
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iAslr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = module.exports.VNodeMeta = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $eb6ss = parcelRequire("eb6ss");

var $ar3s2 = parcelRequire("ar3s2");
var $d881937c916d39ea$var$VNodeMeta = /** @class */ function() {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}();
module.exports.VNodeMeta = $d881937c916d39ea$var$VNodeMeta;
var $d881937c916d39ea$var$VNode = /** @class */ function(_super) {
    $ceFTv.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = $ceFTv.__rest(_b, [
            "children"
        ]);
        _this = _super.call(this) || this;
        _this.children = [];
        Object.assign(_this, meta);
        try {
            for(var _f = $ceFTv.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()){
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, $ceFTv.__spreadArray([], $ceFTv.__read(_a.isFragment(vNode) ? vNode.children || [] : [
                    vNode
                ]), false));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _h = $ceFTv.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()){
                var child = _j.value;
                child.parent = _this;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, '.')),
            is && "[is=\"".concat(is, "\"]")
        ].filter(Boolean).join('');
        return _this;
    }
    VNode.prototype.walkUp = function() {
        var current;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        current
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.namespaceOf = function(tagName) {
        var e_3, _b;
        if ($ar3s2.XMLNamespace[tagName]) return $ar3s2.XMLNamespace[tagName];
        try {
            for(var _c = $ceFTv.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()){
                var namespace = _d.value.namespace;
                if (namespace) return namespace;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $ar3s2.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function(document1) {
        if (document1 === void 0) document1 = globalThis.document;
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return this.node = text ? document1.createTextNode(text) : !tagName ? document1.createDocumentFragment() : document1.createElementNS(this.namespace || (this.namespace = this.namespaceOf(tagName)), tagName, {
            is: is
        });
    };
    VNode.prototype.toJSON = function() {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({
            key: key,
            text: text,
            selector: selector,
            namespace: namespace,
            tagName: tagName,
            is: is,
            props: props,
            style: style,
            children: children
        }));
    };
    VNode.prototype.generateElementXML = function() {
        var _b, tagName, props, style, children, node, body, shadowRoots, innerHTML, restProps, _c, _d, _e, _i, key, _f, _g, _h, _j, key, children_1, children_1_1, child, e_4_1;
        var e_4, _k;
        return $ceFTv.__generator(this, function(_l) {
            switch(_l.label){
                case 0:
                    _b = this, tagName = _b.tagName, props = _b.props, style = _b.style, children = _b.children, node = _b.node;
                    if (!(tagName.includes('-') && (0, $ar3s2.elementTypeOf)(tagName) === 'html')) return [
                        3 /*break*/ ,
                        2
                    ];
                    body = ((node === null || node === void 0 ? void 0 : node.ownerDocument) || document).implementation.createHTMLDocument().body;
                    body.innerHTML = "<".concat(tagName, "></").concat(tagName, ">");
                    shadowRoots = $ceFTv.__spreadArray([], $ceFTv.__read((0, $eb6ss.findShadowRoots)(body)), false);
                    return [
                        4 /*yield*/ ,
                        body.getHTML({
                            serializableShadowRoots: true,
                            shadowRoots: shadowRoots
                        })
                    ];
                case 1:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 2:
                    innerHTML = props.innerHTML, restProps = $ceFTv.__rest(props, [
                        "innerHTML"
                    ]);
                    return [
                        4 /*yield*/ ,
                        "<".concat(tagName)
                    ];
                case 3:
                    _l.sent();
                    _c = restProps;
                    _d = [];
                    for(_e in _c)_d.push(_e);
                    _i = 0;
                    _l.label = 4;
                case 4:
                    if (!(_i < _d.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    _e = _d[_i];
                    if (!(_e in _c)) return [
                        3 /*break*/ ,
                        6
                    ];
                    key = _e;
                    return [
                        4 /*yield*/ ,
                        " ".concat(_a.propsMap[key] || key, "=\"").concat(restProps[key], "\"")
                    ];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    _i++;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 7:
                    if (!style) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        " style=\""
                    ];
                case 8:
                    _l.sent();
                    _f = style;
                    _g = [];
                    for(_h in _f)_g.push(_h);
                    _j = 0;
                    _l.label = 9;
                case 9:
                    if (!(_j < _g.length)) return [
                        3 /*break*/ ,
                        12
                    ];
                    _h = _g[_j];
                    if (!(_h in _f)) return [
                        3 /*break*/ ,
                        11
                    ];
                    key = _h;
                    return [
                        4 /*yield*/ ,
                        "".concat((0, $ar3s2.toHyphenCase)(key), ":").concat(style[key], ";")
                    ];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    _j++;
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 12:
                    return [
                        4 /*yield*/ ,
                        "\""
                    ];
                case 13:
                    _l.sent();
                    _l.label = 14;
                case 14:
                    if (!innerHTML) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        ">".concat(innerHTML, "</").concat(tagName, ">")
                    ];
                case 15:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 16:
                    if (!children[0]) return [
                        3 /*break*/ ,
                        27
                    ];
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 17:
                    _l.sent();
                    _l.label = 18;
                case 18:
                    _l.trys.push([
                        18,
                        23,
                        24,
                        25
                    ]);
                    children_1 = $ceFTv.__values(children), children_1_1 = children_1.next();
                    _l.label = 19;
                case 19:
                    if (!!children_1_1.done) return [
                        3 /*break*/ ,
                        22
                    ];
                    child = children_1_1.value;
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(child.generateXML())
                    ];
                case 20:
                    _l.sent();
                    _l.label = 21;
                case 21:
                    children_1_1 = children_1.next();
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 22:
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 23:
                    e_4_1 = _l.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 24:
                    try {
                        if (children_1_1 && !children_1_1.done && (_k = children_1.return)) _k.call(children_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 25:
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 26:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 27:
                    return [
                        4 /*yield*/ ,
                        tagName === 'script' ? '></script>' : ' />'
                    ];
                case 28:
                    _l.sent();
                    _l.label = 29;
                case 29:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.generateXML = function() {
        var mode;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!_a.isFragment(this)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        '<template'
                    ];
                case 1:
                    _b.sent();
                    mode = (this.node || {}).mode;
                    if (!mode) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        " shadowrootmode=\"".concat(mode, "\"")
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 4:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 5:
                    if (!(this.text != null)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        this.text
                    ];
                case 6:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(this.generateElementXML())
                    ];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $ceFTv.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $ar3s2.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute('is')
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== 'style' && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: 'class',
        htmlFor: 'for'
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}($d881937c916d39ea$var$VNodeMeta);
module.exports.VNode = $d881937c916d39ea$var$VNode;

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $8e874a2fb001c377$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $8e874a2fb001c377$export$3c9a16f847548506);
$parcel$export(module.exports, "__decorate", () => $8e874a2fb001c377$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $8e874a2fb001c377$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $8e874a2fb001c377$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("eb6ss", function(module, exports) {
var $a5271a2f1944ab8a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a5271a2f1944ab8a$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a5271a2f1944ab8a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a5271a2f1944ab8a$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $a5271a2f1944ab8a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $a5271a2f1944ab8a$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $a5271a2f1944ab8a$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $a5271a2f1944ab8a$var$__spreadArray([], $a5271a2f1944ab8a$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=").concat(JSON.parse(value));
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($a5271a2f1944ab8a$var$__spreadArray([
                            tagName
                        ], $a5271a2f1944ab8a$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $a5271a2f1944ab8a$var$__spreadArray([], $a5271a2f1944ab8a$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        "<template shadowrootmode=\"".concat(shadowRoot.mode, "\">").concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $a5271a2f1944ab8a$var$__spreadArray([], $a5271a2f1944ab8a$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $a5271a2f1944ab8a$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});

parcelRegister("ar3s2", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $01f5ebc7a5ca076d$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $01f5ebc7a5ca076d$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $01f5ebc7a5ca076d$export$86f54f62aa7a7514);
$parcel$export(module.exports, "DiffStatus", () => $01f5ebc7a5ca076d$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $01f5ebc7a5ca076d$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $01f5ebc7a5ca076d$export$3f063810d7bf01bd);
$parcel$export(module.exports, "splitArray", () => $01f5ebc7a5ca076d$export$697c3df919c0e61a);
$parcel$export(module.exports, "countBy", () => $01f5ebc7a5ca076d$export$1d012a0dff3dab06);
$parcel$export(module.exports, "parseJSON", () => $01f5ebc7a5ca076d$export$27924e57e9afff7f);
$parcel$export(module.exports, "XMLNamespace", () => $01f5ebc7a5ca076d$export$f5a4056b78c72efa);
$parcel$export(module.exports, "templateOf", () => $01f5ebc7a5ca076d$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $01f5ebc7a5ca076d$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $01f5ebc7a5ca076d$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $01f5ebc7a5ca076d$export$b8a1af58c024fefd);
$parcel$export(module.exports, "importCSS", () => $01f5ebc7a5ca076d$export$7cd14c57bbb84350);
$parcel$export(module.exports, "delegate", () => $01f5ebc7a5ca076d$export$10b1921597150314);
function $01f5ebc7a5ca076d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $01f5ebc7a5ca076d$export$61cc6ed0f143570b;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $01f5ebc7a5ca076d$export$dd1bc94b04021eeb;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $01f5ebc7a5ca076d$export$a09f818797e212c4;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $01f5ebc7a5ca076d$export$170f4e08cad8229d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $01f5ebc7a5ca076d$export$2a489b3f92f4996a;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $01f5ebc7a5ca076d$export$67a6ce548ae77071;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $01f5ebc7a5ca076d$export$a48f0734ac7c2329;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $01f5ebc7a5ca076d$export$3f34ca2fef821bbd;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $01f5ebc7a5ca076d$export$86f54f62aa7a7514;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $01f5ebc7a5ca076d$export$89912e019eef22aa;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $01f5ebc7a5ca076d$export$1c8ba402144543e5;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $01f5ebc7a5ca076d$export$2ddabb89308e1a22;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $01f5ebc7a5ca076d$export$14527669107aa301;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $01f5ebc7a5ca076d$export$3f063810d7bf01bd;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $01f5ebc7a5ca076d$export$b5a4d6f439a5044d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $01f5ebc7a5ca076d$export$b119cc7e1840e59c;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $01f5ebc7a5ca076d$export$7b85fd78dd236198;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $01f5ebc7a5ca076d$export$697c3df919c0e61a;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $01f5ebc7a5ca076d$export$e6b5ff3168b5942b;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $01f5ebc7a5ca076d$export$1d012a0dff3dab06;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $01f5ebc7a5ca076d$export$69a3209f1a06c04d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $01f5ebc7a5ca076d$export$86c18c6347f4a8c4;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $01f5ebc7a5ca076d$export$dce9414bed0662c;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $01f5ebc7a5ca076d$export$271f7c16f175f804;
});
var $01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "sum", function() {
    return $01f5ebc7a5ca076d$export$8a63f25cc62965f1;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $01f5ebc7a5ca076d$export$e1f36757ecda301d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $01f5ebc7a5ca076d$export$8e694e1eafd55acb;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $01f5ebc7a5ca076d$export$57d7c52a66287430;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $01f5ebc7a5ca076d$export$2b4693832ca3ce16;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $01f5ebc7a5ca076d$export$5b784e078da1ce6;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $01f5ebc7a5ca076d$export$17ec9c9f4f23588c;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $01f5ebc7a5ca076d$export$595dbf49c602a1f;
});
function $01f5ebc7a5ca076d$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $01f5ebc7a5ca076d$export$e1f36757ecda301d(...data) {
    return $01f5ebc7a5ca076d$export$8a63f25cc62965f1(...data) / data.length;
}
function $01f5ebc7a5ca076d$export$8e694e1eafd55acb(data, sample = false) {
    const average = $01f5ebc7a5ca076d$export$e1f36757ecda301d(...data);
    const summary = $01f5ebc7a5ca076d$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $01f5ebc7a5ca076d$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($01f5ebc7a5ca076d$export$8e694e1eafd55acb(data, sample));
}
function $01f5ebc7a5ca076d$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($01f5ebc7a5ca076d$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $01f5ebc7a5ca076d$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $01f5ebc7a5ca076d$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $01f5ebc7a5ca076d$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $01f5ebc7a5ca076d$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
function $01f5ebc7a5ca076d$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $01f5ebc7a5ca076d$export$dd1bc94b04021eeb(value) {
    return $01f5ebc7a5ca076d$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $01f5ebc7a5ca076d$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $01f5ebc7a5ca076d$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $01f5ebc7a5ca076d$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $01f5ebc7a5ca076d$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $01f5ebc7a5ca076d$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $01f5ebc7a5ca076d$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $01f5ebc7a5ca076d$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $01f5ebc7a5ca076d$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $01f5ebc7a5ca076d$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $01f5ebc7a5ca076d$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($01f5ebc7a5ca076d$export$2ddabb89308e1a22 || ($01f5ebc7a5ca076d$export$2ddabb89308e1a22 = {}));
function $01f5ebc7a5ca076d$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $01f5ebc7a5ca076d$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $01f5ebc7a5ca076d$export$b5a4d6f439a5044d(data) {
    if ($01f5ebc7a5ca076d$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $01f5ebc7a5ca076d$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $01f5ebc7a5ca076d$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($01f5ebc7a5ca076d$export$61cc6ed0f143570b(data)) return [];
    if ($01f5ebc7a5ca076d$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $01f5ebc7a5ca076d$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $01f5ebc7a5ca076d$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $01f5ebc7a5ca076d$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $01f5ebc7a5ca076d$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $01f5ebc7a5ca076d$export$1d012a0dff3dab06(list, iteratee) {
    const group = $01f5ebc7a5ca076d$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $01f5ebc7a5ca076d$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $01f5ebc7a5ca076d$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $01f5ebc7a5ca076d$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $01f5ebc7a5ca076d$export$271f7c16f175f804 extends $01f5ebc7a5ca076d$export$595dbf49c602a1f {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}
var $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $01f5ebc7a5ca076d$export$c489aa6f7fd82b1a;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $01f5ebc7a5ca076d$export$cbd942915f33be50;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $01f5ebc7a5ca076d$export$9b886f8493244014;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $01f5ebc7a5ca076d$export$e99cbb807a5bb10d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $01f5ebc7a5ca076d$export$7a9a31a911eb9a20;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $01f5ebc7a5ca076d$export$fca4f8121099df57;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $01f5ebc7a5ca076d$export$6ce2f08d515512;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $01f5ebc7a5ca076d$export$951c8378cdfec6e6;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $01f5ebc7a5ca076d$export$1a4097b876a13bf7;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $01f5ebc7a5ca076d$export$d9bcbd5e1ff81430;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $01f5ebc7a5ca076d$export$506c8e8f8c8edda;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $01f5ebc7a5ca076d$export$3ae94a2503e890a1;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $01f5ebc7a5ca076d$export$62ad822b3a5fd9a0;
});
const $01f5ebc7a5ca076d$export$c489aa6f7fd82b1a = 1000;
const $01f5ebc7a5ca076d$export$cbd942915f33be50 = $01f5ebc7a5ca076d$export$c489aa6f7fd82b1a * 60;
const $01f5ebc7a5ca076d$export$9b886f8493244014 = $01f5ebc7a5ca076d$export$cbd942915f33be50 * 15;
const $01f5ebc7a5ca076d$export$e99cbb807a5bb10d = $01f5ebc7a5ca076d$export$9b886f8493244014 * 4;
const $01f5ebc7a5ca076d$export$7a9a31a911eb9a20 = $01f5ebc7a5ca076d$export$e99cbb807a5bb10d * 24;
const $01f5ebc7a5ca076d$export$fca4f8121099df57 = $01f5ebc7a5ca076d$export$7a9a31a911eb9a20 * 7;
const $01f5ebc7a5ca076d$export$6ce2f08d515512 = $01f5ebc7a5ca076d$export$7a9a31a911eb9a20 * 365;
const $01f5ebc7a5ca076d$export$951c8378cdfec6e6 = $01f5ebc7a5ca076d$export$6ce2f08d515512 / 12;
const $01f5ebc7a5ca076d$export$1a4097b876a13bf7 = $01f5ebc7a5ca076d$export$951c8378cdfec6e6 * 3;
class $01f5ebc7a5ca076d$export$d9bcbd5e1ff81430 extends $01f5ebc7a5ca076d$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $01f5ebc7a5ca076d$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $01f5ebc7a5ca076d$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $01f5ebc7a5ca076d$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $01f5ebc7a5ca076d$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $01f5ebc7a5ca076d$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $01f5ebc7a5ca076d$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $01f5ebc7a5ca076d$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $01f5ebc7a5ca076d$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $01f5ebc7a5ca076d$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $01f5ebc7a5ca076d$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $01f5ebc7a5ca076d$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $01f5ebc7a5ca076d$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $01f5ebc7a5ca076d$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $01f5ebc7a5ca076d$export$27924e57e9afff7f;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $01f5ebc7a5ca076d$export$7ea17d45ecdcf634;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $01f5ebc7a5ca076d$export$bb8626e4916f587b;
});
function $01f5ebc7a5ca076d$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $01f5ebc7a5ca076d$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $01f5ebc7a5ca076d$export$7ea17d45ecdcf634(raw) {
    const parsed = $01f5ebc7a5ca076d$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $01f5ebc7a5ca076d$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $01f5ebc7a5ca076d$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($01f5ebc7a5ca076d$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $01f5ebc7a5ca076d$export$71e6483fc2b024eb;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $01f5ebc7a5ca076d$export$eb9b2aadbe449a20;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $01f5ebc7a5ca076d$export$13397a83aa5915d6;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $01f5ebc7a5ca076d$export$fd89523fba250fa4;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $01f5ebc7a5ca076d$export$504fbde693c1771c;
});
function $01f5ebc7a5ca076d$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $01f5ebc7a5ca076d$export$eb9b2aadbe449a20(raw = globalThis.location?.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($01f5ebc7a5ca076d$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $01f5ebc7a5ca076d$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $01f5ebc7a5ca076d$export$b5a4d6f439a5044d(value) ? $01f5ebc7a5ca076d$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $01f5ebc7a5ca076d$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$01f5ebc7a5ca076d$export$dd1bc94b04021eeb(value) && [
            key,
            $01f5ebc7a5ca076d$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $01f5ebc7a5ca076d$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $01f5ebc7a5ca076d$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $01f5ebc7a5ca076d$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $01f5ebc7a5ca076d$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $01f5ebc7a5ca076d$var$$50872bf213056663$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $01f5ebc7a5ca076d$export$1b9ac4d3de3ffd2e;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$50872bf213056663$exports, "makeSHA", function() {
    return $01f5ebc7a5ca076d$export$d51f3b55e8d1aa73;
});
const $01f5ebc7a5ca076d$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $01f5ebc7a5ca076d$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $01f5ebc7a5ca076d$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $01f5ebc7a5ca076d$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $01f5ebc7a5ca076d$var$$93a3089d2937b23f$exports = {};
var $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $01f5ebc7a5ca076d$export$f5a4056b78c72efa;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $01f5ebc7a5ca076d$export$2ee022bbbc550b25;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $01f5ebc7a5ca076d$export$a549dd5cef7f8327;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $01f5ebc7a5ca076d$export$8eece510bcb9c62c;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $01f5ebc7a5ca076d$export$b8a1af58c024fefd;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $01f5ebc7a5ca076d$export$a2cf0d4bb6e06de4;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $01f5ebc7a5ca076d$export$d66b332881d9723f;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $01f5ebc7a5ca076d$export$b0709844452f8b6b;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $01f5ebc7a5ca076d$export$5118471ee5d5453b;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $01f5ebc7a5ca076d$export$be4650432daa84fd;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $01f5ebc7a5ca076d$export$578e38b4a3e0b255;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $01f5ebc7a5ca076d$export$7cd14c57bbb84350;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $01f5ebc7a5ca076d$export$5100419dfae0456d;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $01f5ebc7a5ca076d$export$28d9d24a8cd0ffc2;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $01f5ebc7a5ca076d$export$3f99968195accfaf;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $01f5ebc7a5ca076d$export$eafdbaa868ea9975;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $01f5ebc7a5ca076d$export$36a0c1ca2ae264fa;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $01f5ebc7a5ca076d$export$86d7c59254d6a2c9;
});
const $01f5ebc7a5ca076d$export$f5a4056b78c72efa = {
    html: "http://www.w3.org/1999/xhtml",
    svg: "http://www.w3.org/2000/svg",
    math: "http://www.w3.org/1998/Math/MathML"
};
const $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$templateMap = {};
function $01f5ebc7a5ca076d$export$2ee022bbbc550b25(tagName) {
    if ($01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $01f5ebc7a5ca076d$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes("-")) return "html";
    const [prefix, localName] = tagName.split(":");
    if (localName) return prefix === "html" ? "html" : "xml";
    const node = $01f5ebc7a5ca076d$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $01f5ebc7a5ca076d$export$8eece510bcb9c62c(Class) {
    return $01f5ebc7a5ca076d$export$170f4e08cad8229d(Class, HTMLElement);
}
const $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $01f5ebc7a5ca076d$export$b8a1af58c024fefd(Class) {
    const name = $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $01f5ebc7a5ca076d$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $01f5ebc7a5ca076d$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $01f5ebc7a5ca076d$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $01f5ebc7a5ca076d$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $01f5ebc7a5ca076d$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $01f5ebc7a5ca076d$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($01f5ebc7a5ca076d$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $01f5ebc7a5ca076d$export$5118471ee5d5453b(node, type);
}
function $01f5ebc7a5ca076d$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $01f5ebc7a5ca076d$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $01f5ebc7a5ca076d$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $01f5ebc7a5ca076d$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $01f5ebc7a5ca076d$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$01f5ebc7a5ca076d$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$01f5ebc7a5ca076d$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $01f5ebc7a5ca076d$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $01f5ebc7a5ca076d$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $01f5ebc7a5ca076d$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $01f5ebc7a5ca076d$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $01f5ebc7a5ca076d$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $01f5ebc7a5ca076d$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $01f5ebc7a5ca076d$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$01f5ebc7a5ca076d$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $01f5ebc7a5ca076d$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $01f5ebc7a5ca076d$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$01f5ebc7a5ca076d$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $01f5ebc7a5ca076d$var$$bb23e0c794fefbef$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $01f5ebc7a5ca076d$export$e772c8ff12451969;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $01f5ebc7a5ca076d$export$57207d71b8c929c8;
});
function $01f5ebc7a5ca076d$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $01f5ebc7a5ca076d$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $01f5ebc7a5ca076d$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $01f5ebc7a5ca076d$export$10b1921597150314;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $01f5ebc7a5ca076d$export$3e2b244719956741;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $01f5ebc7a5ca076d$export$1d1d2ed6b55cf67f;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $01f5ebc7a5ca076d$export$2155c0b5a4b77fb8;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $01f5ebc7a5ca076d$export$9d97473344489dfc;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $01f5ebc7a5ca076d$export$d635d04af3887bbe;
});
function $01f5ebc7a5ca076d$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $01f5ebc7a5ca076d$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $01f5ebc7a5ca076d$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $01f5ebc7a5ca076d$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $01f5ebc7a5ca076d$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $01f5ebc7a5ca076d$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $01f5ebc7a5ca076d$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $01f5ebc7a5ca076d$export$1b88f6b6d432a52a;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $01f5ebc7a5ca076d$export$b70f6380221b1350;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $01f5ebc7a5ca076d$export$75d6cbe4503e149;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $01f5ebc7a5ca076d$export$b2618d51188815c2;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $01f5ebc7a5ca076d$export$490814474ddbb428;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $01f5ebc7a5ca076d$export$3ea201dffb50dfef;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $01f5ebc7a5ca076d$export$d1012c7198c6b460;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $01f5ebc7a5ca076d$export$a35a418b7b17958e;
});
class $01f5ebc7a5ca076d$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $01f5ebc7a5ca076d$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $01f5ebc7a5ca076d$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $01f5ebc7a5ca076d$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $01f5ebc7a5ca076d$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $01f5ebc7a5ca076d$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $01f5ebc7a5ca076d$export$75d6cbe4503e149(type, element)))
    ]);
}
function $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $01f5ebc7a5ca076d$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $01f5ebc7a5ca076d$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $01f5ebc7a5ca076d$export$490814474ddbb428(element, className, display = "block") {
    return $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $01f5ebc7a5ca076d$export$3ea201dffb50dfef(element, className, display = "block") {
    return $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $01f5ebc7a5ca076d$export$d1012c7198c6b460(element, className, remove) {
    return $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $01f5ebc7a5ca076d$export$a35a418b7b17958e(element, className, remove) {
    return $01f5ebc7a5ca076d$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $01f5ebc7a5ca076d$var$$69bd9f0117925302$exports = {};
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$69bd9f0117925302$exports, "describe", function() {
    return $01f5ebc7a5ca076d$export$cd5450f3a47e3789;
});
$01f5ebc7a5ca076d$var$$parcel$export($01f5ebc7a5ca076d$var$$69bd9f0117925302$exports, "it", function() {
    return $01f5ebc7a5ca076d$export$3486a10f30cf1ee4;
});
async function $01f5ebc7a5ca076d$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $01f5ebc7a5ca076d$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $01f5ebc7a5ca076d$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("fP3qc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $ceFTv = parcelRequire("ceFTv");
parcelRequire("8BuuC");

var $i3JFt = parcelRequire("i3JFt");

var $ar3s2 = parcelRequire("ar3s2");

var $iAslr = parcelRequire("iAslr");
var $b84e45dd1dd5e491$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.signalCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || '') + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith('aria-') ? (0, $ar3s2.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
        this.attrsNameOf = function(key) {
            return $iAslr.VNode.propsMap[key] || key;
        };
        this.removeProperty = function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $ar3s2.toHyphenCase)(key) : _this.attrsNameOf(key));
        };
        this.setProperty = function(node, key, value) {
            var isXML = (0, $ar3s2.templateOf)(node.tagName) && (0, $ar3s2.elementTypeOf)(node.tagName) === 'xml';
            if (isXML || key.includes('-')) node.setAttribute(_this.attrsNameOf(key), value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(_this.attrsNameOf(key), value);
            }
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $ar3s2.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $ceFTv.__values(group[$ar3s2.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $ceFTv.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $ceFTv.__values($ceFTv.__spreadArray($ceFTv.__spreadArray([], $ceFTv.__read(group[$ar3s2.DiffStatus.Same] || []), false), $ceFTv.__read(group[$ar3s2.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $ceFTv.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChild = function(root, node, index) {
        if (index === void 0) index = 0;
        var targetNode = root.childNodes[index];
        if (targetNode === node) return;
        if (!targetNode) root.append(node);
        else targetNode.before(node);
    };
    DOMRenderer.prototype.diffVChildren = function(oldVNode, newVNode) {
        var _a, map, group, deletingGroup, _b, _c, _d, index, newVChild, key, oldVChild, e_3_1, _e, _f, _g, _i, selector, _h, _j, oldVNode_1, e_4_1;
        var e_3, _k, e_4, _l;
        var _this = this;
        var _m;
        return $ceFTv.__generator(this, function(_o) {
            switch(_o.label){
                case 0:
                    newVNode.children = newVNode.children.map(function(vNode) {
                        return new $iAslr.VNode(vNode);
                    });
                    _a = (0, $ar3s2.diffKeys)(oldVNode.children.map(this.keyOf), newVNode.children.map(this.keyOf)), map = _a.map, group = _a.group;
                    deletingGroup = group[$ar3s2.DiffStatus.Old] && (0, $ar3s2.groupBy)(group[$ar3s2.DiffStatus.Old].map(function(_a) {
                        var _b = $ceFTv.__read(_a, 1), key = _b[0];
                        return _this.vNodeOf(oldVNode.children, key);
                    }), function(_a) {
                        var selector = _a.selector;
                        return selector + '';
                    });
                    _o.label = 1;
                case 1:
                    _o.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _b = $ceFTv.__values(newVNode.children.entries()), _c = _b.next();
                    _o.label = 2;
                case 2:
                    if (!!_c.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _d = $ceFTv.__read(_c.value, 2), index = _d[0], newVChild = _d[1];
                    key = this.keyOf(newVChild, index);
                    oldVChild = map[key] === $ar3s2.DiffStatus.Same ? this.vNodeOf(oldVNode.children, key) : (_m = deletingGroup === null || deletingGroup === void 0 ? void 0 : deletingGroup[newVChild.selector]) === null || _m === void 0 ? void 0 : _m.shift();
                    return [
                        4 /*yield*/ ,
                        {
                            index: index,
                            oldVNode: oldVChild,
                            newVNode: newVChild
                        }
                    ];
                case 3:
                    _o.sent();
                    if (!((oldVChild === null || oldVChild === void 0 ? void 0 : oldVChild.children[0]) || newVChild.children[0])) return [
                        3 /*break*/ ,
                        5
                    ];
                    oldVChild || (oldVChild = new $iAslr.VNode($ceFTv.__assign($ceFTv.__assign({}, newVChild), {
                        children: []
                    })));
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(this.diffVChildren(oldVChild, newVChild))
                    ];
                case 4:
                    _o.sent();
                    _o.label = 5;
                case 5:
                    _c = _b.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_3_1 = _o.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_c && !_c.done && (_k = _b.return)) _k.call(_b);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    _e = deletingGroup;
                    _f = [];
                    for(_g in _e)_f.push(_g);
                    _i = 0;
                    _o.label = 10;
                case 10:
                    if (!(_i < _f.length)) return [
                        3 /*break*/ ,
                        19
                    ];
                    _g = _f[_i];
                    if (!(_g in _e)) return [
                        3 /*break*/ ,
                        18
                    ];
                    selector = _g;
                    _o.label = 11;
                case 11:
                    _o.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _h = (e_4 = void 0, $ceFTv.__values(deletingGroup[selector])), _j = _h.next();
                    _o.label = 12;
                case 12:
                    if (!!_j.done) return [
                        3 /*break*/ ,
                        15
                    ];
                    oldVNode_1 = _j.value;
                    return [
                        4 /*yield*/ ,
                        {
                            oldVNode: oldVNode_1
                        }
                    ];
                case 13:
                    _o.sent();
                    _o.label = 14;
                case 14:
                    _j = _h.next();
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 15:
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 16:
                    e_4_1 = _o.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 17:
                    try {
                        if (_j && !_j.done && (_l = _h.return)) _l.call(_h);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 18:
                    _i++;
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patchNode = function(oldVNode, newVNode) {
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, this.removeProperty, this.setProperty);
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(style, key) {
            return style.removeProperty((0, $ar3s2.toHyphenCase)(key));
        }, function(style, key, value) {
            return style.setProperty((0, $ar3s2.toHyphenCase)(key), value);
        });
        newVNode.node || (newVNode.node = oldVNode.node);
        return newVNode;
    };
    DOMRenderer.prototype.generateDOM = function(oldVRoot, newVRoot) {
        var _a, _b, _c, index, oldVNode, newVNode, inserting, tagName, node, parent_1, e_5_1;
        var e_5, _d;
        var _e;
        return $ceFTv.__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if ($iAslr.VNode.isFragment(newVRoot)) newVRoot = new $iAslr.VNode($ceFTv.__assign($ceFTv.__assign({}, oldVRoot), {
                        children: newVRoot.children
                    }));
                    return [
                        4 /*yield*/ ,
                        this.patchNode(oldVRoot, newVRoot)
                    ];
                case 1:
                    _f.sent();
                    _f.label = 2;
                case 2:
                    _f.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = $ceFTv.__values(this.diffVChildren(oldVRoot, newVRoot)), _b = _a.next();
                    _f.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = _b.value, index = _c.index, oldVNode = _c.oldVNode, newVNode = _c.newVNode;
                    if (!newVNode) {
                        this.deleteNode(oldVNode);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    }
                    inserting = !oldVNode;
                    if (oldVNode) newVNode.node = oldVNode.node;
                    else {
                        newVNode.createDOM(this.document);
                        tagName = newVNode.tagName, node = newVNode.node, parent_1 = newVNode.parent;
                        oldVNode = new $iAslr.VNode({
                            tagName: tagName,
                            node: node,
                            parent: parent_1
                        });
                    }
                    if (newVNode.text) oldVNode.node.nodeValue = newVNode.text;
                    else if (!$iAslr.VNode.isFragment(newVNode)) this.patchNode(oldVNode, newVNode);
                    if (oldVNode.parent) {
                        this.commitChild(oldVNode.parent.node, newVNode.node, index);
                        if (inserting) (_e = newVNode.ref) === null || _e === void 0 || _e.call(newVNode, newVNode.node);
                    }
                    return [
                        4 /*yield*/ ,
                        newVNode
                    ];
                case 4:
                    _f.sent();
                    _f.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_5_1 = _f.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVRoot, newVRoot) {
        var e_6, _a;
        var count = 0;
        try {
            for(var _b = $ceFTv.__values(this.generateDOM(oldVRoot, newVRoot)), _c = _b.next(); !_c.done; _c = _b.next()){
                var newVNode = _c.value;
                if (++count === 1) newVRoot = newVNode;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return newVRoot;
    };
    DOMRenderer.prototype.patchAsync = function(oldVRoot, newVRoot) {
        return $ceFTv.__awaiter(this, void 0, void 0, function() {
            var oldController, controller, count, _a, _b, newVNode, e_7_1;
            var e_7, _c;
            return $ceFTv.__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        oldController = this.signalCache.get(oldVRoot.node);
                        if (oldController) {
                            oldController.abort();
                            oldVRoot = $iAslr.VNode.fromDOM(oldVRoot.node);
                        }
                        controller = new AbortController();
                        this.signalCache.set(oldVRoot.node, controller);
                        count = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _a = $ceFTv.__values(this.generateDOM(oldVRoot, newVRoot)), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        newVNode = _b.value;
                        if (++count === 1) newVRoot = newVNode;
                        return [
                            4 /*yield*/ ,
                            scheduler.yield()
                        ];
                    case 3:
                        _d.sent();
                        if (controller.signal.aborted) {
                            this.signalCache.delete(oldVRoot.node);
                            controller.signal.throwIfAborted();
                        }
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_7_1 = _d.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_7) throw e_7.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        this.signalCache.delete(oldVRoot.node);
                        return [
                            2 /*return*/ ,
                            newVRoot
                        ];
                }
            });
        });
    };
    DOMRenderer.prototype.render = function(vNode, node, mode) {
        var _this = this;
        var _a;
        if (node === void 0) node = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.body;
        if (mode === void 0) mode = 'sync';
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || $iAslr.VNode.fromDOM(node);
        var done = function(root) {
            return _this.treeCache.set(node, root) && root;
        };
        return mode === 'sync' ? done(this.patch(root, new $iAslr.VNode($ceFTv.__assign($ceFTv.__assign({}, root), {
            children: [
                vNode
            ]
        })))) : this.patchAsync(root, new $iAslr.VNode($ceFTv.__assign($ceFTv.__assign({}, root), {
            children: [
                vNode
            ]
        }))).then(done);
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        return $ceFTv.__spreadArray([], $ceFTv.__read(tree.generateXML()), false).join('');
    };
    DOMRenderer.prototype.renderToReadableStream = function(tree) {
        return $i3JFt.ReadableStream.from(tree.generateXML());
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $b84e45dd1dd5e491$var$DOMRenderer;

});
parcelRegister("8BuuC", function(module, exports) {
!function() {
    var t = [
        "user-blocking",
        "user-visible",
        "background"
    ];
    class i {
        constructor(){
            this.t = new MessageChannel, this.i = this.t.port2, this.l = {}, this.o = 1, this.t.port1.onmessage = (t)=>this.h(t);
        }
        u(t) {
            var i = this.o++;
            return this.l[i] = t, this.i.postMessage(i), i;
        }
        p(t) {
            delete this.l[t];
        }
        h(t) {
            var i = t.data;
            if (i in this.l) {
                var r = this.l[i];
                delete this.l[i], r();
            }
        }
    }
    function r() {
        return r.v || (r.v = new i), r.v;
    }
    class s {
        constructor(t, i, r){
            void 0 === r && (r = 0), this.k = t, this.T = null, this.C = null, this.m = !1, this._(i, r);
        }
        isIdleCallback() {
            return 0 === this.T;
        }
        I() {
            return 2 === this.T;
        }
        cancel() {
            if (!this.m) switch(this.m = !0, this.T){
                case 0:
                    cancelIdleCallback(this.C);
                    break;
                case 1:
                    clearTimeout(this.C);
                    break;
                case 2:
                    r().p(this.C);
                    break;
                default:
                    throw new TypeError("Unknown CallbackType");
            }
        }
        _(i, s) {
            if (s && s > 0) return this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            }, s));
            if (!t.includes(i)) throw new TypeError("Invalid task priority : " + i);
            return "background" === i && "function" == typeof requestIdleCallback ? (this.T = 0, void (this.C = requestIdleCallback(()=>{
                this.P();
            }))) : "function" == typeof MessageChannel ? (this.T = 2, void (this.C = r().u(()=>{
                this.P();
            }))) : (this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            })));
        }
        P() {
            this.m || this.k();
        }
    }
    var e = 0;
    class n {
        constructor(){
            this.j = null, this.M = null;
        }
        isEmpty() {
            return null == this.j;
        }
        push(t) {
            if ("object" != typeof t) throw new TypeError("Task must be an Object");
            t.A = e++, this.isEmpty() ? (t.N = null, this.j = t) : (t.N = this.M, this.M.O = t), t.O = null, this.M = t;
        }
        takeNextTask() {
            if (this.isEmpty()) return null;
            var t = this.j;
            return this.q(t), t;
        }
        merge(t, i) {
            if ("function" != typeof i) throw new TypeError("Must provide a selector function.");
            if (null == t) throw new Error("sourceQueue cannot be null");
            for(var r = this.j, s = null, e = t.j; e;){
                var n = e;
                if (e = e.O, i(n)) {
                    for(t.q(n); r && r.A < n.A;)s = r, r = r.O;
                    this.D(n, s), s = n;
                }
            }
        }
        D(t, i) {
            if (i != this.M) {
                var r = i ? i.O : this.j;
                t.O = r, r.N = t, t.N = i, null != i ? i.O = t : this.j = t;
            } else this.push(t);
        }
        q(t) {
            if (null == t) throw new Error("Expected task to be non-null");
            t === this.j && (this.j = t.O), t === this.M && (this.M = this.M.N), t.O && (t.O.N = t.N), t.N && (t.N.O = t.O);
        }
    }
    class l extends Event {
        constructor(i, r){
            if (!r || !t.includes(r.previousPriority)) throw new TypeError("Invalid task priority: '" + r.previousPriority + "'");
            super(i), this.previousPriority = r.previousPriority;
        }
    }
    class o extends AbortController {
        constructor(i){
            if (void 0 === i && (i = {}), super(), null == i && (i = {}), "object" != typeof i) throw new TypeError("'init' is not an object");
            var r, s, e = void 0 === i.priority ? "user-visible" : i.priority;
            if (!t.includes(e)) throw new TypeError("Invalid task priority: '" + e + "'");
            this.H = e, this.R = !1, s = (r = this).signal, Object.defineProperties(s, {
                priority: {
                    get: function() {
                        return r.H;
                    },
                    enumerable: !0
                },
                onprioritychange: {
                    value: null,
                    writable: !0,
                    enumerable: !0
                }
            }), s.addEventListener("prioritychange", (t)=>{
                s.onprioritychange && s.onprioritychange(t);
            });
        }
        setPriority(i) {
            if (!t.includes(i)) throw new TypeError("Invalid task priority: " + i);
            if (this.R) throw new DOMException("", "NotAllowedError");
            if (this.signal.priority !== i) {
                this.R = !0;
                var r = this.H;
                this.H = i;
                var s = new l("prioritychange", {
                    previousPriority: r
                });
                this.signal.dispatchEvent(s), this.R = !1;
            }
        }
    }
    void 0 === self.scheduler ? (self.scheduler = new class {
        constructor(){
            this.S = {}, t.forEach((t)=>{
                this.S[t] = [
                    new n,
                    new n
                ];
            }), this.U = null, this.W = new WeakMap;
        }
        yield() {
            return this.B(()=>{}, {
                priority: "user-visible"
            }, !0);
        }
        postTask(t, i) {
            return this.B(t, i, !1);
        }
        B(i, r, s) {
            if (void 0 !== (r = Object.assign({}, r)).signal) {
                if (null === r.signal || !("aborted" in r.signal) || "function" != typeof r.signal.addEventListener) return Promise.reject(new TypeError("'signal' is not a valid 'AbortSignal'"));
                if (r.signal && r.signal.priority && !t.includes(r.signal.priority)) return Promise.reject(new TypeError("Invalid task priority: '" + r.signal.priority + "'"));
            }
            if (void 0 !== r.priority && (null === r.priority || !t.includes(r.priority))) return Promise.reject(new TypeError("Invalid task priority: '" + r.priority + "'"));
            if (void 0 === r.delay && (r.delay = 0), r.delay = Number(r.delay), r.delay < 0) return Promise.reject(new TypeError("'delay' must be a positive number."));
            var e = {
                callback: i,
                options: r,
                resolve: null,
                reject: null,
                hostCallback: null,
                abortCallback: null,
                onTaskCompleted: function() {
                    this.options.signal && this.abortCallback && (this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null);
                },
                onTaskAborted: function() {
                    this.hostCallback && (this.hostCallback.cancel(), this.hostCallback = null), this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null, this.reject(this.options.signal.reason);
                },
                isAborted: function() {
                    return this.options.signal && this.options.signal.aborted;
                },
                isContinuation: s
            }, n = new Promise((t, i)=>{
                e.resolve = t, e.reject = i;
            });
            return this._(e), n;
        }
        _(t) {
            var i = t.options.signal;
            if (i) {
                if (i.aborted) return void t.reject(i.reason);
                t.abortCallback = ()=>{
                    t.onTaskAborted();
                }, i.addEventListener("abort", t.abortCallback);
            }
            t.options.delay > 0 ? t.hostCallback = new s(()=>{
                t.hostCallback = null, this.F(t);
            }, null, t.options.delay) : (this.G(t), this.J());
        }
        F(t) {
            this.G(t), this.U && (this.U.cancel(), this.U = null), this.K();
        }
        L(t) {
            var i = this.W.get(t);
            if (void 0 === i) throw new Error("Attempting to change priority on an unregistered signal");
            if (i !== t.priority) {
                for(var r = 0; r < 2; r++)this.S[t.priority][r].merge(this.S[i][r], (i)=>i.options.signal === t);
                this.W.set(t, t.priority);
            }
        }
        K() {
            this.U = null, this.V(), this.J();
        }
        J() {
            var { priority: t } = this.X();
            null != t && ("background" !== t && this.U && this.U.isIdleCallback() && (this.U.cancel(), this.U = null), this.U || (this.U = new s(()=>{
                this.K();
            }, t, 0)));
        }
        G(i) {
            var r;
            if (!t.includes(r = i.options.priority ? i.options.priority : i.options.signal && i.options.signal.priority ? i.options.signal.priority : "user-visible")) throw new TypeError("Invalid task priority: " + r);
            if (i.options.signal && i.options.signal.priority) {
                var s = i.options.signal;
                this.W.has(s) || (s.addEventListener("prioritychange", ()=>{
                    this.L(s);
                }), this.W.set(s, s.priority));
            }
            this.S[r][i.isContinuation ? 0 : 1].push(i);
        }
        V() {
            var t = null;
            do {
                var { priority: i, type: r } = this.X();
                if (null == i) return;
                t = this.S[i][r].takeNextTask();
            }while (t.isAborted());
            try {
                var s = t.callback();
                t.resolve(s);
            } catch (i) {
                t.reject(i);
            } finally{
                t.onTaskCompleted();
            }
        }
        X() {
            for(var i = 0; i < t.length; i++)for(var r = t[i], s = 0; s < 2; s++)if (!this.S[r][s].isEmpty()) return {
                priority: r,
                type: s
            };
            return {
                priority: null,
                type: 0
            };
        }
    }, self.TaskController = o, self.TaskPriorityChangeEvent = l) : self.scheduler.yield || (self.scheduler.yield = function() {
        return self.scheduler.postTask(()=>{}, {
            priority: "user-blocking"
        });
    });
}();

});

parcelRegister("i3JFt", function(module, exports) {

$parcel$export(module.exports, "ReadableStream", () => $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76);
/**
 * @license
 * web-streams-polyfill v4.0.0
 * Copyright 2024 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $33f07bbd4ddcb7b3$var$e() {}
function $33f07bbd4ddcb7b3$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $33f07bbd4ddcb7b3$var$r = $33f07bbd4ddcb7b3$var$e;
function $33f07bbd4ddcb7b3$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $33f07bbd4ddcb7b3$var$n = Promise, $33f07bbd4ddcb7b3$var$a = Promise.resolve.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$i = Promise.prototype.then, $33f07bbd4ddcb7b3$var$l = Promise.reject.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$s = $33f07bbd4ddcb7b3$var$a;
function $33f07bbd4ddcb7b3$var$u(e) {
    return new $33f07bbd4ddcb7b3$var$n(e);
}
function $33f07bbd4ddcb7b3$var$c(e) {
    return $33f07bbd4ddcb7b3$var$u((t)=>t(e));
}
function $33f07bbd4ddcb7b3$var$d(e) {
    return $33f07bbd4ddcb7b3$var$l(e);
}
function $33f07bbd4ddcb7b3$var$f(e, t, r) {
    return $33f07bbd4ddcb7b3$var$i.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$b(e, t, o) {
    $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$f(e, t, o), void 0, $33f07bbd4ddcb7b3$var$r);
}
function $33f07bbd4ddcb7b3$var$h(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, t);
}
function $33f07bbd4ddcb7b3$var$m(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, void 0, t);
}
function $33f07bbd4ddcb7b3$var$_(e, t, r) {
    return $33f07bbd4ddcb7b3$var$f(e, t, r);
}
function $33f07bbd4ddcb7b3$var$p(e) {
    $33f07bbd4ddcb7b3$var$f(e, void 0, $33f07bbd4ddcb7b3$var$r);
}
let $33f07bbd4ddcb7b3$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $33f07bbd4ddcb7b3$var$y = queueMicrotask;
    else {
        const e = $33f07bbd4ddcb7b3$var$c(void 0);
        $33f07bbd4ddcb7b3$var$y = (t)=>$33f07bbd4ddcb7b3$var$f(e, t);
    }
    return $33f07bbd4ddcb7b3$var$y(e);
};
function $33f07bbd4ddcb7b3$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$g(e, t, r) {
    try {
        return $33f07bbd4ddcb7b3$var$c($33f07bbd4ddcb7b3$var$S(e, t, r));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
class $33f07bbd4ddcb7b3$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, a = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $33f07bbd4ddcb7b3$var$w = Symbol("[[AbortSteps]]"), $33f07bbd4ddcb7b3$var$R = Symbol("[[ErrorSteps]]"), $33f07bbd4ddcb7b3$var$T = Symbol("[[CancelSteps]]"), $33f07bbd4ddcb7b3$var$C = Symbol("[[PullSteps]]"), $33f07bbd4ddcb7b3$var$P = Symbol("[[ReleaseSteps]]");
function $33f07bbd4ddcb7b3$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $33f07bbd4ddcb7b3$var$B(e) : "closed" === t._state ? function(e) {
        $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$A(e);
    }(e) : $33f07bbd4ddcb7b3$var$k(e, t._storedError);
}
function $33f07bbd4ddcb7b3$var$E(e, t) {
    return $33f07bbd4ddcb7b3$var$Or(e._ownerReadableStream, t);
}
function $33f07bbd4ddcb7b3$var$W(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $33f07bbd4ddcb7b3$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $33f07bbd4ddcb7b3$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$33f07bbd4ddcb7b3$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $33f07bbd4ddcb7b3$var$B(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $33f07bbd4ddcb7b3$var$k(e, t) {
    $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$j(e, t);
}
function $33f07bbd4ddcb7b3$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $33f07bbd4ddcb7b3$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $33f07bbd4ddcb7b3$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $33f07bbd4ddcb7b3$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $33f07bbd4ddcb7b3$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $33f07bbd4ddcb7b3$var$I(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $33f07bbd4ddcb7b3$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$Y(e) {
    return Number(e);
}
function $33f07bbd4ddcb7b3$var$x(e) {
    return 0 === e ? 0 : e;
}
function $33f07bbd4ddcb7b3$var$Q(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $33f07bbd4ddcb7b3$var$x(o), !$33f07bbd4ddcb7b3$var$z(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $33f07bbd4ddcb7b3$var$x($33f07bbd4ddcb7b3$var$D(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $33f07bbd4ddcb7b3$var$z(o) && 0 !== o ? o : 0;
}
function $33f07bbd4ddcb7b3$var$N(e, t) {
    if (!$33f07bbd4ddcb7b3$var$Er(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $33f07bbd4ddcb7b3$var$H(e) {
    return new $33f07bbd4ddcb7b3$export$a890bf36e2af9168(e);
}
function $33f07bbd4ddcb7b3$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$U(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $33f07bbd4ddcb7b3$var$G(e) {
    return e._reader._readRequests.length;
}
function $33f07bbd4ddcb7b3$var$X(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$J(t);
}
class $33f07bbd4ddcb7b3$export$a890bf36e2af9168 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamDefaultReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$J(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$J(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("cancel"));
    }
    read() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("read"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let e, t;
        const r = $33f07bbd4ddcb7b3$var$u((r, o)=>{
            e = r, t = o;
        });
        return $33f07bbd4ddcb7b3$var$K(this, {
            _chunkSteps: (t)=>e({
                    value: t,
                    done: !1
                }),
            _closeSteps: ()=>e({
                    value: void 0,
                    done: !0
                }),
            _errorSteps: (e)=>t(e)
        }), r;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) throw $33f07bbd4ddcb7b3$var$ee("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$Z(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$J(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $33f07bbd4ddcb7b3$export$a890bf36e2af9168;
}
function $33f07bbd4ddcb7b3$var$K(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$33f07bbd4ddcb7b3$var$C](t);
}
function $33f07bbd4ddcb7b3$var$Z(e, t) {
    const r = e._readRequests;
    e._readRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$ee(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $33f07bbd4ddcb7b3$var$te, $33f07bbd4ddcb7b3$var$re, $33f07bbd4ddcb7b3$var$oe;
function $33f07bbd4ddcb7b3$var$ne(e) {
    return e.slice();
}
function $33f07bbd4ddcb7b3$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
let $33f07bbd4ddcb7b3$var$ie = (e)=>($33f07bbd4ddcb7b3$var$ie = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $33f07bbd4ddcb7b3$var$ie(e)), $33f07bbd4ddcb7b3$var$le = (e)=>($33f07bbd4ddcb7b3$var$le = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $33f07bbd4ddcb7b3$var$le(e));
function $33f07bbd4ddcb7b3$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $33f07bbd4ddcb7b3$var$ae(n, 0, e, t, o), n;
}
function $33f07bbd4ddcb7b3$var$ue(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $33f07bbd4ddcb7b3$var$ce(e) {
    try {
        const t = e.done, r = e.value;
        return $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$s(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
const $33f07bbd4ddcb7b3$var$de = null !== ($33f07bbd4ddcb7b3$var$oe = null !== ($33f07bbd4ddcb7b3$var$te = Symbol.asyncIterator) && void 0 !== $33f07bbd4ddcb7b3$var$te ? $33f07bbd4ddcb7b3$var$te : null === ($33f07bbd4ddcb7b3$var$re = Symbol.for) || void 0 === $33f07bbd4ddcb7b3$var$re ? void 0 : $33f07bbd4ddcb7b3$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $33f07bbd4ddcb7b3$var$oe ? $33f07bbd4ddcb7b3$var$oe : "@@asyncIterator";
function $33f07bbd4ddcb7b3$var$fe(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $33f07bbd4ddcb7b3$var$ue(e, $33f07bbd4ddcb7b3$var$de))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $33f07bbd4ddcb7b3$var$be(e);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$ce(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $33f07bbd4ddcb7b3$var$ue(e.iterator, "return");
                            if (void 0 === t) return $33f07bbd4ddcb7b3$var$c({
                                done: !0,
                                value: r
                            });
                            o = $33f07bbd4ddcb7b3$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$t(o) ? $33f07bbd4ddcb7b3$var$ce(o) : $33f07bbd4ddcb7b3$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($33f07bbd4ddcb7b3$var$fe(e, "sync", $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator)));
        } else o = $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $33f07bbd4ddcb7b3$var$S(o, e, []);
    if (!$33f07bbd4ddcb7b3$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $33f07bbd4ddcb7b3$var$be(e) {
    const r = $33f07bbd4ddcb7b3$var$S(e.nextMethod, e.iterator, []);
    if (!$33f07bbd4ddcb7b3$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $33f07bbd4ddcb7b3$var$he {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, t, t) : t();
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader;
        let t, r;
        const o = $33f07bbd4ddcb7b3$var$u((e, o)=>{
            t = e, r = o;
        });
        return $33f07bbd4ddcb7b3$var$K(e, {
            _chunkSteps: (e)=>{
                this._ongoingPromise = void 0, $33f07bbd4ddcb7b3$var$y(()=>t({
                        value: e,
                        done: !1
                    }));
            },
            _closeSteps: ()=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), t({
                    value: void 0,
                    done: !0
                });
            },
            _errorSteps: (t)=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), r(t);
            }
        }), o;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $33f07bbd4ddcb7b3$var$E(t, e);
            return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$_(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$c({
            value: e,
            done: !0
        });
    }
}
const $33f07bbd4ddcb7b3$var$me = {
    next () {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.next() : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("next"));
    },
    return (e) {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.return(e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("return"));
    },
    [$33f07bbd4ddcb7b3$var$de] () {
        return this;
    }
};
function $33f07bbd4ddcb7b3$var$_e(e) {
    if (!$33f07bbd4ddcb7b3$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $33f07bbd4ddcb7b3$var$he;
    } catch (e) {
        return !1;
    }
}
function $33f07bbd4ddcb7b3$var$pe(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($33f07bbd4ddcb7b3$var$me, $33f07bbd4ddcb7b3$var$de, {
    enumerable: !1
});
const $33f07bbd4ddcb7b3$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $33f07bbd4ddcb7b3$var$Se(e) {
    const t = $33f07bbd4ddcb7b3$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $33f07bbd4ddcb7b3$var$ge(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $33f07bbd4ddcb7b3$var$ve(e, t, r) {
    if ("number" != typeof (o = r) || $33f07bbd4ddcb7b3$var$ye(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $33f07bbd4ddcb7b3$var$we(e) {
    e._queue = new $33f07bbd4ddcb7b3$var$v, e._queueTotalSize = 0;
}
function $33f07bbd4ddcb7b3$var$Re(e) {
    return e === DataView;
}
class $33f07bbd4ddcb7b3$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("view");
        return this._view;
    }
    respond(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respond");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respond"), e = $33f07bbd4ddcb7b3$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ue(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respondWithNewView");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ge(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respond, "respond"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("byobRequest");
        return $33f07bbd4ddcb7b3$var$He(this);
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("desiredSize");
        return $33f07bbd4ddcb7b3$var$Ve(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $33f07bbd4ddcb7b3$var$Ye(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("enqueue");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $33f07bbd4ddcb7b3$var$xe(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("error");
        $33f07bbd4ddcb7b3$var$Qe(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$qe(this), $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$Me(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $33f07bbd4ddcb7b3$var$Ne(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$Pe(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $33f07bbd4ddcb7b3$var$Te(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $33f07bbd4ddcb7b3$export$2047cf34091e94ac;
}
function $33f07bbd4ddcb7b3$var$Ce(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $33f07bbd4ddcb7b3$export$fbcf11583158d2c;
}
function $33f07bbd4ddcb7b3$var$Pe(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($33f07bbd4ddcb7b3$var$X(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
        if ($33f07bbd4ddcb7b3$var$ot(t) && $33f07bbd4ddcb7b3$var$rt(t) > 0) return !0;
        const r = $33f07bbd4ddcb7b3$var$Ve(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$Pe(e)), null), (t)=>($33f07bbd4ddcb7b3$var$Qe(e, t), null));
}
function $33f07bbd4ddcb7b3$var$qe(e) {
    $33f07bbd4ddcb7b3$var$De(e), e._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v;
}
function $33f07bbd4ddcb7b3$var$Ee(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $33f07bbd4ddcb7b3$var$We(t);
    "default" === t.readerType ? $33f07bbd4ddcb7b3$var$U(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $33f07bbd4ddcb7b3$var$We(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $33f07bbd4ddcb7b3$var$Oe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $33f07bbd4ddcb7b3$var$Be(e, t, r, o) {
    let n;
    try {
        n = $33f07bbd4ddcb7b3$var$se(t, r, r + o);
    } catch (t) {
        throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
    }
    $33f07bbd4ddcb7b3$var$Oe(e, n, 0, o);
}
function $33f07bbd4ddcb7b3$var$ke(e, t) {
    t.bytesFilled > 0 && $33f07bbd4ddcb7b3$var$Be(e, t.buffer, t.byteOffset, t.bytesFilled), $33f07bbd4ddcb7b3$var$$e(e);
}
function $33f07bbd4ddcb7b3$var$je(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, a = !1;
    const i = o - o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    const l = e._queue;
    for(; n > 0;){
        const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
        $33f07bbd4ddcb7b3$var$ae(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $33f07bbd4ddcb7b3$var$Ae(e, o, t), n -= o;
    }
    return a;
}
function $33f07bbd4ddcb7b3$var$Ae(e, t, r) {
    r.bytesFilled += t;
}
function $33f07bbd4ddcb7b3$var$ze(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(e._controlledReadableByteStream)) : $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$De(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $33f07bbd4ddcb7b3$var$Le(e) {
    for(; e._pendingPullIntos.length > 0;){
        if (0 === e._queueTotalSize) return;
        const t = e._pendingPullIntos.peek();
        $33f07bbd4ddcb7b3$var$je(e, t) && ($33f07bbd4ddcb7b3$var$$e(e), $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, t));
    }
}
function $33f07bbd4ddcb7b3$var$Fe(e, t, r, o) {
    const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $33f07bbd4ddcb7b3$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
    let c;
    try {
        c = $33f07bbd4ddcb7b3$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    const d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $33f07bbd4ddcb7b3$var$tt(n, o);
    if ("closed" !== n._state) {
        if (e._queueTotalSize > 0) {
            if ($33f07bbd4ddcb7b3$var$je(e, d)) {
                const t = $33f07bbd4ddcb7b3$var$We(d);
                return $33f07bbd4ddcb7b3$var$ze(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $33f07bbd4ddcb7b3$var$Qe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $33f07bbd4ddcb7b3$var$tt(n, o), $33f07bbd4ddcb7b3$var$Pe(e);
    } else {
        const e = new a(d.buffer, d.byteOffset, 0);
        o._closeSteps(e);
    }
}
function $33f07bbd4ddcb7b3$var$Ie(e, t) {
    const r = e._pendingPullIntos.peek();
    $33f07bbd4ddcb7b3$var$De(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $33f07bbd4ddcb7b3$var$$e(e);
        const r = e._controlledReadableByteStream;
        if ($33f07bbd4ddcb7b3$var$ot(r)) for(; $33f07bbd4ddcb7b3$var$rt(r) > 0;)$33f07bbd4ddcb7b3$var$Ee(r, $33f07bbd4ddcb7b3$var$$e(e));
    }(e, r) : function(e, t, r) {
        if ($33f07bbd4ddcb7b3$var$Ae(0, t, r), "none" === r.readerType) return $33f07bbd4ddcb7b3$var$ke(e, r), void $33f07bbd4ddcb7b3$var$Le(e);
        if (r.bytesFilled < r.minimumFill) return;
        $33f07bbd4ddcb7b3$var$$e(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $33f07bbd4ddcb7b3$var$Be(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o, $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, r), $33f07bbd4ddcb7b3$var$Le(e);
    }(e, t, r), $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$$e(e) {
    return e._pendingPullIntos.shift();
}
function $33f07bbd4ddcb7b3$var$Me(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Ye(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize != 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
                }
            }
            $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(t);
        }
    }
}
function $33f07bbd4ddcb7b3$var$xe(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: a } = t;
    if ($33f07bbd4ddcb7b3$var$le(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const i = $33f07bbd4ddcb7b3$var$ie(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($33f07bbd4ddcb7b3$var$le(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $33f07bbd4ddcb7b3$var$De(e), t.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), "none" === t.readerType && $33f07bbd4ddcb7b3$var$ke(e, t);
    }
    if ($33f07bbd4ddcb7b3$var$X(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $33f07bbd4ddcb7b3$var$Ne(e, t._readRequests.shift());
            }
        }(e), 0 === $33f07bbd4ddcb7b3$var$G(r)) $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$$e(e);
            $33f07bbd4ddcb7b3$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else $33f07bbd4ddcb7b3$var$ot(r) ? ($33f07bbd4ddcb7b3$var$Oe(e, i, n, a), $33f07bbd4ddcb7b3$var$Le(e)) : $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
    $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$Qe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$qe(e), $33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$Ne(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $33f07bbd4ddcb7b3$var$ze(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $33f07bbd4ddcb7b3$var$He(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $33f07bbd4ddcb7b3$var$Ve(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Ue(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $33f07bbd4ddcb7b3$var$ie(r.buffer), $33f07bbd4ddcb7b3$var$Ie(e, t);
}
function $33f07bbd4ddcb7b3$var$Ge(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), $33f07bbd4ddcb7b3$var$Ie(e, o);
}
function $33f07bbd4ddcb7b3$var$Xe(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Pe(t), null), (e)=>($33f07bbd4ddcb7b3$var$Qe(t, e), null));
}
function $33f07bbd4ddcb7b3$var$Je(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $33f07bbd4ddcb7b3$var$Ke(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $33f07bbd4ddcb7b3$var$Ze(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $33f07bbd4ddcb7b3$var$et(e) {
    return new $33f07bbd4ddcb7b3$export$20068a30393fcc28(e);
}
function $33f07bbd4ddcb7b3$var$tt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$rt(e) {
    return e._reader._readIntoRequests.length;
}
function $33f07bbd4ddcb7b3$var$ot(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$nt(t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$20068a30393fcc28 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamBYOBReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$33f07bbd4ddcb7b3$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readIntoRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$nt(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$nt(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("cancel"));
    }
    read(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("read"));
        if (!ArrayBuffer.isView(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $33f07bbd4ddcb7b3$var$L(e, t), {
                    min: $33f07bbd4ddcb7b3$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $33f07bbd4ddcb7b3$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $33f07bbd4ddcb7b3$var$Re(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let n, a;
        const i = $33f07bbd4ddcb7b3$var$u((e, t)=>{
            n = e, a = t;
        });
        return $33f07bbd4ddcb7b3$var$at(this, e, o, {
            _chunkSteps: (e)=>n({
                    value: e,
                    done: !1
                }),
            _closeSteps: (e)=>n({
                    value: e,
                    done: !0
                }),
            _errorSteps: (e)=>a(e)
        }), i;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) throw $33f07bbd4ddcb7b3$var$lt("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$it(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$nt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $33f07bbd4ddcb7b3$export$20068a30393fcc28;
}
function $33f07bbd4ddcb7b3$var$at(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $33f07bbd4ddcb7b3$var$Fe(n._readableStreamController, t, r, o);
}
function $33f07bbd4ddcb7b3$var$it(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$lt(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $33f07bbd4ddcb7b3$var$st(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($33f07bbd4ddcb7b3$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $33f07bbd4ddcb7b3$var$ut(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $33f07bbd4ddcb7b3$var$ct(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Y(r),
        size: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$dt(o, `${t} has member 'size' that`)
    };
}
function $33f07bbd4ddcb7b3$var$dt(e, t) {
    return $33f07bbd4ddcb7b3$var$F(e, t), (t)=>$33f07bbd4ddcb7b3$var$Y(e(t));
}
function $33f07bbd4ddcb7b3$var$ft(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$bt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), ()=>$33f07bbd4ddcb7b3$var$g(e, t, []);
}
function $33f07bbd4ddcb7b3$var$ht(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$mt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$_t(e, t) {
    if (!$33f07bbd4ddcb7b3$var$gt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$pt = "function" == typeof AbortController;
class $33f07bbd4ddcb7b3$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$ft(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$bt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$ht(n, e, `${t} has member 'start' that`),
                write: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$mt(i, e, `${t} has member 'write' that`),
                type: a
            };
        }(e, "First parameter");
        $33f07bbd4ddcb7b3$var$St(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $33f07bbd4ddcb7b3$var$ut(r);
        !function(e, t, r, o) {
            const n = Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype);
            let a, i, l, s;
            a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            l = void 0 !== t.close ? ()=>t.close() : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            $33f07bbd4ddcb7b3$var$Ft(e, n, a, i, l, s, r, o);
        }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), n);
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("locked");
        return $33f07bbd4ddcb7b3$var$vt(this);
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$wt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("abort"));
    }
    close() {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$qt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Rt(this) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("close"));
    }
    getWriter() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("getWriter");
        return $33f07bbd4ddcb7b3$var$yt(this);
    }
}
function $33f07bbd4ddcb7b3$var$yt(e) {
    return new $33f07bbd4ddcb7b3$export$9295348f005d6054(e);
}
function $33f07bbd4ddcb7b3$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $33f07bbd4ddcb7b3$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $33f07bbd4ddcb7b3$var$gt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$826849241f7970f8;
}
function $33f07bbd4ddcb7b3$var$vt(e) {
    return void 0 !== e._writer;
}
function $33f07bbd4ddcb7b3$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $33f07bbd4ddcb7b3$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const a = $33f07bbd4ddcb7b3$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $33f07bbd4ddcb7b3$var$Ct(e, t), a;
}
function $33f07bbd4ddcb7b3$var$Rt(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $33f07bbd4ddcb7b3$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $33f07bbd4ddcb7b3$var$or(o), $33f07bbd4ddcb7b3$var$ve(n = e._writableStreamController, $33f07bbd4ddcb7b3$var$Dt, 0), $33f07bbd4ddcb7b3$var$Mt(n), r;
}
function $33f07bbd4ddcb7b3$var$Tt(e, t) {
    "writable" !== e._state ? $33f07bbd4ddcb7b3$var$Pt(e) : $33f07bbd4ddcb7b3$var$Ct(e, t);
}
function $33f07bbd4ddcb7b3$var$Ct(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $33f07bbd4ddcb7b3$var$jt(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $33f07bbd4ddcb7b3$var$Pt(e);
}
function $33f07bbd4ddcb7b3$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$33f07bbd4ddcb7b3$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $33f07bbd4ddcb7b3$var$v, void 0 === e._pendingAbortRequest) return void $33f07bbd4ddcb7b3$var$Et(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $33f07bbd4ddcb7b3$var$Et(e);
    $33f07bbd4ddcb7b3$var$b(e._writableStreamController[$33f07bbd4ddcb7b3$var$w](r._reason), ()=>(r._resolve(), $33f07bbd4ddcb7b3$var$Et(e), null), (t)=>(r._reject(t), $33f07bbd4ddcb7b3$var$Et(e), null));
}
function $33f07bbd4ddcb7b3$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $33f07bbd4ddcb7b3$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $33f07bbd4ddcb7b3$var$Jt(t, e._storedError);
}
function $33f07bbd4ddcb7b3$var$Wt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $33f07bbd4ddcb7b3$var$Zt(e);
    }(r) : $33f07bbd4ddcb7b3$var$or(r)), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$9295348f005d6054 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "WritableStreamDefaultWriter"), $33f07bbd4ddcb7b3$var$_t(e, "First parameter"), $33f07bbd4ddcb7b3$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$33f07bbd4ddcb7b3$var$qt(e) && e._backpressure ? $33f07bbd4ddcb7b3$var$Zt(this) : $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("erroring" === t) $33f07bbd4ddcb7b3$var$er(this, e._storedError), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("closed" === t) $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(r = this), $33f07bbd4ddcb7b3$var$Kt(r);
        else {
            const t = e._storedError;
            $33f07bbd4ddcb7b3$var$er(this, t), $33f07bbd4ddcb7b3$var$Xt(this, t);
        }
        var r;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("closed"));
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $33f07bbd4ddcb7b3$var$Ut("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $33f07bbd4ddcb7b3$var$$t(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._readyPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("ready"));
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("abort")) : function(e, t) {
            return $33f07bbd4ddcb7b3$var$wt(e._ownerWritableStream, t);
        }(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("abort"));
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("close")) : $33f07bbd4ddcb7b3$var$qt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Bt(this);
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("releaseLock");
        void 0 !== this._ownerWritableStream && $33f07bbd4ddcb7b3$var$At(this);
    }
    write(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to")) : $33f07bbd4ddcb7b3$var$zt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("write"));
    }
}
function $33f07bbd4ddcb7b3$var$Ot(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9295348f005d6054;
}
function $33f07bbd4ddcb7b3$var$Bt(e) {
    return $33f07bbd4ddcb7b3$var$Rt(e._ownerWritableStream);
}
function $33f07bbd4ddcb7b3$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $33f07bbd4ddcb7b3$var$Jt(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$Xt(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $33f07bbd4ddcb7b3$var$rr(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$er(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$At(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $33f07bbd4ddcb7b3$var$jt(e, r), $33f07bbd4ddcb7b3$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$zt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $33f07bbd4ddcb7b3$var$Yt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to"));
    const a = r._state;
    if ("errored" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    if ($33f07bbd4ddcb7b3$var$qt(r) || "closed" === a) return $33f07bbd4ddcb7b3$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    const i = function(e) {
        return $33f07bbd4ddcb7b3$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            return void $33f07bbd4ddcb7b3$var$Yt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$33f07bbd4ddcb7b3$var$qt(o) && "writable" === o._state) $33f07bbd4ddcb7b3$var$Wt(o, $33f07bbd4ddcb7b3$var$xt(e));
        $33f07bbd4ddcb7b3$var$Mt(e);
    }(o, t, n), i;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Dt = {};
class $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("error");
        "writable" === this._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(this, e);
    }
    [$33f07bbd4ddcb7b3$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$It(this), t;
    }
    [$33f07bbd4ddcb7b3$var$R]() {
        $33f07bbd4ddcb7b3$var$we(this);
    }
}
function $33f07bbd4ddcb7b3$var$Lt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2;
}
function $33f07bbd4ddcb7b3$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ($33f07bbd4ddcb7b3$var$pt) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    const s = $33f07bbd4ddcb7b3$var$xt(t);
    $33f07bbd4ddcb7b3$var$Wt(e, s);
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Mt(t), null), (r)=>(t._started = !0, $33f07bbd4ddcb7b3$var$Tt(e, r), null));
}
function $33f07bbd4ddcb7b3$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Mt(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $33f07bbd4ddcb7b3$var$Pt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $33f07bbd4ddcb7b3$var$Dt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $33f07bbd4ddcb7b3$var$ge(e);
        const r = e._closeAlgorithm();
        $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$b(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $33f07bbd4ddcb7b3$var$Kt(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $33f07bbd4ddcb7b3$var$Tt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $33f07bbd4ddcb7b3$var$b(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($33f07bbd4ddcb7b3$var$ge(e), !$33f07bbd4ddcb7b3$var$qt(r) && "writable" === t) {
                const t = $33f07bbd4ddcb7b3$var$xt(e);
                $33f07bbd4ddcb7b3$var$Wt(r, t);
            }
            return $33f07bbd4ddcb7b3$var$Mt(e), null;
        }, (t)=>("writable" === r._state && $33f07bbd4ddcb7b3$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $33f07bbd4ddcb7b3$var$Tt(e, t);
            }(r, t), null));
    }(e, r);
}
function $33f07bbd4ddcb7b3$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(e, t);
}
function $33f07bbd4ddcb7b3$var$xt(e) {
    return $33f07bbd4ddcb7b3$var$$t(e) <= 0;
}
function $33f07bbd4ddcb7b3$var$Qt(e, t) {
    const r = e._controlledWritableStream;
    $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$Ct(r, t);
}
function $33f07bbd4ddcb7b3$var$Nt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $33f07bbd4ddcb7b3$var$Ht(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$Vt(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $33f07bbd4ddcb7b3$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $33f07bbd4ddcb7b3$var$Gt(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $33f07bbd4ddcb7b3$var$Xt(e, t) {
    $33f07bbd4ddcb7b3$var$Gt(e), $33f07bbd4ddcb7b3$var$Jt(e, t);
}
function $33f07bbd4ddcb7b3$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $33f07bbd4ddcb7b3$var$Zt(e) {
    e._readyPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $33f07bbd4ddcb7b3$var$er(e, t) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$rr(e, t);
}
function $33f07bbd4ddcb7b3$var$tr(e) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$or(e);
}
function $33f07bbd4ddcb7b3$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $33f07bbd4ddcb7b3$var$ar = function() {
    const e = null == $33f07bbd4ddcb7b3$var$nr ? void 0 : $33f07bbd4ddcb7b3$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $33f07bbd4ddcb7b3$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $33f07bbd4ddcb7b3$var$ir(t, r, o, n, a, i) {
    const l = $33f07bbd4ddcb7b3$var$H(t), s = $33f07bbd4ddcb7b3$var$yt(r);
    t._disturbed = !0;
    let _ = !1, y = $33f07bbd4ddcb7b3$var$c(void 0);
    return $33f07bbd4ddcb7b3$var$u((S, g)=>{
        let v;
        if (void 0 !== i) {
            if (v = ()=>{
                const e = void 0 !== i.reason ? i.reason : new $33f07bbd4ddcb7b3$var$ar("Aborted", "AbortError"), o = [];
                n || o.push(()=>"writable" === r._state ? $33f07bbd4ddcb7b3$var$wt(r, e) : $33f07bbd4ddcb7b3$var$c(void 0)), a || o.push(()=>"readable" === t._state ? $33f07bbd4ddcb7b3$var$Or(t, e) : $33f07bbd4ddcb7b3$var$c(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$wt(r, e), !0, e), null)), P(r, s._closedPromise, (e)=>(a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e), null)), w = t, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $33f07bbd4ddcb7b3$var$qt(t) || "closed" === r ? $33f07bbd4ddcb7b3$var$c(void 0) : "errored" === r ? $33f07bbd4ddcb7b3$var$d(t._storedError) : $33f07bbd4ddcb7b3$var$Bt(e);
                })(s)), null), "closed" === w._state ? T() : $33f07bbd4ddcb7b3$var$h(R, T), $33f07bbd4ddcb7b3$var$qt(r) || "closed" === r._state) {
            const e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e);
        }
        function C() {
            const e = y;
            return $33f07bbd4ddcb7b3$var$f(y, ()=>e !== y ? C() : void 0);
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $33f07bbd4ddcb7b3$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $33f07bbd4ddcb7b3$var$b(e(), ()=>O(t, o), (e)=>O(!0, e)), null;
            }
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? n() : $33f07bbd4ddcb7b3$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? O(e, t) : $33f07bbd4ddcb7b3$var$h(C(), ()=>O(e, t)));
        }
        function O(e, t) {
            return $33f07bbd4ddcb7b3$var$At(s), $33f07bbd4ddcb7b3$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$u((t, r)=>{
            !function o(n) {
                n ? t() : $33f07bbd4ddcb7b3$var$f(_ ? $33f07bbd4ddcb7b3$var$c(!0) : $33f07bbd4ddcb7b3$var$f(s._readyPromise, ()=>$33f07bbd4ddcb7b3$var$u((t, r)=>{
                        $33f07bbd4ddcb7b3$var$K(l, {
                            _chunkSteps: (r)=>{
                                y = $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$zt(s, r), void 0, $33f07bbd4ddcb7b3$var$e), t(!1);
                            },
                            _closeSteps: ()=>t(!0),
                            _errorSteps: r
                        });
                    })), o, r);
            }(!1);
        }));
    });
}
class $33f07bbd4ddcb7b3$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("close");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
        $33f07bbd4ddcb7b3$var$dr(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("enqueue");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $33f07bbd4ddcb7b3$var$fr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("error");
        $33f07bbd4ddcb7b3$var$br(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$cr(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $33f07bbd4ddcb7b3$var$ge(this);
            this._closeRequested && 0 === this._queue.length ? ($33f07bbd4ddcb7b3$var$cr(this), $33f07bbd4ddcb7b3$var$Br(t)) : $33f07bbd4ddcb7b3$var$sr(this), e._chunkSteps(r);
        } else $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$sr(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {}
}
function $33f07bbd4ddcb7b3$var$lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $33f07bbd4ddcb7b3$export$b0bb6d0989d67700;
}
function $33f07bbd4ddcb7b3$var$sr(e) {
    if (!$33f07bbd4ddcb7b3$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$sr(e)), null), (t)=>($33f07bbd4ddcb7b3$var$br(e, t), null));
}
function $33f07bbd4ddcb7b3$var$ur(e) {
    const t = e._controlledReadableStream;
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($33f07bbd4ddcb7b3$var$Wr(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
    return $33f07bbd4ddcb7b3$var$hr(e) > 0;
}
function $33f07bbd4ddcb7b3$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$dr(e) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$Br(t));
}
function $33f07bbd4ddcb7b3$var$fr(e, t) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const r = e._controlledReadableStream;
    if ($33f07bbd4ddcb7b3$var$Wr(r) && $33f07bbd4ddcb7b3$var$G(r) > 0) $33f07bbd4ddcb7b3$var$U(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
    }
    $33f07bbd4ddcb7b3$var$sr(e);
}
function $33f07bbd4ddcb7b3$var$br(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$hr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$mr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $33f07bbd4ddcb7b3$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$sr(t), null), (e)=>($33f07bbd4ddcb7b3$var$br(t, e), null));
}
function $33f07bbd4ddcb7b3$var$pr(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$yr(e, t) {
    return $33f07bbd4ddcb7b3$var$Te(e._readableStreamController) ? function(e) {
        let t, r, o, n, a, i = $33f07bbd4ddcb7b3$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            a = e;
        });
        function _(e) {
            $33f07bbd4ddcb7b3$var$m(e._closedPromise, (t)=>(e !== i || ($33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), f && b || a(void 0)), null));
        }
        function p() {
            $33f07bbd4ddcb7b3$var$nt(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$H(e), _(i));
            $33f07bbd4ddcb7b3$var$K(i, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const r = t;
                        let i = t;
                        if (!f && !b) try {
                            i = $33f07bbd4ddcb7b3$var$Se(t);
                        } catch (t) {
                            return $33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                        }
                        f || $33f07bbd4ddcb7b3$var$xe(o._readableStreamController, r), b || $33f07bbd4ddcb7b3$var$xe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, f || $33f07bbd4ddcb7b3$var$Ye(o._readableStreamController), b || $33f07bbd4ddcb7b3$var$Ye(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $33f07bbd4ddcb7b3$var$J(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$et(e), _(i));
            const u = r ? n : o, c = r ? o : n;
            $33f07bbd4ddcb7b3$var$at(i, t, 1, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const o = r ? b : f;
                        if (r ? f : b) o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $33f07bbd4ddcb7b3$var$Se(t);
                            } catch (t) {
                                return $33f07bbd4ddcb7b3$var$Qe(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(c._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                            }
                            o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$xe(c._readableStreamController, r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    l = !1;
                    const t = r ? b : f, o = r ? f : b;
                    t || $33f07bbd4ddcb7b3$var$Ye(u._readableStreamController), o || $33f07bbd4ddcb7b3$var$Ye(c._readableStreamController), void 0 !== e && (t || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(c._readableStreamController, 0)), t && o || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function T() {}
        return o = $33f07bbd4ddcb7b3$var$Pr(T, g, w), n = $33f07bbd4ddcb7b3$var$Pr(T, v, R), _(i), [
            o,
            n
        ];
    }(e) : function(e, t) {
        const r = $33f07bbd4ddcb7b3$var$H(e);
        let o, n, a, i, l, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            l = e;
        });
        function _() {
            if (s) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            s = !0;
            return $33f07bbd4ddcb7b3$var$K(r, {
                _chunkSteps: (e)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        d = !1;
                        const t = e, r = e;
                        f || $33f07bbd4ddcb7b3$var$fr(a._readableStreamController, t), b || $33f07bbd4ddcb7b3$var$fr(i._readableStreamController, r), s = !1, d && _();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $33f07bbd4ddcb7b3$var$dr(a._readableStreamController), b || $33f07bbd4ddcb7b3$var$dr(i._readableStreamController), f && b || l(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function p(t) {
            if (f = !0, o = t, b) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function S(t) {
            if (b = !0, n = t, f) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function g() {}
        return a = $33f07bbd4ddcb7b3$var$Cr(g, _, p), i = $33f07bbd4ddcb7b3$var$Cr(g, _, S), $33f07bbd4ddcb7b3$var$m(r._closedPromise, (e)=>($33f07bbd4ddcb7b3$var$br(a._readableStreamController, e), $33f07bbd4ddcb7b3$var$br(i._readableStreamController, e), f && b || l(void 0), null)), [
            a,
            i
        ];
    }(e);
}
function $33f07bbd4ddcb7b3$var$Sr(r) {
    var o;
    return $33f07bbd4ddcb7b3$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_(e, (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            try {
                return $33f07bbd4ddcb7b3$var$c(r.cancel(e));
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, n, a, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $33f07bbd4ddcb7b3$var$fe(r, "async");
        function a() {
            let e;
            try {
                e = $33f07bbd4ddcb7b3$var$be(n);
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$c(e), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            const r = n.iterator;
            let o;
            try {
                o = $33f07bbd4ddcb7b3$var$ue(r, "return");
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            if (void 0 === o) return $33f07bbd4ddcb7b3$var$c(void 0);
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, a, i, 0), o;
    }(r);
}
function $33f07bbd4ddcb7b3$var$gr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$vr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$wr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Rr(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $33f07bbd4ddcb7b3$var$Tr(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(a, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Q(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$gr(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$vr(a, r, `${t} has member 'pull' that`),
                start: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$wr(i, r, `${t} has member 'start' that`),
                type: void 0 === l ? void 0 : $33f07bbd4ddcb7b3$var$Rr(l, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($33f07bbd4ddcb7b3$var$qr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype);
                let n, a, i;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
                const l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $33f07bbd4ddcb7b3$var$Xe(e, o, n, a, i, r, l);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 0));
        } else {
            const e = $33f07bbd4ddcb7b3$var$ut(r);
            !function(e, t, r, o) {
                const n = Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype);
                let a, i, l;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), $33f07bbd4ddcb7b3$var$_r(e, n, a, i, l, r, o);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), e);
        }
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("locked");
        return $33f07bbd4ddcb7b3$var$Wr(this);
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$Er(this) ? $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $33f07bbd4ddcb7b3$var$Or(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("cancel"));
    }
    getReader(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("getReader");
        return void 0 === function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Ze(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $33f07bbd4ddcb7b3$var$H(this) : $33f07bbd4ddcb7b3$var$et(this);
    }
    pipeThrough(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("pipeThrough");
        $33f07bbd4ddcb7b3$var$$(e, 1, "pipeThrough");
        const r = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $33f07bbd4ddcb7b3$var$M(r, "readable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$N(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $33f07bbd4ddcb7b3$var$M(o, "writable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$_t(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        if ($33f07bbd4ddcb7b3$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($33f07bbd4ddcb7b3$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$ir(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("pipeTo"));
        if (void 0 === e) return $33f07bbd4ddcb7b3$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$33f07bbd4ddcb7b3$var$gt(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        return $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $33f07bbd4ddcb7b3$var$vt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $33f07bbd4ddcb7b3$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("tee");
        return $33f07bbd4ddcb7b3$var$ne($33f07bbd4ddcb7b3$var$yr(this));
    }
    values(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("values");
        return function(e, t) {
            const r = $33f07bbd4ddcb7b3$var$H(e), o = new $33f07bbd4ddcb7b3$var$he(r, t), n = Object.create($33f07bbd4ddcb7b3$var$me);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$33f07bbd4ddcb7b3$var$de](e) {
        return this.values(e);
    }
    static from(e) {
        return $33f07bbd4ddcb7b3$var$Sr(e);
    }
}
function $33f07bbd4ddcb7b3$var$Cr(e, t, r, o = 1, n = ()=>1) {
    const a = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(a);
    return $33f07bbd4ddcb7b3$var$_r(a, Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype), e, t, r, o, n), a;
}
function $33f07bbd4ddcb7b3$var$Pr(e, t, r) {
    const o = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(o);
    return $33f07bbd4ddcb7b3$var$Xe(o, Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $33f07bbd4ddcb7b3$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $33f07bbd4ddcb7b3$var$Er(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76;
}
function $33f07bbd4ddcb7b3$var$Wr(e) {
    return void 0 !== e._reader;
}
function $33f07bbd4ddcb7b3$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    if ("errored" === t._state) return $33f07bbd4ddcb7b3$var$d(t._storedError);
    $33f07bbd4ddcb7b3$var$Br(t);
    const o = t._reader;
    if (void 0 !== o && $33f07bbd4ddcb7b3$var$nt(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $33f07bbd4ddcb7b3$var$_(t._readableStreamController[$33f07bbd4ddcb7b3$var$T](r), $33f07bbd4ddcb7b3$var$e);
}
function $33f07bbd4ddcb7b3$var$Br(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($33f07bbd4ddcb7b3$var$A(t), $33f07bbd4ddcb7b3$var$J(t))) {
        const e = t._readRequests;
        t._readRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $33f07bbd4ddcb7b3$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($33f07bbd4ddcb7b3$var$j(r, t), $33f07bbd4ddcb7b3$var$J(r) ? $33f07bbd4ddcb7b3$var$Z(r, t) : $33f07bbd4ddcb7b3$var$it(r, t));
}
function $33f07bbd4ddcb7b3$var$jr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $33f07bbd4ddcb7b3$var$Ar(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $33f07bbd4ddcb7b3$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $33f07bbd4ddcb7b3$var$Y(r)
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.from, "from"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.tee, "tee"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, $33f07bbd4ddcb7b3$var$de, {
    value: $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$zr = (e)=>e.byteLength;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$zr, "size");
class $33f07bbd4ddcb7b3$export$d386b5f37d154119 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("size");
        return $33f07bbd4ddcb7b3$var$zr;
    }
}
function $33f07bbd4ddcb7b3$var$Dr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$Lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$d386b5f37d154119;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Fr = ()=>1;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$Fr, "size");
class $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "CountQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("size");
        return $33f07bbd4ddcb7b3$var$Fr;
    }
}
function $33f07bbd4ddcb7b3$var$Ir(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$$r(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625;
}
function $33f07bbd4ddcb7b3$var$Mr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Yr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$xr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$Qr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), n = $33f07bbd4ddcb7b3$var$ct(r, "Third parameter"), a = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Qr(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Mr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$Yr(a, e, `${t} has member 'start' that`),
                transform: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$xr(i, e, `${t} has member 'transform' that`),
                writableType: l
            };
        }(e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        const i = $33f07bbd4ddcb7b3$var$st(n, 0), l = $33f07bbd4ddcb7b3$var$ut(n), s = $33f07bbd4ddcb7b3$var$st(o, 1), f = $33f07bbd4ddcb7b3$var$ut(o);
        let h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $33f07bbd4ddcb7b3$var$_(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $33f07bbd4ddcb7b3$var$Zr(r, t);
                    });
                    return $33f07bbd4ddcb7b3$var$Zr(r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$br(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$to(r)), null), (e)=>($33f07bbd4ddcb7b3$var$br(o._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $33f07bbd4ddcb7b3$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $33f07bbd4ddcb7b3$var$Jr(t), $33f07bbd4ddcb7b3$var$b(o, ()=>("errored" === r._state ? $33f07bbd4ddcb7b3$var$ro(t, r._storedError) : ($33f07bbd4ddcb7b3$var$dr(r._readableStreamController), $33f07bbd4ddcb7b3$var$to(t)), null), (e)=>($33f07bbd4ddcb7b3$var$br(r._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $33f07bbd4ddcb7b3$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$to(r)), null), (t)=>($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$ro(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                const i = Object.create($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype);
                return $33f07bbd4ddcb7b3$var$St(i), $33f07bbd4ddcb7b3$var$Ft(i, Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, a), i;
            }(i, l, c, s, r, o), e._readable = $33f07bbd4ddcb7b3$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $33f07bbd4ddcb7b3$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $33f07bbd4ddcb7b3$var$u((e)=>{
            h = e;
        }), s, f, i, l), function(e, t) {
            const r = Object.create($33f07bbd4ddcb7b3$export$a55559184460222.prototype);
            let o, n, a;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $33f07bbd4ddcb7b3$var$Kr(r, e), $33f07bbd4ddcb7b3$var$c(void 0);
                } catch (e) {
                    return $33f07bbd4ddcb7b3$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    get readable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("readable");
        return this._readable;
    }
    get writable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("writable");
        return this._writable;
    }
}
function $33f07bbd4ddcb7b3$var$Nr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $33f07bbd4ddcb7b3$export$d102341634899398;
}
function $33f07bbd4ddcb7b3$var$Hr(e, t) {
    $33f07bbd4ddcb7b3$var$br(e._readable._readableStreamController, t), $33f07bbd4ddcb7b3$var$Vr(e, t);
}
function $33f07bbd4ddcb7b3$var$Vr(e, t) {
    $33f07bbd4ddcb7b3$var$Jr(e._transformStreamController), $33f07bbd4ddcb7b3$var$Yt(e._writable._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e);
}
function $33f07bbd4ddcb7b3$var$Ur(e) {
    e._backpressure && $33f07bbd4ddcb7b3$var$Gr(e, !1);
}
function $33f07bbd4ddcb7b3$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $33f07bbd4ddcb7b3$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("enqueue");
        $33f07bbd4ddcb7b3$var$Kr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("error");
        var t;
        t = e, $33f07bbd4ddcb7b3$var$Hr(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $33f07bbd4ddcb7b3$var$dr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $33f07bbd4ddcb7b3$var$Vr(t, r);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$Xr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $33f07bbd4ddcb7b3$export$a55559184460222;
}
function $33f07bbd4ddcb7b3$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Kr(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$33f07bbd4ddcb7b3$var$mr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $33f07bbd4ddcb7b3$var$fr(o, t);
    } catch (e) {
        throw $33f07bbd4ddcb7b3$var$Vr(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$33f07bbd4ddcb7b3$var$ur(e);
    }(o);
    n !== r._backpressure && $33f07bbd4ddcb7b3$var$Gr(r, !0);
}
function $33f07bbd4ddcb7b3$var$Zr(e, t) {
    return $33f07bbd4ddcb7b3$var$_(e._transformAlgorithm(t), void 0, (t)=>{
        throw $33f07bbd4ddcb7b3$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $33f07bbd4ddcb7b3$var$eo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$oo(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.error, "error"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});


parcelRegister("a2E6i", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterableForSet({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterableForSet({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("iEIKV", function(module, exports) {
const $d94eadff66ce104b$var$CRLF = '\r\n';
const $d94eadff66ce104b$var$SP = ' ';
/**
 * Maximum line length (excluding <CR><LF>)
 * There are two limits that RFC 5322 places on the number of
 * characters in a line. Each line of characters MUST be
 * no more than 998 characters, and SHOULD be no more
 * than 78 characters, excluding the <CR><LF>.
 * @type {Number}
 * @constant
 */ const $d94eadff66ce104b$var$MAX_LINE_LENGTH = 998;
/**
 * Default maximum line length (excluding <CR><LF>)
 * @type {Number}
 * @constant
 */ const $d94eadff66ce104b$var$DEFAULT_LINE_LENGTH = 78;
/**
 * Minimum `maxLength` that can be used
 * @type {Number}
 * @constant
 */ const $d94eadff66ce104b$var$MIN_LINE_LENGTH = 2;
/**
 * Folds a long line according to RFC 5322
 * @see http://tools.ietf.org/html/rfc5322#section-2.1.1
 *
 * @param {String} input - input string
 * @param {Number} maxLength - maximum line length (excluding CRLF)
 * @param {Boolean} hardWrap - whether to insert a hard break at `maxLength`
 * @returns {String}
 */ function $d94eadff66ce104b$var$foldLine(input, maxLength, hardWrap) {
    if (maxLength != null && maxLength < $d94eadff66ce104b$var$MIN_LINE_LENGTH) throw new Error('Maximum length must not be less than ' + $d94eadff66ce104b$var$MIN_LINE_LENGTH);
    if (maxLength != null && maxLength > $d94eadff66ce104b$var$MAX_LINE_LENGTH) throw new Error('Maximum length must not exceed ' + $d94eadff66ce104b$var$MAX_LINE_LENGTH);
    // RFC compliant default line length
    maxLength = maxLength || $d94eadff66ce104b$var$DEFAULT_LINE_LENGTH;
    input = input.replace(/[\r\n]+/g, '');
    // We really don't need to fold this
    if (input.length <= maxLength) return input;
    var output = '';
    var index = 0;
    var nextIndex = 0;
    var length = input.length;
    var line = 0;
    var trim = 0;
    while(index < length){
        if (!hardWrap && ~(nextIndex = input.lastIndexOf($d94eadff66ce104b$var$SP, index + maxLength))) {
            if (nextIndex > index) {
                output += input.slice(index, nextIndex) + $d94eadff66ce104b$var$CRLF + $d94eadff66ce104b$var$SP;
                index = nextIndex;
            } else {
                output += input.slice(index, index + maxLength - trim) + $d94eadff66ce104b$var$CRLF + $d94eadff66ce104b$var$SP;
                index = index + maxLength - trim;
                hardWrap = true;
            }
        } else {
            output += input.slice(index, index + maxLength - trim) + $d94eadff66ce104b$var$CRLF + $d94eadff66ce104b$var$SP;
            index = index + maxLength - trim;
        }
        if (length - index < maxLength) {
            output += input.slice(index);
            break;
        }
        if (line === 0) trim = 1;
        line++;
    }
    return output;
}
$d94eadff66ce104b$var$foldLine.unfold = function unfold(input) {
    return input.replace(/\r\n\s/gm, '');
};
module.exports = $d94eadff66ce104b$var$foldLine;

});

parcelRegister("2KRUh", function(module, exports) {

var $4TXj5 = parcelRequire("4TXj5");

var $lXGBn = parcelRequire("lXGBn");
function $2019b162807b21b3$var$set(object, key, value) {
    if (Array.isArray(object[key])) object[key].push(value);
    else if (object[key] != null) object[key] = [
        object[key],
        value
    ];
    else object[key] = value;
}
function $2019b162807b21b3$var$createParams(params, param) {
    var parts = param.split('=');
    var k = $4TXj5(parts[0]);
    var value = parts[1];
    if (value == null || value === '') {
        value = parts[0];
        k = 'type';
    }
    if (k === 'type') {
        if (value[0] === '"' && value[value.length - 1] === '"' && value.indexOf(',') !== -1) value = value.slice(1, -1);
        value.toLowerCase().split(',').forEach(function(value) {
            $2019b162807b21b3$var$set(params, k, value);
        });
        return params;
    }
    $2019b162807b21b3$var$set(params, k, value);
    return params;
}
function $2019b162807b21b3$var$parseLines(lines) {
    var data = {};
    // NOTE: Line format:
    //  PROPERTY[;PARAMETER[=VALUE]]:Attribute[;Attribute]
    var line = null;
    var pattern = /^([^;:]+)((?:;(?:[^;:]+))*)(?:\:([\s\S]+))?$/i;
    var len = lines.length - 1;
    for(var i = 1; i < len; i++){
        line = lines[i];
        var match = pattern.exec(line);
        if (!match) continue;
        var name = match[1].split('.');
        var property = name.pop();
        var group = name.pop();
        var value = match[3];
        var params = match[2] ? match[2].replace(/^;|;$/g, '').split(';') : [];
        var propParams = params.reduce($2019b162807b21b3$var$createParams, group ? {
            group: group
        } : {});
        var propName = $4TXj5(property);
        var propVal = new $lXGBn(propName, value, propParams);
        $2019b162807b21b3$var$set(data, propName, propVal);
    }
    return data;
}
module.exports = $2019b162807b21b3$var$parseLines;

});
parcelRegister("4TXj5", function(module, exports) {
'use strict';
const $391a4d94d30ed66d$var$preserveCamelCase = (string)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && /[a-zA-Z]/.test(character) && character.toUpperCase() === character) {
            string = string.slice(0, i) + '-' + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(character) && character.toLowerCase() === character) {
            string = string.slice(0, i - 1) + '-' + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = character.toLowerCase() === character && character.toUpperCase() !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = character.toUpperCase() === character && character.toLowerCase() !== character;
        }
    }
    return string;
};
const $391a4d94d30ed66d$var$camelCase = (input, options)=>{
    if (!(typeof input === 'string' || Array.isArray(input))) throw new TypeError('Expected the input to be `string | string[]`');
    options = Object.assign({
        pascalCase: false
    }, options);
    const postProcess = (x)=>options.pascalCase ? x.charAt(0).toUpperCase() + x.slice(1) : x;
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join('-');
    else input = input.trim();
    if (input.length === 0) return '';
    if (input.length === 1) return options.pascalCase ? input.toUpperCase() : input.toLowerCase();
    const hasUpperCase = input !== input.toLowerCase();
    if (hasUpperCase) input = $391a4d94d30ed66d$var$preserveCamelCase(input);
    input = input.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, (_, p1)=>p1.toUpperCase()).replace(/\d+(\w|$)/g, (m)=>m.toUpperCase());
    return postProcess(input);
};
module.exports = $391a4d94d30ed66d$var$camelCase;
// TODO: Remove this for the next major release
module.exports.default = $391a4d94d30ed66d$var$camelCase;

});

parcelRegister("lXGBn", function(module, exports) {
/**
 * vCard Property
 * @constructor
 * @memberOf vCard
 * @param {String} field
 * @param {String} value
 * @param {Object} params
 * @return {Property}
 */ function $ffd0277a2b104837$var$Property(field, value, params) {
    if (!(this instanceof $ffd0277a2b104837$var$Property)) return new $ffd0277a2b104837$var$Property(value);
    if (params != null) Object.assign(this, params);
    this._field = field;
    this._data = value;
    Object.defineProperty(this, '_field', {
        enumerable: false
    });
    Object.defineProperty(this, '_data', {
        enumerable: false
    });
}
/**
 * Constructs a vCard.Property from jCard data
 * @param  {Array} data
 * @return {Property}
 */ $ffd0277a2b104837$var$Property.fromJSON = function(data) {
    var field = data[0];
    var params = data[1];
    if (!/text/i.test(data[2])) params.value = data[2];
    var value = Array.isArray(data[3]) ? data[3].join(';') : data[3];
    return new $ffd0277a2b104837$var$Property(field, value, params);
};
/**
 * Turn a string into capitalized dash-case
 * @internal used by `Property#toString()`
 * @param  {String} value
 * @return {String}
 * @ignore
 */ function $ffd0277a2b104837$var$capitalDashCase(value) {
    return value.replace(/([A-Z])/g, '-$1').toUpperCase();
}
/**
 * Property prototype
 * @type {Object}
 */ $ffd0277a2b104837$var$Property.prototype = {
    constructor: $ffd0277a2b104837$var$Property,
    /**
   * Check whether the property is of a given type
   * @param  {String}  type
   * @return {Boolean}
   */ is: function(type) {
        type = (type + '').toLowerCase();
        return Array.isArray(this.type) ? this.type.indexOf(type) >= 0 : this.type === type;
    },
    /**
   * Check whether the property is empty
   * @return {Boolean}
   */ isEmpty: function() {
        return this._data == null && Object.keys(this).length === 0;
    },
    /**
   * Clone the property
   * @return {Property}
   */ clone: function() {
        return new $ffd0277a2b104837$var$Property(this._field, this._data, this);
    },
    /**
   * Format the property as vcf with given version
   * @param  {String} version
   * @return {String}
   */ toString: function(version) {
        var propName = (this.group ? this.group + '.' : '') + $ffd0277a2b104837$var$capitalDashCase(this._field);
        var keys = Object.keys(this);
        var params = [];
        for(var i = 0; i < keys.length; i++){
            if (keys[i] === 'group') continue;
            switch(propName){
                case 'TEL':
                case 'ADR':
                case 'EMAIL':
                    if (version === '2.1') {
                        if (Array.isArray(this[keys[i]])) params.push(this[keys[i]].join(';'));
                        else params.push(this[keys[i]]);
                    } else params.push($ffd0277a2b104837$var$capitalDashCase(keys[i]) + '=' + this[keys[i]]);
                    break;
                default:
                    params.push($ffd0277a2b104837$var$capitalDashCase(keys[i]) + '=' + this[keys[i]]);
            }
        }
        if (version === '2.1' || version === '3.0') return propName + (params.length ? ';' + params.join(';').toUpperCase() : params.toString().toUpperCase()) + ':' + (Array.isArray(this._data) ? this._data.join(';') : this._data);
        else return propName + (params.length ? ';' + params.join(';') : params) + ':' + (Array.isArray(this._data) ? this._data.join(';') : this._data);
    },
    /**
   * Get the property's value
   * @return {String}
   */ valueOf: function() {
        return this._data;
    },
    /**
   * Format the property as jCard data
   * @return {Array}
   */ toJSON: function() {
        var params = Object.assign({}, this);
        if (params.value === 'text') {
            params.value = void 0;
            delete params.value;
        }
        var data = [
            this._field,
            params,
            this.value || 'text'
        ];
        switch(this._field){
            default:
                data.push(this._data);
                break;
            case 'adr':
            case 'n':
                data.push(this._data.split(';'));
        }
        return data;
    }
};
// Exports
module.exports = $ffd0277a2b104837$var$Property;

});


var $2867b35b7a77a433$exports = {};
"use strict";
Object.defineProperty($2867b35b7a77a433$exports, "__esModule", {
    value: true
});

var $ceFTv = parcelRequire("ceFTv");

$ceFTv.__exportStar((parcelRequire("iAslr")), $2867b35b7a77a433$exports);

$ceFTv.__exportStar((parcelRequire("fP3qc")), $2867b35b7a77a433$exports);



var $a2E6i = parcelRequire("a2E6i");
var $44580a92b304de9d$exports = {};
"use strict";
Object.defineProperty($44580a92b304de9d$exports, "__esModule", {
    value: true
});
$44580a92b304de9d$exports.Fragment = $44580a92b304de9d$exports.jsxDEV = $44580a92b304de9d$exports.jsxs = void 0;
$44580a92b304de9d$exports.jsx = $44580a92b304de9d$var$jsx;

var $ceFTv = parcelRequire("ceFTv");

var $ar3s2 = parcelRequire("ar3s2");

var $iAslr = parcelRequire("iAslr");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $44580a92b304de9d$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === 'function' && (0, $ar3s2.isHTMLElementClass)(type)) type = (0, $ar3s2.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $iAslr.VNode(node) : node === 0 || node ? new $iAslr.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === 'string' ? new $iAslr.VNode($ceFTv.__assign($ceFTv.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($ceFTv.__assign($ceFTv.__assign({}, commonProps), props));
}
$44580a92b304de9d$exports.jsxs = $44580a92b304de9d$var$jsx;
$44580a92b304de9d$exports.jsxDEV = $44580a92b304de9d$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $44580a92b304de9d$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $iAslr.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $ar3s2.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$44580a92b304de9d$exports.Fragment = $44580a92b304de9d$var$Fragment;



var $ceFTv = parcelRequire("ceFTv");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0268acc93e67b930$var$t = globalThis, $0268acc93e67b930$export$b4d10f6001c083c2 = $0268acc93e67b930$var$t.ShadowRoot && (void 0 === $0268acc93e67b930$var$t.ShadyCSS || $0268acc93e67b930$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $0268acc93e67b930$var$s = Symbol(), $0268acc93e67b930$var$o = new WeakMap;
class $0268acc93e67b930$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $0268acc93e67b930$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($0268acc93e67b930$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $0268acc93e67b930$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $0268acc93e67b930$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $0268acc93e67b930$export$8d80f9cac07cdb3 = (t)=>new $0268acc93e67b930$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $0268acc93e67b930$var$s), $0268acc93e67b930$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $0268acc93e67b930$export$505d1e8739bad805(o, t, $0268acc93e67b930$var$s);
}, $0268acc93e67b930$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($0268acc93e67b930$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $0268acc93e67b930$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $0268acc93e67b930$export$ee69dfd951e24778 = $0268acc93e67b930$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $0268acc93e67b930$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $67bf2f689afe545b$var$i, defineProperty: $67bf2f689afe545b$var$e, getOwnPropertyDescriptor: $67bf2f689afe545b$var$r, getOwnPropertyNames: $67bf2f689afe545b$var$h, getOwnPropertySymbols: $67bf2f689afe545b$var$o, getPrototypeOf: $67bf2f689afe545b$var$n } = Object, $67bf2f689afe545b$var$a = globalThis, $67bf2f689afe545b$var$c = $67bf2f689afe545b$var$a.trustedTypes, $67bf2f689afe545b$var$l = $67bf2f689afe545b$var$c ? $67bf2f689afe545b$var$c.emptyScript : "", $67bf2f689afe545b$var$p = $67bf2f689afe545b$var$a.reactiveElementPolyfillSupport, $67bf2f689afe545b$var$d = (t, s)=>t, $67bf2f689afe545b$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $67bf2f689afe545b$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $67bf2f689afe545b$export$53a6892c50694894 = (t, s)=>!$67bf2f689afe545b$var$i(t, s), $67bf2f689afe545b$var$y = {
    attribute: !0,
    type: String,
    converter: $67bf2f689afe545b$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $67bf2f689afe545b$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $67bf2f689afe545b$var$a.litPropertyMetadata ??= new WeakMap;
class $67bf2f689afe545b$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $67bf2f689afe545b$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $67bf2f689afe545b$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $67bf2f689afe545b$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $67bf2f689afe545b$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($67bf2f689afe545b$var$d("elementProperties"))) return;
        const t = $67bf2f689afe545b$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($67bf2f689afe545b$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($67bf2f689afe545b$var$d("properties"))) {
            const t = this.properties, s = [
                ...$67bf2f689afe545b$var$h(t),
                ...$67bf2f689afe545b$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $0268acc93e67b930$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $0268acc93e67b930$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $0268acc93e67b930$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $67bf2f689afe545b$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $67bf2f689afe545b$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $67bf2f689afe545b$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$67bf2f689afe545b$export$c7c07a37856565d.elementStyles = [], $67bf2f689afe545b$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $67bf2f689afe545b$export$c7c07a37856565d[$67bf2f689afe545b$var$d("elementProperties")] = new Map, $67bf2f689afe545b$export$c7c07a37856565d[$67bf2f689afe545b$var$d("finalized")] = new Map, $67bf2f689afe545b$var$p?.({
    ReactiveElement: $67bf2f689afe545b$export$c7c07a37856565d
}), ($67bf2f689afe545b$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1182a8bbea75578f$var$t = globalThis, $1182a8bbea75578f$var$i = $1182a8bbea75578f$var$t.trustedTypes, $1182a8bbea75578f$var$s = $1182a8bbea75578f$var$i ? $1182a8bbea75578f$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $1182a8bbea75578f$var$e = "$lit$", $1182a8bbea75578f$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $1182a8bbea75578f$var$o = "?" + $1182a8bbea75578f$var$h, $1182a8bbea75578f$var$n = `<${$1182a8bbea75578f$var$o}>`, $1182a8bbea75578f$var$r = document, $1182a8bbea75578f$var$l = ()=>$1182a8bbea75578f$var$r.createComment(""), $1182a8bbea75578f$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $1182a8bbea75578f$var$a = Array.isArray, $1182a8bbea75578f$var$u = (t)=>$1182a8bbea75578f$var$a(t) || "function" == typeof t?.[Symbol.iterator], $1182a8bbea75578f$var$d = "[ \t\n\f\r]", $1182a8bbea75578f$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $1182a8bbea75578f$var$v = /-->/g, $1182a8bbea75578f$var$_ = />/g, $1182a8bbea75578f$var$m = RegExp(`>|${$1182a8bbea75578f$var$d}(?:([^\\s"'>=/]+)(${$1182a8bbea75578f$var$d}*=${$1182a8bbea75578f$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $1182a8bbea75578f$var$p = /'/g, $1182a8bbea75578f$var$g = /"/g, $1182a8bbea75578f$var$$ = /^(?:script|style|textarea|title)$/i, $1182a8bbea75578f$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $1182a8bbea75578f$export$c0bb0b647f701bb5 = $1182a8bbea75578f$var$y(1), $1182a8bbea75578f$export$7ed1367e7fa1ad68 = $1182a8bbea75578f$var$y(2), $1182a8bbea75578f$export$47d5b44d225be5b4 = $1182a8bbea75578f$var$y(3), $1182a8bbea75578f$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $1182a8bbea75578f$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $1182a8bbea75578f$var$A = new WeakMap, $1182a8bbea75578f$var$C = $1182a8bbea75578f$var$r.createTreeWalker($1182a8bbea75578f$var$r, 129);
function $1182a8bbea75578f$var$P(t, i) {
    if (!$1182a8bbea75578f$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $1182a8bbea75578f$var$s ? $1182a8bbea75578f$var$s.createHTML(i) : i;
}
const $1182a8bbea75578f$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $1182a8bbea75578f$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $1182a8bbea75578f$var$f ? "!--" === u[1] ? c = $1182a8bbea75578f$var$v : void 0 !== u[1] ? c = $1182a8bbea75578f$var$_ : void 0 !== u[2] ? ($1182a8bbea75578f$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $1182a8bbea75578f$var$m) : void 0 !== u[3] && (c = $1182a8bbea75578f$var$m) : c === $1182a8bbea75578f$var$m ? ">" === u[0] ? (c = r ?? $1182a8bbea75578f$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $1182a8bbea75578f$var$m : '"' === u[3] ? $1182a8bbea75578f$var$g : $1182a8bbea75578f$var$p) : c === $1182a8bbea75578f$var$g || c === $1182a8bbea75578f$var$p ? c = $1182a8bbea75578f$var$m : c === $1182a8bbea75578f$var$v || c === $1182a8bbea75578f$var$_ ? c = $1182a8bbea75578f$var$f : (c = $1182a8bbea75578f$var$m, r = void 0);
        const x = c === $1182a8bbea75578f$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $1182a8bbea75578f$var$f ? s + $1182a8bbea75578f$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $1182a8bbea75578f$var$e + s.slice(d) + $1182a8bbea75578f$var$h + x) : s + $1182a8bbea75578f$var$h + (-2 === d ? i : x);
    }
    return [
        $1182a8bbea75578f$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $1182a8bbea75578f$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $1182a8bbea75578f$var$V(t, s);
        if (this.el = $1182a8bbea75578f$var$N.createElement(f, n), $1182a8bbea75578f$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $1182a8bbea75578f$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($1182a8bbea75578f$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($1182a8bbea75578f$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $1182a8bbea75578f$var$H : "?" === e[1] ? $1182a8bbea75578f$var$I : "@" === e[1] ? $1182a8bbea75578f$var$L : $1182a8bbea75578f$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($1182a8bbea75578f$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($1182a8bbea75578f$var$$.test(r.tagName)) {
                    const t = r.textContent.split($1182a8bbea75578f$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $1182a8bbea75578f$var$i ? $1182a8bbea75578f$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $1182a8bbea75578f$var$l()), $1182a8bbea75578f$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $1182a8bbea75578f$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $1182a8bbea75578f$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($1182a8bbea75578f$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $1182a8bbea75578f$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $1182a8bbea75578f$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $1182a8bbea75578f$var$S(t, i, s = t, e) {
    if (i === $1182a8bbea75578f$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $1182a8bbea75578f$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $1182a8bbea75578f$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $1182a8bbea75578f$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $1182a8bbea75578f$var$r).importNode(i, !0);
        $1182a8bbea75578f$var$C.currentNode = e;
        let h = $1182a8bbea75578f$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $1182a8bbea75578f$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $1182a8bbea75578f$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $1182a8bbea75578f$var$C.nextNode(), o++);
        }
        return $1182a8bbea75578f$var$C.currentNode = $1182a8bbea75578f$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $1182a8bbea75578f$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $1182a8bbea75578f$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $1182a8bbea75578f$var$S(this, t, i), $1182a8bbea75578f$var$c(t) ? t === $1182a8bbea75578f$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $1182a8bbea75578f$export$45b790e32b2810ee && this._$AR(), this._$AH = $1182a8bbea75578f$export$45b790e32b2810ee) : t !== this._$AH && t !== $1182a8bbea75578f$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $1182a8bbea75578f$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $1182a8bbea75578f$export$45b790e32b2810ee && $1182a8bbea75578f$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($1182a8bbea75578f$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $1182a8bbea75578f$var$N.createElement($1182a8bbea75578f$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $1182a8bbea75578f$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $1182a8bbea75578f$var$A.get(t.strings);
        return void 0 === i && $1182a8bbea75578f$var$A.set(t.strings, i = new $1182a8bbea75578f$var$N(t)), i;
    }
    k(t) {
        $1182a8bbea75578f$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $1182a8bbea75578f$var$R(this.O($1182a8bbea75578f$var$l()), this.O($1182a8bbea75578f$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $1182a8bbea75578f$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $1182a8bbea75578f$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $1182a8bbea75578f$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $1182a8bbea75578f$var$S(this, t, i, 0), o = !$1182a8bbea75578f$var$c(t) || t !== this._$AH && t !== $1182a8bbea75578f$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $1182a8bbea75578f$var$S(this, e[s + n], i, n), r === $1182a8bbea75578f$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$1182a8bbea75578f$var$c(r) || r !== this._$AH[n], r === $1182a8bbea75578f$export$45b790e32b2810ee ? t = $1182a8bbea75578f$export$45b790e32b2810ee : t !== $1182a8bbea75578f$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $1182a8bbea75578f$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $1182a8bbea75578f$var$H extends $1182a8bbea75578f$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $1182a8bbea75578f$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $1182a8bbea75578f$var$I extends $1182a8bbea75578f$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $1182a8bbea75578f$export$45b790e32b2810ee);
    }
}
class $1182a8bbea75578f$var$L extends $1182a8bbea75578f$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $1182a8bbea75578f$var$S(this, t, i, 0) ?? $1182a8bbea75578f$export$45b790e32b2810ee) === $1182a8bbea75578f$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $1182a8bbea75578f$export$45b790e32b2810ee && s !== $1182a8bbea75578f$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $1182a8bbea75578f$export$45b790e32b2810ee && (s === $1182a8bbea75578f$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $1182a8bbea75578f$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $1182a8bbea75578f$var$S(this, t);
    }
}
const $1182a8bbea75578f$export$8613d1ca9052b22e = {
    M: $1182a8bbea75578f$var$e,
    P: $1182a8bbea75578f$var$h,
    A: $1182a8bbea75578f$var$o,
    C: 1,
    L: $1182a8bbea75578f$var$V,
    R: $1182a8bbea75578f$var$M,
    D: $1182a8bbea75578f$var$u,
    V: $1182a8bbea75578f$var$S,
    I: $1182a8bbea75578f$var$R,
    H: $1182a8bbea75578f$var$k,
    N: $1182a8bbea75578f$var$I,
    U: $1182a8bbea75578f$var$L,
    B: $1182a8bbea75578f$var$H,
    F: $1182a8bbea75578f$var$z
}, $1182a8bbea75578f$var$j = $1182a8bbea75578f$var$t.litHtmlPolyfillSupport;
$1182a8bbea75578f$var$j?.($1182a8bbea75578f$var$N, $1182a8bbea75578f$var$R), ($1182a8bbea75578f$var$t.litHtmlVersions ??= []).push("3.2.1");
const $1182a8bbea75578f$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $1182a8bbea75578f$var$R(i.insertBefore($1182a8bbea75578f$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $d7ae2122416faf05$export$3f2f9f5909897157 extends (0, $67bf2f689afe545b$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const s = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $1182a8bbea75578f$export$b3890eb0ae9dca99)(s, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
    }
}
$d7ae2122416faf05$export$3f2f9f5909897157._$litElement$ = !0, $d7ae2122416faf05$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $d7ae2122416faf05$export$3f2f9f5909897157
});
const $d7ae2122416faf05$var$i = globalThis.litElementPolyfillSupport;
$d7ae2122416faf05$var$i?.({
    LitElement: $d7ae2122416faf05$export$3f2f9f5909897157
});
const $d7ae2122416faf05$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e9e0fbd595279cd7$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6eca265e3a72f146$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $acf573f6c2910992$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $67bf2f689afe545b$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $67bf2f689afe545b$export$53a6892c50694894)
}, $acf573f6c2910992$export$8d623b1670eb40f4 = (t = $acf573f6c2910992$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $acf573f6c2910992$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $acf573f6c2910992$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $81aad1feed252031$export$ca000e230c0caa3e(r) {
    return (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $830a3847e122411d$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9b255c0a7142f8f7$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $03ce58f7638eee56$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $79eb9c68ac24f475$var$e;
function $79eb9c68ac24f475$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($79eb9c68ac24f475$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b42730e79cfcbab4$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fd9f04ee645bb4e0$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $aa8cbb37243d3606$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $9b255c0a7142f8f7$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}






/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $dc08001cbc3c8af5$var$t } = (0, $1182a8bbea75578f$export$8613d1ca9052b22e), $dc08001cbc3c8af5$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $dc08001cbc3c8af5$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $dc08001cbc3c8af5$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $dc08001cbc3c8af5$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $dc08001cbc3c8af5$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $dc08001cbc3c8af5$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $dc08001cbc3c8af5$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $dc08001cbc3c8af5$var$s = ()=>document.createComment(""), $dc08001cbc3c8af5$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($dc08001cbc3c8af5$var$s(), l), c = e.insertBefore($dc08001cbc3c8af5$var$s(), l);
        n = new $dc08001cbc3c8af5$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $dc08001cbc3c8af5$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $dc08001cbc3c8af5$var$u = {}, $dc08001cbc3c8af5$export$ea70d9dd5965b1c8 = (o, t = $dc08001cbc3c8af5$var$u)=>o._$AH = t, $dc08001cbc3c8af5$export$59e9bce518cde500 = (o)=>o._$AH, $dc08001cbc3c8af5$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $dc08001cbc3c8af5$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7f965b17d718bf91$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $7f965b17d718bf91$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $7f965b17d718bf91$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $044d98491ba33eb0$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $044d98491ba33eb0$var$s(i, t);
    return !0;
}, $044d98491ba33eb0$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $044d98491ba33eb0$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $044d98491ba33eb0$var$c(t);
    }
};
function $044d98491ba33eb0$var$h(i) {
    void 0 !== this._$AN ? ($044d98491ba33eb0$var$o(this), this._$AM = i, $044d98491ba33eb0$var$r(this)) : this._$AM = i;
}
function $044d98491ba33eb0$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$044d98491ba33eb0$var$s(r[i], !1), $044d98491ba33eb0$var$o(r[i]);
            else null != r && ($044d98491ba33eb0$var$s(r, !1), $044d98491ba33eb0$var$o(r));
        } else $044d98491ba33eb0$var$s(this, i);
    }
}
const $044d98491ba33eb0$var$c = (i)=>{
    i.type == (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $044d98491ba33eb0$var$n, i._$AQ ??= $044d98491ba33eb0$var$h);
};
class $044d98491ba33eb0$export$7d025501802325e extends (0, $7f965b17d718bf91$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $044d98491ba33eb0$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($044d98491ba33eb0$var$s(this, i), $044d98491ba33eb0$var$o(this));
    }
    setValue(t) {
        if ((0, $dc08001cbc3c8af5$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f322d22fead4969a$export$7d1e3a5e95ceca43 = ()=>new $f322d22fead4969a$var$h;
class $f322d22fead4969a$var$h {
}
const $f322d22fead4969a$var$o = new WeakMap, $f322d22fead4969a$export$eff4d24c3ff7876e = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)(class extends (0, $044d98491ba33eb0$export$7d025501802325e) {
    render(i) {
        return 0, $1182a8bbea75578f$export$45b790e32b2810ee;
    }
    update(i, [s]) {
        const e = s !== this.Y;
        return e && void 0 !== this.Y && this.rt(void 0), (e || this.lt !== this.ct) && (this.Y = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $1182a8bbea75578f$export$45b790e32b2810ee;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $f322d22fead4969a$var$o.get(i);
            void 0 === s && (s = new WeakMap, $f322d22fead4969a$var$o.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $f322d22fead4969a$var$o.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});





class $53a1aafae9c6752a$export$9bb0a9faa319390c extends (0, $d7ae2122416faf05$export$3f2f9f5909897157) {
    /**
     * 触发自定义事件。若返回 false，表示事件被取消
     * @param type
     * @param options 通常只用到 cancelable 和 detail；bubbles、composed 统一不用
     */ emit(type, options) {
        const event = new CustomEvent(type, Object.assign({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        return this.dispatchEvent(event);
    }
}


/**
 * 在原生的 HTML 中，布尔属性只要添加了属性名，不论属性值设置成什么，属性值都是 true
 * 但这里设置了 attr="false" 时，要把属性设置为 false
 *
 * 原因是：
 * 在 vue3 中，通过 :attr="value" 设置属性时，vue 会优先从 DOM 属性中寻找是否存在 attr 属性名，
 * 若存在，则设置对应的 DOM 属性，否则设置对应的 attribute 属性
 * 但在 vue 的服务端渲染（ssr）时，不存在 DOM 对象，所以会把 attribute 属性设置成 attr="true" 或 attr="false"
 * 所以在 attribute 属性 attr="false" 时，需要把属性值转换为布尔值 false
 *
 * 在 CSS 中选择布尔属性时，必须排除掉属性值为 false 的情况。i 表示不区分大小写。仅 public 属性需要这样处理，private 和 protected 属性不需要
 * 例如：:host([hide]:not([hide="false" i])) { ... }
 *
 * 这段代码不能封装成函数，否则生成 custom-elements.json 会识别不了
 * 这段注释仅在这里写一次，其他地方不再重复
 *
 * @see https://v3-migration.vuejs.org/zh/breaking-changes/attribute-coercion.html
 */ const $9f4de283a23bd2a5$export$2aee1c8d7bab360b = (value)=>{
    return value !== null && value.toLowerCase() !== 'false';
};



const $a1095454894349c1$export$7ef977f86985f711 = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{box-sizing:border-box}:host *,:host ::after,:host ::before{box-sizing:inherit}:host :focus,:host :focus-visible,:host(:focus),:host(:focus-visible){outline:0}[hidden]{display:none!important}`;



var $ceFTv = parcelRequire("ceFTv");



/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $dd2a3999053fa8a1$export$f68dd208b5df064d = (o)=>o ?? (0, $1182a8bbea75578f$export$45b790e32b2810ee);




const $127a23c52a5adf4f$export$e70f90f657dd64e = (superclass)=>{
    class AnchorMixinClass extends superclass {
        renderAnchor({ id: id, className: className, part: part, content: content = (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>`, refDirective: refDirective, tabIndex: tabIndex }) {
            return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<a ${refDirective} id="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(id)}" class="_a ${className ? className : ''}" part="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(part)}" href="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.href)}" download="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.download)}" target="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.target)}" rel="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.rel)}" tabindex="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(tabIndex)}">${content}</a>`;
        }
    }
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            reflect: true
        })
    ], AnchorMixinClass.prototype, "href", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            reflect: true
        })
    ], AnchorMixinClass.prototype, "download", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            reflect: true
        })
    ], AnchorMixinClass.prototype, "target", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            reflect: true
        })
    ], AnchorMixinClass.prototype, "rel", void 0);
    return AnchorMixinClass;
};



var $ceFTv = parcelRequire("ceFTv");

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $c87de1375632dba4$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $c87de1375632dba4$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($c87de1375632dba4$var$isObject(src[key]) && $c87de1375632dba4$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $c87de1375632dba4$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $c87de1375632dba4$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $c87de1375632dba4$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $c87de1375632dba4$export$8b58be045bf06082(doc, $c87de1375632dba4$export$3fdcb9b4d81368d8);
    return doc;
}
const $c87de1375632dba4$export$8582633f185c62bb = {
    document: $c87de1375632dba4$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $c87de1375632dba4$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $c87de1375632dba4$export$8b58be045bf06082(win, $c87de1375632dba4$export$8582633f185c62bb);
    return win;
}



/**
 * 获取指定元素的标签名（小写），不存在元素的返回空字符串
 * @param element
 */ const $d0cded150def05db$export$651544f548703224 = (element)=>{
    return element?.nodeName.toLowerCase() ?? '';
};
const $d0cded150def05db$export$40bcf76e2c1becc2 = (element, name)=>{
    return element?.nodeName.toLowerCase() === name.toLowerCase();
};
const $d0cded150def05db$export$f6e2535fb5126e54 = (target)=>{
    return typeof target === 'function';
};
const $d0cded150def05db$export$844ec244b1367d54 = (target)=>{
    return typeof target === 'string';
};
const $d0cded150def05db$export$7e4aa119212bc614 = (target)=>{
    return typeof target === 'number';
};
const $d0cded150def05db$export$f9ce7b637dfbe238 = (target)=>{
    return typeof target === 'boolean';
};
const $d0cded150def05db$export$fce6876652108ab = (target)=>{
    return typeof target === 'undefined';
};
const $d0cded150def05db$export$630801d484da15df = (target)=>{
    return target === null;
};
const $d0cded150def05db$export$5a096129d439f843 = (target)=>{
    return typeof Window !== 'undefined' && target instanceof Window;
};
const $d0cded150def05db$export$62858bae88b53fd0 = (target)=>{
    return typeof Document !== 'undefined' && target instanceof Document;
};
const $d0cded150def05db$export$45a5e7f76e0caa8d = (target)=>{
    return typeof Element !== 'undefined' && target instanceof Element;
};
const $d0cded150def05db$export$8ee0fc9ee280b4ee = (target)=>{
    return typeof Node !== 'undefined' && target instanceof Node;
};
const $d0cded150def05db$export$1e2f57719e155213 = (target)=>{
    return !$d0cded150def05db$export$f6e2535fb5126e54(target) && !$d0cded150def05db$export$5a096129d439f843(target) && $d0cded150def05db$export$7e4aa119212bc614(target.length);
};
const $d0cded150def05db$export$c10d0b04eaa80a43 = (target)=>{
    return typeof target === 'object' && target !== null;
};
const $d0cded150def05db$export$8d51e3db1a844094 = (target)=>{
    return $d0cded150def05db$export$62858bae88b53fd0(target) ? target.documentElement : target;
};
const $d0cded150def05db$export$86f54f62aa7a7514 = (string)=>{
    return string.replace(/-([a-z])/g, (_, letter)=>{
        return letter.toUpperCase();
    });
};
const $d0cded150def05db$export$73bda83cddbc7187 = (string)=>{
    if (!string) return string;
    return string.replace(/^./, string[0].toLowerCase()) // 首字母转小写
    .replace(/[A-Z]/g, (replacer)=>{
        return '-' + replacer.toLowerCase();
    });
};
const $d0cded150def05db$export$35d6da1a7e941e79 = ()=>{
    return false;
};
const $d0cded150def05db$export$8a16822a2b63cb79 = ()=>{
    return true;
};
const $d0cded150def05db$export$211b8db791997e25 = (target, callback)=>{
    for(let i = 0; i < target.length; i += 1){
        if (callback.call(target[i], target[i], i) === false) return target;
    }
    return target;
};
const $d0cded150def05db$export$1b8ac1d3a07c9372 = (target, callback)=>{
    const keys = Object.keys(target);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (callback.call(target[key], key, target[key]) === false) return target;
    }
    return target;
};


class $6175daf4c02230d4$export$af7f3c1d59036499 {
    constructor(arr){
        this.length = 0;
        if (!arr) return this;
        (0, $d0cded150def05db$export$211b8db791997e25)(arr, (item, i)=>{
            this[i] = item;
        });
        this.length = arr.length;
        return this;
    }
}



const $f94b048e0ef94ba5$export$37e2077ccaabdaf6 = (document = (0, $c87de1375632dba4$export$f65ca476c09acec0)())=>{
    return /complete|interactive/.test(document.readyState);
};
const $f94b048e0ef94ba5$export$c8a8987d4410bf2d = (tagName)=>{
    const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
    return document.createElement(tagName);
};
const $f94b048e0ef94ba5$export$1b8e57c9ea42f1d2 = (element, child)=>{
    return element.appendChild(child);
};
const $f94b048e0ef94ba5$export$7ae609f7af59e4f7 = (element)=>{
    return element.parentNode ? element.parentNode.removeChild(element) : element;
};
const $f94b048e0ef94ba5$export$ddad7c9cfa637961 = (target, parent)=>{
    const tempParent = $f94b048e0ef94ba5$export$c8a8987d4410bf2d(parent);
    tempParent.innerHTML = target;
    return [].slice.call(tempParent.childNodes);
};



const $b95421a1db56b097$var$get$ = ()=>{
    const $ = function(selector) {
        if (!selector) return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)();
        // JQ
        if (selector instanceof (0, $6175daf4c02230d4$export$af7f3c1d59036499)) return selector;
        // function
        if ((0, $d0cded150def05db$export$f6e2535fb5126e54)(selector)) {
            const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
            if ((0, $f94b048e0ef94ba5$export$37e2077ccaabdaf6)(document)) selector.call(document, $);
            else document.addEventListener('DOMContentLoaded', ()=>selector.call(document, $), {
                once: true
            });
            return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)([
                document
            ]);
        }
        // String
        if ((0, $d0cded150def05db$export$844ec244b1367d54)(selector)) {
            const html = selector.trim();
            // 根据 HTML 字符串创建 JQ 对象
            if (html.startsWith('<') && html.endsWith('>')) {
                let toCreate = 'div';
                const tags = {
                    li: 'ul',
                    tr: 'tbody',
                    td: 'tr',
                    th: 'tr',
                    tbody: 'table',
                    option: 'select'
                };
                (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(tags, (childTag, parentTag)=>{
                    if (html.startsWith(`<${childTag}`)) {
                        toCreate = parentTag;
                        return false;
                    }
                    return;
                });
                return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)((0, $f94b048e0ef94ba5$export$ddad7c9cfa637961)(html, toCreate));
            }
            const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
            // 根据 CSS 选择器创建 JQ 对象
            return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)(document.querySelectorAll(selector));
        }
        if ((0, $d0cded150def05db$export$1e2f57719e155213)(selector) && !(0, $d0cded150def05db$export$8ee0fc9ee280b4ee)(selector)) return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)(selector);
        return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)([
            selector
        ]);
    };
    $.fn = (0, $6175daf4c02230d4$export$af7f3c1d59036499).prototype;
    return $;
};
const $b95421a1db56b097$export$3d8c2f653ac9d0b9 = $b95421a1db56b097$var$get$();




const $93c84b873bab7bc6$export$735ee1799fd02602 = (element, key, defaultValue)=>{
    const value = element.getAttribute(key);
    return (0, $d0cded150def05db$export$630801d484da15df)(value) ? defaultValue : value;
};
const $93c84b873bab7bc6$export$6399f3bb52316b2c = (element, key)=>{
    element.removeAttribute(key);
};
const $93c84b873bab7bc6$export$9fec4d97f1922e0b = (element, key, value)=>{
    (0, $d0cded150def05db$export$630801d484da15df)(value) ? $93c84b873bab7bc6$export$6399f3bb52316b2c(element, key) : element.setAttribute(key, value);
};




const $0caf6a5c58ee85f9$export$8279eff504af5afb = (element, name)=>{
    const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
    return window.getComputedStyle(element).getPropertyValue((0, $d0cded150def05db$export$73bda83cddbc7187)(name));
};
const $0caf6a5c58ee85f9$export$78bc5c0ac316e909 = (element)=>{
    return $0caf6a5c58ee85f9$export$8279eff504af5afb(element, 'box-sizing') === 'border-box';
};
const $0caf6a5c58ee85f9$export$31fae7b1c9494af1 = (element, direction, extra)=>{
    const position = direction === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    return [
        0,
        1
    ].reduce((prev, _, index)=>{
        let prop = extra + position[index];
        if (extra === 'border') prop += 'Width';
        return prev + parseFloat($0caf6a5c58ee85f9$export$8279eff504af5afb(element, prop) || '0');
    }, 0);
};
const $0caf6a5c58ee85f9$export$3d2f074408bd1b82 = (element, name)=>{
    // width、height 属性使用 getComputedStyle 得到的值不准确，需要使用 getBoundingClientRect 获取
    if (name === 'width' || name === 'height') {
        const valueNumber = element.getBoundingClientRect()[name];
        if ($0caf6a5c58ee85f9$export$78bc5c0ac316e909(element)) return `${valueNumber}px`;
        return `${valueNumber - $0caf6a5c58ee85f9$export$31fae7b1c9494af1(element, name, 'border') - $0caf6a5c58ee85f9$export$31fae7b1c9494af1(element, name, 'padding')}px`;
    }
    return $0caf6a5c58ee85f9$export$8279eff504af5afb(element, name);
};
const $0caf6a5c58ee85f9$export$7914d752ca654669 = [
    'animation-iteration-count',
    'column-count',
    'fill-opacity',
    'flex-grow',
    'flex-shrink',
    'font-weight',
    'grid-area',
    'grid-column',
    'grid-column-end',
    'grid-column-start',
    'grid-row',
    'grid-row-end',
    'grid-row-start',
    'line-height',
    'opacity',
    'order',
    'orphans',
    'widows',
    'z-index',
    'zoom'
];





// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.each = function(callback) {
    return (0, $d0cded150def05db$export$211b8db791997e25)(this, (value, index)=>{
        return callback.call(value, index, value);
    });
};


(0, $d0cded150def05db$export$211b8db791997e25)([
    'attr',
    'prop',
    'css'
], (name, nameIndex)=>{
    // eslint-disable-next-line
    const set = (element, key, value)=>{
        // 值为 undefined 时，不修改
        if ((0, $d0cded150def05db$export$fce6876652108ab)(value)) return;
        // attr
        if (nameIndex === 0) return (0, $93c84b873bab7bc6$export$9fec4d97f1922e0b)(element, key, value);
        // prop
        if (nameIndex === 1) {
            // @ts-ignore
            element[key] = value;
            return;
        }
        // css
        key = (0, $d0cded150def05db$export$73bda83cddbc7187)(key);
        // 获取默认后缀。以 -- 开头的为 CSS 变量，不添加后缀；值为数值类型的不添加后缀
        const getSuffix = ()=>key.startsWith('--') || (0, $0caf6a5c58ee85f9$export$7914d752ca654669).includes(key) ? '' : 'px';
        element.style.setProperty(key, (0, $d0cded150def05db$export$7e4aa119212bc614)(value) ? `${value}${getSuffix()}` : value);
    };
    // eslint-disable-next-line
    const get = (element, key)=>{
        // attr
        if (nameIndex === 0) // 属性不存在时，原生 getAttribute 方法返回 null，而 jquery 返回 undefined。这里和 jquery 保持一致
        return (0, $93c84b873bab7bc6$export$735ee1799fd02602)(element, key);
        // prop
        if (nameIndex === 1) // @ts-ignore
        return element[key];
        return (0, $0caf6a5c58ee85f9$export$3d2f074408bd1b82)(element, key);
    };
    (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[name] = function(key, // eslint-disable-next-line
    value) {
        if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(key)) {
            (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(key, (k, v)=>{
                // @ts-ignore
                this[name](k, v);
            });
            return this;
        }
        if (arguments.length === 1) {
            const element = this[0];
            return (0, $d0cded150def05db$export$45a5e7f76e0caa8d)(element) ? get(element, key) : undefined;
        }
        return this.each((i, element)=>{
            set(element, key, (0, $d0cded150def05db$export$f6e2535fb5126e54)(value) ? value.call(element, i, get(element, key)) : value);
        });
    };
});










(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.removeAttr = function(attributeName) {
    const names = attributeName.split(' ').filter((name)=>name);
    return this.each(function() {
        (0, $d0cded150def05db$export$211b8db791997e25)(names, (name)=>{
            (0, $93c84b873bab7bc6$export$6399f3bb52316b2c)(this, name);
        });
    });
};



/**
 * 过滤掉数组中的重复元素
 * @param arr 数组
 * @example
```js
unique([1, 2, 12, 3, 2, 1, 2, 1, 1]);
// [1, 2, 12, 3]
```
 */ const $8917adc71c53e49d$export$7a5d5c156e7dc406 = (arr)=>{
    return [
        ...new Set(arr)
    ];
};



class $29b950a65aaa366a$export$da3260c7a0861b80 {
    constructor(host, options){
        /**
         * 组件是否已定义完成
         */ this.defined = false;
        (this.host = host).addController(this);
        this.relatedElements = options.relatedElements;
        this.needDomReady = options.needDomReady || !!options.relatedElements;
        this.onSlotChange = this.onSlotChange.bind(this);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener('slotchange', this.onSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener('slotchange', this.onSlotChange);
    }
    /**
     * 判断组件是否定义完成
     */ isDefined() {
        if (this.defined) return true;
        this.defined = (!this.needDomReady || (0, $f94b048e0ef94ba5$export$37e2077ccaabdaf6)()) && !this.getUndefinedLocalNames().length;
        return this.defined;
    }
    /**
     * 在组件定义完成后，promise 被 resolve
     */ async whenDefined() {
        if (this.defined) return Promise.resolve();
        const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
        if (this.needDomReady && !(0, $f94b048e0ef94ba5$export$37e2077ccaabdaf6)(document)) await new Promise((resolve)=>{
            document.addEventListener('DOMContentLoaded', ()=>resolve(), {
                once: true
            });
        });
        const undefinedLocalNames = this.getUndefinedLocalNames();
        if (undefinedLocalNames.length) {
            const promises = [];
            undefinedLocalNames.forEach((localName)=>{
                promises.push(customElements.whenDefined(localName));
            });
            await Promise.all(promises);
        }
        this.defined = true;
        return;
    }
    /**
     * slot 中的未完成定义的相关 Web components 组件的 CSS 选择器
     */ getScopeLocalNameSelector() {
        const localNames = this.relatedElements;
        if (!localNames) return null;
        if (Array.isArray(localNames)) return localNames.map((localName)=>`${localName}:not(:defined)`).join(',');
        return Object.keys(localNames).filter((localName)=>!localNames[localName]).map((localName)=>`${localName}:not(:defined)`).join(',');
    }
    /**
     * 整个页面中的未完成定义的相关 Web components 组件的 CSS 选择器
     */ getGlobalLocalNameSelector() {
        const localNames = this.relatedElements;
        if (!localNames || Array.isArray(localNames)) return null;
        return Object.keys(localNames).filter((localName)=>localNames[localName]).map((localName)=>`${localName}:not(:defined)`).join(',');
    }
    /**
     * 获取未完成定义的相关 Web components 组件名
     */ getUndefinedLocalNames() {
        const scopeSelector = this.getScopeLocalNameSelector();
        const globalSelector = this.getGlobalLocalNameSelector();
        const undefinedScopeElements = scopeSelector ? [
            ...this.host.querySelectorAll(scopeSelector)
        ] : [];
        const undefinedGlobalElements = globalSelector ? [
            ...(0, $c87de1375632dba4$export$f65ca476c09acec0)().querySelectorAll(globalSelector)
        ] : [];
        const localNames = [
            ...undefinedScopeElements,
            ...undefinedGlobalElements
        ].map((element)=>element.localName);
        return (0, $8917adc71c53e49d$export$7a5d5c156e7dc406)(localNames);
    }
    /**
     * slot 变更时，若 slot 中包含未完成定义的相关 Web components 组件，则组件未定义完成
     */ onSlotChange() {
        const selector = this.getScopeLocalNameSelector();
        if (selector) {
            const undefinedElements = this.host.querySelectorAll(selector);
            if (undefinedElements.length) this.defined = false;
        }
    }
}



let $3bb9ba68ccebecb9$var$isClick = true;
const $3bb9ba68ccebecb9$var$document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
$3bb9ba68ccebecb9$var$document.addEventListener('pointerdown', ()=>{
    $3bb9ba68ccebecb9$var$isClick = true;
});
$3bb9ba68ccebecb9$var$document.addEventListener('keydown', ()=>{
    $3bb9ba68ccebecb9$var$isClick = false;
});
const $3bb9ba68ccebecb9$export$7b86c168e7d309f7 = (superclass)=>{
    class FocusableMixinClass extends superclass {
        constructor(){
            super(...arguments);
            /**
             * 是否在页面加载完成后自动获取焦点
             */ this.autofocus = false;
            /**
             * 是否获得了焦点，不管是鼠标点击，还是键盘切换获得的焦点，都会添加该属性
             * 添加到 :host 元素上，供 CSS 选择器添加样式
             */ this.focused = false;
            /**
             * 是否通过键盘切换获得了焦点
             * 添加到 :host 元素上，供 CSS 选择器添加样式
             */ this.focusVisible = false;
            this.focusableDefinedController = new (0, $29b950a65aaa366a$export$da3260c7a0861b80)(this, {
                relatedElements: [
                    ''
                ]
            });
            this._manipulatingTabindex = false;
            this._tabIndex = 0;
        }
        /**
         * 元素在使用 Tab 键切换焦点时的顺序
         */ get tabIndex() {
            const $this = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this);
            if (this.focusElement === this) return Number($this.attr('tabindex') || -1);
            const tabIndexAttribute = Number($this.attr('tabindex') || 0);
            if (this.focusDisabled || tabIndexAttribute < 0) return -1;
            if (!this.focusElement) return tabIndexAttribute;
            return this.focusElement.tabIndex;
        }
        set tabIndex(tabIndex) {
            if (this._manipulatingTabindex) {
                this._manipulatingTabindex = false;
                return;
            }
            const $this = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this);
            if (this.focusElement === this) {
                if (tabIndex !== null) this._tabIndex = tabIndex;
                $this.attr('tabindex', this.focusDisabled ? null : tabIndex);
                return;
            }
            const onPointerDown = ()=>{
                if (this.tabIndex === -1) {
                    this.tabIndex = 0;
                    this.focus({
                        preventScroll: true
                    });
                }
            };
            if (tabIndex === -1) this.addEventListener('pointerdown', onPointerDown);
            else {
                this._manipulatingTabindex = true;
                this.removeEventListener('pointerdown', onPointerDown);
            }
            if (tabIndex === -1 || this.focusDisabled) {
                $this.attr('tabindex', -1);
                if (tabIndex !== -1) this.manageFocusElementTabindex(tabIndex);
                return;
            }
            if (!this.hasAttribute('tabindex')) this._manipulatingTabindex = false;
            this.manageFocusElementTabindex(tabIndex);
        }
        /**
         * 父类要实现该属性，表示是否禁用 focus 状态
         */ get focusDisabled() {
            throw new Error('Must implement focusDisabled getter!');
        }
        /**
         * 最终获得焦点的元素
         */ get focusElement() {
            throw new Error('Must implement focusElement getter!');
        }
        connectedCallback() {
            super.connectedCallback();
            this.updateComplete.then(()=>{
                requestAnimationFrame(()=>{
                    this.manageAutoFocus();
                });
            });
        }
        /**
         * 模拟鼠标点击元素
         */ click() {
            if (this.focusDisabled) return;
            if (this.focusElement !== this) this.focusElement.click();
            else HTMLElement.prototype.click.apply(this);
        }
        /**
         * 将焦点设置到当前元素。
         *
         * 可以传入一个对象作为参数，该对象的属性包括：
         *
         * * `preventScroll`：默认情况下，元素获取焦点后，页面会滚动以将该元素滚动到视图中。如果不希望页面滚动，可以将此属性设置为 `true`。
         */ focus(options) {
            if (this.focusDisabled || !this.focusElement) return;
            if (this.focusElement !== this) this.focusElement.focus(options);
            else HTMLElement.prototype.focus.apply(this, [
                options
            ]);
        }
        /**
         * 移除当前元素的焦点
         */ blur() {
            if (this.focusElement !== this) this.focusElement.blur();
            else HTMLElement.prototype.blur.apply(this);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.focusElement.addEventListener('focus', ()=>{
                this.focused = true;
                this.focusVisible = !$3bb9ba68ccebecb9$var$isClick;
            });
            this.focusElement.addEventListener('blur', ()=>{
                this.focused = false;
                this.focusVisible = false;
            });
        }
        update(changedProperties) {
            if (this._lastFocusDisabled === undefined || this._lastFocusDisabled !== this.focusDisabled) {
                this._lastFocusDisabled = this.focusDisabled;
                const $this = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this);
                if (this.focusDisabled) $this.removeAttr('tabindex');
                else {
                    if (this.focusElement === this) {
                        this._manipulatingTabindex = true;
                        $this.attr('tabindex', this._tabIndex);
                    } else if (this.tabIndex > -1) $this.removeAttr('tabindex');
                }
            }
            super.update(changedProperties);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (this.focused && this.focusDisabled) this.blur();
        }
        async manageFocusElementTabindex(tabIndex) {
            if (!this.focusElement) await this.updateComplete;
            if (tabIndex === null) this.focusElement.removeAttribute('tabindex');
            else this.focusElement.tabIndex = tabIndex;
        }
        manageAutoFocus() {
            if (this.autofocus) {
                this.dispatchEvent(new KeyboardEvent('keydown', {
                    code: 'Tab'
                }));
                this.focusElement.focus();
            }
        }
    }
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            type: Boolean,
            /**
             * 哪些属性需要 reflect: true？
             * 一般所有属性都需要 reflect，但以下情况除外：
             * 1. 会频繁变更的属性
             * 2. 属性同步会造成较大性能开销的属性
             * 3. 复杂类型属性（数组、对象等，仅提供 property，不提供 attribute）
             */ reflect: true,
            converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
        })
    ], FocusableMixinClass.prototype, "autofocus", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true,
            converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
        })
    ], FocusableMixinClass.prototype, "focused", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true,
            converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
            attribute: 'focus-visible'
        })
    ], FocusableMixinClass.prototype, "focusVisible", void 0);
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            type: Number,
            attribute: 'tabindex'
        })
    ], FocusableMixinClass.prototype, "tabIndex", null);
    return FocusableMixinClass;
};



var $ceFTv = parcelRequire("ceFTv");












// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.is = function(selector) {
    let isMatched = false;
    if ((0, $d0cded150def05db$export$f6e2535fb5126e54)(selector)) {
        this.each((index, element)=>{
            if (selector.call(element, index, element)) isMatched = true;
        });
        return isMatched;
    }
    if ((0, $d0cded150def05db$export$844ec244b1367d54)(selector)) {
        this.each((_, element)=>{
            if ((0, $d0cded150def05db$export$62858bae88b53fd0)(element) || (0, $d0cded150def05db$export$5a096129d439f843)(element)) return;
            if (element.matches.call(element, selector)) isMatched = true;
        });
        return isMatched;
    }
    const $compareWith = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(selector);
    this.each((_, element)=>{
        $compareWith.each((_, compare)=>{
            if (element === compare) isMatched = true;
        });
    });
    return isMatched;
};


(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.children = function(selector) {
    const children = [];
    this.each((_, element)=>{
        (0, $d0cded150def05db$export$211b8db791997e25)(element.childNodes, (childNode)=>{
            if (!(0, $d0cded150def05db$export$45a5e7f76e0caa8d)(childNode)) return;
            if (!selector || (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(childNode).is(selector)) children.push(childNode);
        });
    });
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)((0, $8917adc71c53e49d$export$7a5d5c156e7dc406)(children));
};






(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.slice = function(...args) {
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)([].slice.apply(this, args));
};


(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.eq = function(index) {
    const ret = index === -1 ? this.slice(index) : this.slice(index, +index + 1);
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)(ret);
};



// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.get = function(index) {
    return index === undefined ? [].slice.call(this) : this[index >= 0 ? index : index + this.length];
};











const $bd16f506cea8b6ba$export$147ec2801e896265 = ($elements, nameIndex, node, // eslint-disable-next-line
selector, filter)=>{
    const ret = [];
    let target;
    $elements.each((_, element)=>{
        target = element[node];
        // 不能包含最顶层的 document 元素
        while(target && (0, $d0cded150def05db$export$45a5e7f76e0caa8d)(target)){
            // prevUntil, nextUntil, parentsUntil
            if (nameIndex === 2) {
                if (selector && (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target).is(selector)) break;
                if (!filter || (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target).is(filter)) ret.push(target);
            } else if (nameIndex === 0) {
                if (!selector || (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target).is(selector)) ret.push(target);
                break;
            } else if (!selector || (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target).is(selector)) ret.push(target);
            target = target[node];
        }
    });
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)((0, $8917adc71c53e49d$export$7a5d5c156e7dc406)(ret));
};


(0, $d0cded150def05db$export$211b8db791997e25)([
    '',
    's',
    'sUntil'
], (name, nameIndex)=>{
    (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[`parent${name}`] = function(// eslint-disable-next-line
    selector, filter) {
        // parents、parentsUntil 需要把元素的顺序反向处理，以便和 jQuery 的结果一致
        const $nodes = !nameIndex ? this : (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.get().reverse());
        return (0, $bd16f506cea8b6ba$export$147ec2801e896265)($nodes, nameIndex, 'parentNode', selector, filter);
    };
});


// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.index = function(selector) {
    if (!arguments.length) return this.eq(0).parent().children().get().indexOf(this[0]);
    if ((0, $d0cded150def05db$export$844ec244b1367d54)(selector)) return (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(selector).get().indexOf(this[0]);
    return this.get().indexOf((0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(selector)[0]);
};





var $ceFTv = parcelRequire("ceFTv");




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c9d15c868ac73f05$export$56cc687933817664 = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)(class extends (0, $7f965b17d718bf91$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
    }
});










(0, $d0cded150def05db$export$211b8db791997e25)([
    'add',
    'remove',
    'toggle'
], (name)=>{
    (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[`${name}Class`] = function(className) {
        if (name === 'remove' && !arguments.length) return this.each((_, element)=>{
            (0, $93c84b873bab7bc6$export$9fec4d97f1922e0b)(element, 'class', '');
        });
        return this.each((i, element)=>{
            if (!(0, $d0cded150def05db$export$45a5e7f76e0caa8d)(element)) return;
            const classes = ((0, $d0cded150def05db$export$f6e2535fb5126e54)(className) ? className.call(element, i, (0, $93c84b873bab7bc6$export$735ee1799fd02602)(element, 'class', '')) : className).split(' ').filter((name)=>name);
            (0, $d0cded150def05db$export$211b8db791997e25)(classes, (cls)=>{
                element.classList[name](cls);
            });
        });
    };
});






const $0998345f3fc9bb6a$var$weakMap = new WeakMap();
const $0998345f3fc9bb6a$export$2774c37398bee8b2 = (element)=>{
    return $0998345f3fc9bb6a$var$weakMap.get(element) ?? {};
};
const $0998345f3fc9bb6a$export$3988ae62b71be9a3 = (element, keyOriginal)=>{
    const data = $0998345f3fc9bb6a$export$2774c37398bee8b2(element);
    const key = (0, $d0cded150def05db$export$86f54f62aa7a7514)(keyOriginal);
    return key in data ? data[key] : undefined;
};
const $0998345f3fc9bb6a$export$5c5fa8f869a462 = (element, object)=>{
    const data = $0998345f3fc9bb6a$export$2774c37398bee8b2(element);
    (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(object, (keyOriginal, value)=>{
        data[(0, $d0cded150def05db$export$86f54f62aa7a7514)(keyOriginal)] = value;
    });
    $0998345f3fc9bb6a$var$weakMap.set(element, data);
};
const $0998345f3fc9bb6a$export$adaa4cf7ef1b65be = (element, keyOriginal, value)=>{
    $0998345f3fc9bb6a$export$5c5fa8f869a462(element, {
        [keyOriginal]: value
    });
};
const $0998345f3fc9bb6a$export$1cfc7aad5cb1833b = (element)=>{
    $0998345f3fc9bb6a$var$weakMap.delete(element);
};
const $0998345f3fc9bb6a$export$f5106542ad584215 = (element, keysOriginal)=>{
    const data = $0998345f3fc9bb6a$export$2774c37398bee8b2(element);
    (0, $d0cded150def05db$export$211b8db791997e25)(keysOriginal, (keyOriginal)=>{
        const key = (0, $d0cded150def05db$export$86f54f62aa7a7514)(keyOriginal);
        delete data[key];
    });
    $0998345f3fc9bb6a$var$weakMap.set(element, data);
};
const $0998345f3fc9bb6a$var$rbrace = /^(?:{[\w\W]*\}|\[[\w\W]*\])$/;
/**
 * dataset 中的值读取时进行转换
 * @param value
 */ const $0998345f3fc9bb6a$var$stringTransform = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === 'null') return null;
    if (value === +value + '') return +value;
    if ($0998345f3fc9bb6a$var$rbrace.test(value)) return JSON.parse(value);
    return value;
};
const $0998345f3fc9bb6a$export$5cc3b7b83e34ade7 = (element, key, value)=>{
    if ((0, $d0cded150def05db$export$fce6876652108ab)(value) && element.nodeType === 1) {
        value = element.dataset[key];
        if ((0, $d0cded150def05db$export$844ec244b1367d54)(value)) try {
            value = $0998345f3fc9bb6a$var$stringTransform(value);
        } catch (e) {}
    }
    return value;
};




// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.data = function(key, value) {
    // 获取所有值
    if ((0, $d0cded150def05db$export$fce6876652108ab)(key)) {
        if (!this.length) return undefined;
        const element = this[0];
        const resultData = (0, $0998345f3fc9bb6a$export$2774c37398bee8b2)(element);
        // window, document 上不存在 `dataset`
        if (element.nodeType !== 1) return resultData;
        // 若值未通过 data 方法设置，则从 `dataset` 中获取值。dataset 中读取的 key 会自动转为驼峰法
        (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(element.dataset, (key)=>{
            resultData[key] = (0, $0998345f3fc9bb6a$export$5cc3b7b83e34ade7)(element, key, resultData[key]);
        });
        return resultData;
    }
    // 同时设置多个值
    if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(key)) return this.each(function() {
        (0, $0998345f3fc9bb6a$export$5c5fa8f869a462)(this, key);
    });
    // value 传入了 undefined
    if (arguments.length === 2 && (0, $d0cded150def05db$export$fce6876652108ab)(value)) return this;
    // 设置值
    if (!(0, $d0cded150def05db$export$fce6876652108ab)(value)) return this.each(function() {
        (0, $0998345f3fc9bb6a$export$adaa4cf7ef1b65be)(this, key, value);
    });
    // 获取值
    if (!this.length) return undefined;
    return (0, $0998345f3fc9bb6a$export$5cc3b7b83e34ade7)(this[0], (0, $d0cded150def05db$export$86f54f62aa7a7514)(key), (0, $0998345f3fc9bb6a$export$3988ae62b71be9a3)(this[0], key));
};









function $3de04dbd0bc55081$export$79b2f7037acddd43(target, callback) {
    // eachArray 回调函数是 value, key，这里的 each 函数是 key, value
    return (0, $d0cded150def05db$export$1e2f57719e155213)(target) ? (0, $d0cded150def05db$export$211b8db791997e25)(target, (value, index)=>{
        return callback.call(value, index, value);
    }) : (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(target, callback);
}


function $67dfbc376cd90141$export$871de8747c9eaa88(elements, callback) {
    const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
    let value;
    const ret = [];
    (0, $3de04dbd0bc55081$export$79b2f7037acddd43)(elements, (i, element)=>{
        value = callback.call(window, element, i);
        if (value != null) ret.push(value);
    });
    return [].concat(...ret);
}



// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.map = function(callback) {
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)((0, $67dfbc376cd90141$export$871de8747c9eaa88)(this, (element, i)=>{
        return callback.call(element, i, element);
    }));
};


// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.filter = function(selector) {
    if ((0, $d0cded150def05db$export$f6e2535fb5126e54)(selector)) return this.map((index, element)=>{
        return selector.call(element, index, element) ? element : undefined;
    });
    if ((0, $d0cded150def05db$export$844ec244b1367d54)(selector)) return this.map((_, element)=>{
        return (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element).is(selector) ? element : undefined;
    });
    const $selector = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(selector);
    return this.map((_, element)=>{
        return $selector.get().includes(element) ? element : undefined;
    });
};








/**
 * 值上面的 padding、border、margin 处理
 * @param element
 * @param name
 * @param value
 * @param funcIndex
 * @param includeMargin
 * @param multiply
 */ const $c5eae2e260de3fc7$var$handleExtraWidth = (element, name, value, funcIndex, includeMargin, multiply)=>{
    // 获取元素的 padding, border, margin 宽度（两侧宽度的和）
    const getExtraWidthValue = (extra)=>{
        return (0, $0caf6a5c58ee85f9$export$31fae7b1c9494af1)(element, name.toLowerCase(), extra) * multiply;
    };
    if (funcIndex === 2 && includeMargin) value += getExtraWidthValue('margin');
    if ((0, $0caf6a5c58ee85f9$export$78bc5c0ac316e909)(element)) {
        if (funcIndex === 0) value -= getExtraWidthValue('border');
        if (funcIndex === 1) {
            value -= getExtraWidthValue('border');
            value -= getExtraWidthValue('padding');
        }
    } else {
        if (funcIndex === 0) value += getExtraWidthValue('padding');
        if (funcIndex === 2) {
            value += getExtraWidthValue('border');
            value += getExtraWidthValue('padding');
        }
    }
    return value;
};
/**
 * 获取元素的样式值
 * @param element
 * @param name
 * @param funcIndex 0: innerWidth, innerHeight; 1: width, height; 2: outerWidth, outerHeight
 * @param includeMargin
 */ const $c5eae2e260de3fc7$var$get = (element, name, funcIndex, includeMargin)=>{
    const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
    const clientProp = `client${name}`;
    const scrollProp = `scroll${name}`;
    const offsetProp = `offset${name}`;
    const innerProp = `inner${name}`;
    // $(window).width()
    if ((0, $d0cded150def05db$export$5a096129d439f843)(element)) // outerWidth, outerHeight 需要包含滚动条的宽度
    return funcIndex === 2 ? element[innerProp] : (0, $d0cded150def05db$export$8d51e3db1a844094)(document)[clientProp];
    // $(document).width()
    if ((0, $d0cded150def05db$export$62858bae88b53fd0)(element)) {
        const doc = (0, $d0cded150def05db$export$8d51e3db1a844094)(element);
        return Math.max(// @ts-ignore
        element.body[scrollProp], doc[scrollProp], // @ts-ignore
        element.body[offsetProp], doc[offsetProp], doc[clientProp]);
    }
    const value = parseFloat((0, $0caf6a5c58ee85f9$export$8279eff504af5afb)(element, name.toLowerCase()) || '0');
    return $c5eae2e260de3fc7$var$handleExtraWidth(element, name, value, funcIndex, includeMargin, 1);
};
/**
 * 设置元素的样式值
 * @param element
 * @param elementIndex
 * @param name
 * @param funcIndex 0: innerWidth, innerHeight; 1: width, height; 2: outerWidth, outerHeight
 * @param includeMargin
 * @param value
 */ const $c5eae2e260de3fc7$var$set = (element, elementIndex, name, funcIndex, includeMargin, value)=>{
    let computedValue = (0, $d0cded150def05db$export$f6e2535fb5126e54)(value) ? value.call(element, elementIndex, $c5eae2e260de3fc7$var$get(element, name, funcIndex, includeMargin)) : value;
    if (computedValue == null) return;
    const $element = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element);
    const dimension = name.toLowerCase();
    // 特殊的值，不需要计算 padding、border、margin
    if ((0, $d0cded150def05db$export$844ec244b1367d54)(computedValue) && [
        'auto',
        'inherit',
        ''
    ].includes(computedValue)) {
        $element.css(dimension, computedValue);
        return;
    }
    // 其他值保留原始单位。注意：如果不使用 px 作为单位，则算出的值一般是不准确的
    const suffix = computedValue.toString().replace(/\b[0-9.]*/, '');
    const numerical = parseFloat(computedValue);
    computedValue = $c5eae2e260de3fc7$var$handleExtraWidth(element, name, numerical, funcIndex, includeMargin, -1) + (suffix || 'px');
    $element.css(dimension, computedValue);
};
(0, $d0cded150def05db$export$211b8db791997e25)([
    'Width',
    'Height'
], (name)=>{
    (0, $d0cded150def05db$export$211b8db791997e25)([
        `inner${name}`,
        name.toLowerCase(),
        `outer${name}`
    ], (funcName, funcIndex)=>{
        (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[funcName] = function(// eslint-disable-next-line
        margin, // eslint-disable-next-line
        value) {
            // 是否是赋值操作
            const isSet = arguments.length && (funcIndex < 2 || !(0, $d0cded150def05db$export$f9ce7b637dfbe238)(margin));
            const includeMargin = margin === true || value === true;
            // 获取第一个元素的值
            if (!isSet) return this.length ? $c5eae2e260de3fc7$var$get(this[0], name, funcIndex, includeMargin) : undefined;
            // 设置每个元素的值
            return this.each((index, element)=>{
                return $c5eae2e260de3fc7$var$set(element, index, name, funcIndex, includeMargin, margin);
            });
        };
    });
});









function $229897d88c30053c$export$8b58be045bf06082(target, ...objectN) {
    (0, $d0cded150def05db$export$211b8db791997e25)(objectN, (object)=>{
        (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(object, (prop, value)=>{
            if (!(0, $d0cded150def05db$export$fce6876652108ab)(value)) target[prop] = value;
        });
    });
    return target;
}













/**
 * 返回最近的用于定位的父元素
 */ (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.offsetParent = function() {
    const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
    return this.map(function() {
        let offsetParent = this.offsetParent;
        while(offsetParent && (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(offsetParent).css('position') === 'static')offsetParent = offsetParent.offsetParent;
        return offsetParent || document.documentElement;
    });
};


const $3320362c87173871$var$floatStyle = ($element, name)=>{
    return parseFloat($element.css(name));
};
// @ts-ignore
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.position = function() {
    if (!this.length) return undefined;
    const $element = this.eq(0);
    let currentOffset;
    let parentOffset = {
        left: 0,
        top: 0
    };
    if ($element.css('position') === 'fixed') currentOffset = $element[0].getBoundingClientRect();
    else {
        currentOffset = $element.offset();
        const $offsetParent = $element.offsetParent();
        parentOffset = $offsetParent.offset();
        parentOffset.top += $3320362c87173871$var$floatStyle($offsetParent, 'border-top-width');
        parentOffset.left += $3320362c87173871$var$floatStyle($offsetParent, 'border-left-width');
    }
    return {
        top: currentOffset.top - parentOffset.top - $3320362c87173871$var$floatStyle($element, 'margin-top'),
        left: currentOffset.left - parentOffset.left - $3320362c87173871$var$floatStyle($element, 'margin-left')
    };
};


const $d5f1bc9a569b30f2$var$get = (element)=>{
    if (!element.getClientRects().length) return {
        top: 0,
        left: 0
    };
    const { top: top, left: left } = element.getBoundingClientRect();
    const { pageYOffset: pageYOffset, pageXOffset: pageXOffset } = element.ownerDocument.defaultView;
    return {
        top: top + pageYOffset,
        left: left + pageXOffset
    };
};
const $d5f1bc9a569b30f2$var$set = (element, value, index)=>{
    const $element = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element);
    const position = $element.css('position');
    if (position === 'static') $element.css('position', 'relative');
    const currentOffset = $d5f1bc9a569b30f2$var$get(element);
    const currentTopString = $element.css('top');
    const currentLeftString = $element.css('left');
    let currentTop;
    let currentLeft;
    const calculatePosition = (position === 'absolute' || position === 'fixed') && (currentTopString + currentLeftString).includes('auto');
    if (calculatePosition) {
        const currentPosition = $element.position();
        currentTop = currentPosition.top;
        currentLeft = currentPosition.left;
    } else {
        currentTop = parseFloat(currentTopString);
        currentLeft = parseFloat(currentLeftString);
    }
    const computedValue = (0, $d0cded150def05db$export$f6e2535fb5126e54)(value) ? value.call(element, index, (0, $229897d88c30053c$export$8b58be045bf06082)({}, currentOffset)) : value;
    $element.css({
        top: computedValue.top != null ? computedValue.top - currentOffset.top + currentTop : undefined,
        left: computedValue.left != null ? computedValue.left - currentOffset.left + currentLeft : undefined
    });
};
// eslint-disable-next-line
(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.offset = function(value) {
    // 获取坐标
    if (!arguments.length) {
        if (!this.length) return undefined;
        return $d5f1bc9a569b30f2$var$get(this[0]);
    }
    // 设置坐标
    return this.each(function(index) {
        $d5f1bc9a569b30f2$var$set(this, value, index);
    });
};






const $dbdfa8d1727f2953$export$2344b14b097df817 = (container, contains)=>{
    return container !== contains && (0, $d0cded150def05db$export$8d51e3db1a844094)(container).contains(contains);
};




const $de9a3271470b39d0$export$4950aa0f605343fb = (first, second)=>{
    (0, $d0cded150def05db$export$211b8db791997e25)(second, (value)=>{
        first.push(value);
    });
    return first;
};





(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.find = function(selector) {
    const foundElements = [];
    this.each((_, element)=>{
        (0, $de9a3271470b39d0$export$4950aa0f605343fb)(foundElements, (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element.querySelectorAll(selector)).get());
    });
    return new (0, $6175daf4c02230d4$export$af7f3c1d59036499)(foundElements);
};




// 直接使用 CustomEvent 在 ssr 环境下会报错
const $c9243290d90ea08c$var$CustomEvent = (0, $c87de1375632dba4$export$38b2d434cce3ea22)().CustomEvent;
class $c9243290d90ea08c$export$df19c5abb73be735 extends $c9243290d90ea08c$var$CustomEvent {
    constructor(type, options){
        super(type, options);
        this.data = options.data;
        this.namespace = options.namespace;
    }
}
const $c9243290d90ea08c$var$elementIdMap = new WeakMap();
let $c9243290d90ea08c$var$elementId = 1;
/**
 * 为元素赋予一个唯一的ID
 */ const $c9243290d90ea08c$var$getElementId = (element)=>{
    if (!$c9243290d90ea08c$var$elementIdMap.has(element)) $c9243290d90ea08c$var$elementIdMap.set(element, ++$c9243290d90ea08c$var$elementId);
    return $c9243290d90ea08c$var$elementIdMap.get(element);
};
// 存储唯一ID及事件处理
const $c9243290d90ea08c$var$handlersMap = new Map();
/**
 * 获取元素上的事件处理器数组
 * @param element
 */ const $c9243290d90ea08c$var$getHandlers = (element)=>{
    const id = $c9243290d90ea08c$var$getElementId(element);
    return $c9243290d90ea08c$var$handlersMap.get(id) || $c9243290d90ea08c$var$handlersMap.set(id, []).get(id);
};
const $c9243290d90ea08c$export$98e6a39c04603d36 = (type)=>{
    const parts = type.split('.');
    return {
        type: parts[0],
        namespace: parts.slice(1).sort().join(' ')
    };
};
/**
 * 命名空间匹配规则
 */ const $c9243290d90ea08c$var$matcherFor = (namespace)=>{
    return new RegExp('(?:^| )' + namespace.replace(' ', ' .* ?') + '(?: |$)');
};
/**
 * 获取匹配的事件
 * @param element
 * @param type
 * @param func
 * @param selector
 */ const $c9243290d90ea08c$var$getMatchedHandlers = (element, type, func, selector)=>{
    const event = $c9243290d90ea08c$export$98e6a39c04603d36(type);
    return $c9243290d90ea08c$var$getHandlers(element).filter((handler)=>{
        return handler && (!event.type || handler.type === event.type) && (!event.namespace || $c9243290d90ea08c$var$matcherFor(event.namespace).test(handler.namespace)) && (!func || $c9243290d90ea08c$var$getElementId(handler.func) === $c9243290d90ea08c$var$getElementId(func)) && (!selector || handler.selector === selector);
    });
};
const $c9243290d90ea08c$export$e16d8520af44a096 = (element, types, func, data, selector)=>{
    // 传入 data.useCapture 来设置 useCapture: true
    let useCapture = false;
    if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(data) && data.useCapture) useCapture = true;
    types.split(' ').forEach((type)=>{
        if (!type) return;
        const event = $c9243290d90ea08c$export$98e6a39c04603d36(type);
        const callFn = (e, elem)=>{
            const result = func.apply(elem, // @ts-ignore
            e.detail === null ? [
                e
            ] : [
                e
            ].concat(e.detail));
            if (result === false) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        const proxyFn = (e)=>{
            if (e.namespace && !$c9243290d90ea08c$var$matcherFor(e.namespace).test(event.namespace)) return;
            e.data = data;
            if (selector) // 事件代理
            (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element).find(selector).get().reverse().forEach((elem)=>{
                if (elem === e.target || (0, $dbdfa8d1727f2953$export$2344b14b097df817)(elem, e.target)) callFn(e, elem);
            });
            else // 不使用事件代理
            callFn(e, element);
        };
        const handler = {
            type: event.type,
            namespace: event.namespace,
            func: func,
            selector: selector,
            id: $c9243290d90ea08c$var$getHandlers(element).length,
            proxy: proxyFn
        };
        $c9243290d90ea08c$var$getHandlers(element).push(handler);
        // @ts-ignore
        element.addEventListener(handler.type, proxyFn, useCapture);
    });
};
const $c9243290d90ea08c$export$cd7f480d6b8286c3 = (element, types, func, selector)=>{
    const handlersInElement = $c9243290d90ea08c$var$getHandlers(element);
    const removeEvent = (handler)=>{
        delete handlersInElement[handler.id];
        // @ts-ignore
        element.removeEventListener(handler.type, handler.proxy, false);
    };
    if (!types) handlersInElement.forEach((handler)=>{
        removeEvent(handler);
    });
    else types.split(' ').forEach((type)=>{
        if (type) $c9243290d90ea08c$var$getMatchedHandlers(element, type, func, selector).forEach((handler)=>{
            removeEvent(handler);
        });
    });
};








(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.off = function(types, // eslint-disable-next-line
selector, // eslint-disable-next-line
callback) {
    // types 是对象
    if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(types)) {
        (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(types, (type, fn)=>{
            // this.off('click', undefined, function () {})
            // this.off('click', '.box', function () {})
            this.off(type, selector, fn);
        });
        return this;
    }
    // selector 不存在
    if (selector === false || (0, $d0cded150def05db$export$f6e2535fb5126e54)(selector)) {
        callback = selector;
        selector = undefined;
    // this.off('click', undefined, function () {})
    }
    // callback 传入 `false`，相当于 `return false`
    if (callback === false) callback = (0, $d0cded150def05db$export$35d6da1a7e941e79);
    return this.each(function() {
        (0, $c9243290d90ea08c$export$cd7f480d6b8286c3)(this, types, callback, selector);
    });
};


(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.on = function(// eslint-disable-next-line
types, // eslint-disable-next-line
selector, // eslint-disable-next-line
data, // eslint-disable-next-line
callback, one) {
    // types 可以是 type/func 对象
    if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(types)) {
        // (types-Object, selector, data)
        if (!(0, $d0cded150def05db$export$844ec244b1367d54)(selector)) {
            // (types-Object, data)
            data = data || selector;
            selector = undefined;
        }
        (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(types, (type, fn)=>{
            // selector 和 data 都可能是 undefined
            // @ts-ignore
            this.on(type, selector, data, fn, one);
        });
        return this;
    }
    if (data == null && callback == null) {
        // (types, fn)
        callback = selector;
        data = selector = undefined;
    } else if (callback == null) {
        if ((0, $d0cded150def05db$export$844ec244b1367d54)(selector)) {
            // (types, selector, fn)
            callback = data;
            data = undefined;
        } else {
            // (types, data, fn)
            callback = data;
            data = selector;
            selector = undefined;
        }
    }
    if (callback === false) callback = (0, $d0cded150def05db$export$35d6da1a7e941e79);
    else if (!callback) return this;
    // $().one()
    if (one) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        const origCallback = callback;
        callback = function(event, ...dataN) {
            _this.off(event.type, selector, callback);
            return origCallback.call(this, event, ...dataN);
        };
    }
    return this.each(function() {
        (0, $c9243290d90ea08c$export$e16d8520af44a096)(this, types, callback, data, selector);
    });
};









(0, $d0cded150def05db$export$211b8db791997e25)([
    'insertBefore',
    'insertAfter'
], (name, nameIndex)=>{
    // eslint-disable-next-line
    (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[name] = function(target) {
        const $element = nameIndex ? (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.get().reverse()) : this; // 顺序和 jQuery 保持一致
        const $target = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target);
        const result = [];
        $target.each((index, target)=>{
            if (!target.parentNode) return;
            $element.each((_, element)=>{
                const newItem = index ? element.cloneNode(true) : element;
                const existingItem = nameIndex ? target.nextSibling : target;
                result.push(newItem);
                target.parentNode.insertBefore(newItem, existingItem);
            });
        });
        return (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(nameIndex ? result.reverse() : result);
    };
});










(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.remove = function(selector) {
    return this.each((_, element)=>{
        if (!selector || (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(element).is(selector)) (0, $f94b048e0ef94ba5$export$7ae609f7af59e4f7)(element);
    });
};


(0, $d0cded150def05db$export$211b8db791997e25)([
    'appendTo',
    'prependTo'
], (name, nameIndex)=>{
    // eslint-disable-next-line
    (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn[name] = function(target) {
        const extraChilds = [];
        const $target = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target).map((_, element)=>{
            const childNodes = element.childNodes;
            const childLength = childNodes.length;
            if (childLength) return childNodes[nameIndex ? 0 : childLength - 1];
            const child = (0, $f94b048e0ef94ba5$export$c8a8987d4410bf2d)('div');
            (0, $f94b048e0ef94ba5$export$1b8e57c9ea42f1d2)(element, child);
            extraChilds.push(child);
            return child;
        });
        const $result = this[nameIndex ? 'insertBefore' : 'insertAfter']($target);
        (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(extraChilds).remove();
        return $result;
    };
});









const $48ad39a890570dca$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{position:absolute;top:0;left:0;display:block;width:100%;height:100%;overflow:hidden;pointer-events:none}.surface{position:absolute;top:0;left:0;width:100%;height:100%;transition-duration:280ms;transition-property:background-color;pointer-events:none;transition-timing-function:var(--mdui-motion-easing-standard)}.hover{background-color:rgba(var(--mdui-comp-ripple-state-layer-color,var(--mdui-color-on-surface)),var(--mdui-state-layer-hover))}:host-context([focus-visible]) .focused{background-color:rgba(var(--mdui-comp-ripple-state-layer-color,var(--mdui-color-on-surface)),var(--mdui-state-layer-focus))}.dragged{background-color:rgba(var(--mdui-comp-ripple-state-layer-color,var(--mdui-color-on-surface)),var(--mdui-state-layer-dragged))}.wave{position:absolute;z-index:1;background-color:rgb(var(--mdui-comp-ripple-state-layer-color,var(--mdui-color-on-surface)));border-radius:50%;transform:translate3d(0,0,0) scale(.4);opacity:0;animation:225ms ease 0s 1 normal forwards running mdui-comp-ripple-radius-in,75ms ease 0s 1 normal forwards running mdui-comp-ripple-opacity-in;pointer-events:none}.out{transform:translate3d(var(--mdui-comp-ripple-transition-x,0),var(--mdui-comp-ripple-transition-y,0),0) scale(1);animation:150ms ease 0s 1 normal none running mdui-comp-ripple-opacity-out}@keyframes mdui-comp-ripple-radius-in{from{transform:translate3d(0,0,0) scale(.4);animation-timing-function:var(--mdui-motion-easing-standard)}to{transform:translate3d(var(--mdui-comp-ripple-transition-x,0),var(--mdui-comp-ripple-transition-y,0),0) scale(1)}}@keyframes mdui-comp-ripple-opacity-in{from{opacity:0;animation-timing-function:linear}to{opacity:var(--mdui-state-layer-pressed)}}@keyframes mdui-comp-ripple-opacity-out{from{animation-timing-function:linear;opacity:var(--mdui-state-layer-pressed)}to{opacity:0}}`;


/**
 * 处理点击时的涟漪动画；及添加 hover、focused、dragged 的背景色
 * 背景色通过在 .surface 元素上添加对应的 class 实现
 * 阴影在 ripple-mixin 中处理，通过在 :host 元素上添加 attribute 供 CSS 选择器添加样式
 */ let $6e172aead194afb2$export$9e9146f7e027fdaa = class Ripple extends (0, $53a1aafae9c6752a$export$9bb0a9faa319390c) {
    constructor(){
        super(...arguments);
        /**
         * 是否禁用涟漪动画
         */ this.noRipple = false;
        this.hover = false;
        this.focused = false;
        this.dragged = false;
        this.surfaceRef = (0, $f322d22fead4969a$export$7d1e3a5e95ceca43)();
    }
    startPress(event) {
        if (this.noRipple) return;
        const $surface = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.surfaceRef.value);
        const surfaceHeight = $surface.innerHeight();
        const surfaceWidth = $surface.innerWidth();
        // 点击位置坐标
        let touchStartX;
        let touchStartY;
        if (!event) {
            // 未传入事件对象，涟漪从中间扩散
            touchStartX = surfaceWidth / 2;
            touchStartY = surfaceHeight / 2;
        } else {
            // 传入了事件对象，涟漪从点击位置扩散
            const touchPosition = typeof TouchEvent !== 'undefined' && event instanceof TouchEvent && event.touches.length ? event.touches[0] : event;
            const offset = $surface.offset();
            // 点击位置不在 surface 内，不执行
            if (touchPosition.pageX < offset.left || touchPosition.pageX > offset.left + surfaceWidth || touchPosition.pageY < offset.top || touchPosition.pageY > offset.top + surfaceHeight) return;
            touchStartX = touchPosition.pageX - offset.left;
            touchStartY = touchPosition.pageY - offset.top;
        }
        // 涟漪直径
        const diameter = Math.max(Math.pow(Math.pow(surfaceHeight, 2) + Math.pow(surfaceWidth, 2), 0.5), 48);
        // 涟漪扩散动画
        const translateX = `${-touchStartX + surfaceWidth / 2}px`;
        const translateY = `${-touchStartY + surfaceHeight / 2}px`;
        const translate = `translate3d(${translateX}, ${translateY}, 0) scale(1)`;
        // 涟漪 DOM 元素
        (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)('<div class="wave"></div>').css({
            width: diameter,
            height: diameter,
            marginTop: -diameter / 2,
            marginLeft: -diameter / 2,
            left: touchStartX,
            top: touchStartY
        }).each((_, wave)=>{
            wave.style.setProperty('--mdui-comp-ripple-transition-x', translateX);
            wave.style.setProperty('--mdui-comp-ripple-transition-y', translateY);
        }).prependTo(this.surfaceRef.value).each((_, wave)=>wave.clientLeft) // 重绘
        .css('transform', translate).on('animationend', function(e) {
            const event = e;
            if (event.animationName === 'mdui-comp-ripple-radius-in') (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this).data('filled', true); // 扩散动画完成后，添加标记
        });
    }
    endPress() {
        const $waves = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.surfaceRef.value).children().filter((_, wave)=>!(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(wave).data('removing')).data('removing', true);
        const hideAndRemove = ($waves)=>{
            $waves.addClass('out').each((_, wave)=>wave.clientLeft) // 重绘
            .on('animationend', function() {
                (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this).remove();
            });
        };
        // 扩散动画未完成，先完成扩散，再隐藏并移除
        $waves.filter((_, wave)=>!(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(wave).data('filled')).on('animationend', function(e) {
            const event = e;
            if (event.animationName === 'mdui-comp-ripple-radius-in') hideAndRemove((0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this));
        });
        // 扩散动画已完成，直接隐藏并移除
        hideAndRemove($waves.filter((_, wave)=>!!(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(wave).data('filled')));
    }
    startHover() {
        this.hover = true;
    }
    endHover() {
        this.hover = false;
    }
    startFocus() {
        this.focused = true;
    }
    endFocus() {
        this.focused = false;
    }
    startDrag() {
        this.dragged = true;
    }
    endDrag() {
        this.dragged = false;
    }
    render() {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div ${(0, $f322d22fead4969a$export$eff4d24c3ff7876e)(this.surfaceRef)} class="surface ${(0, $c9d15c868ac73f05$export$56cc687933817664)({
            hover: this.hover,
            focused: this.focused,
            dragged: this.dragged
        })}"></div>`;
    }
};
$6e172aead194afb2$export$9e9146f7e027fdaa.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $48ad39a890570dca$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'no-ripple'
    })
], $6e172aead194afb2$export$9e9146f7e027fdaa.prototype, "noRipple", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $6e172aead194afb2$export$9e9146f7e027fdaa.prototype, "hover", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $6e172aead194afb2$export$9e9146f7e027fdaa.prototype, "focused", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $6e172aead194afb2$export$9e9146f7e027fdaa.prototype, "dragged", void 0);
$6e172aead194afb2$export$9e9146f7e027fdaa = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-ripple')
], $6e172aead194afb2$export$9e9146f7e027fdaa);


const $abaf2949eee28760$export$7891358133f12319 = (superclass)=>{
    class Mixin extends superclass {
        constructor(){
            super(...arguments);
            /**
             * 是否禁用涟漪动画
             */ this.noRipple = false;
            /**
             * 当前激活的是第几个 <mdui-ripple>。仅一个组件中有多个 <mdui-ripple> 时可以使用该属性
             * 若值为 undefined，则组件中所有 <mdui-ripple> 都激活
             */ this.rippleIndex = undefined;
            /**
             * 获取当前激活的是第几个 <mdui-ripple>。仅一个组件中有多个 <mdui-ripple> 时可以使用该属性
             * 若值为 undefined，则组件中所有 <mdui-ripple> 都激活
             * 可在子类中手动指定该方法，指定需要激活的 ripple
             */ this.getRippleIndex = ()=>this.rippleIndex;
        }
        /**
         * 子类要添加该属性，指向 <mdui-ripple> 元素
         * 如果一个组件中包含多个 <mdui-ripple> 元素，则这里可以是一个数组或 NodeList
         */ get rippleElement() {
            throw new Error('Must implement rippleElement getter!');
        }
        /**
         * 子类要实现该属性，表示是否禁用 ripple
         * 如果一个组件中包含多个 <mdui-ripple> 元素，则这里可以是一个数组；也可以是单个值，同时控制多个 <mdui-ripple> 元素
         */ get rippleDisabled() {
            throw new Error('Must implement rippleDisabled getter!');
        }
        /**
         * 当前 <mdui-ripple> 元素相对于哪个元素存在，即 hover、pressed、dragged 属性要添加到哪个元素上，默认为 :host
         * 如果需要修改该属性，则子类可以实现该属性
         * 如果一个组件中包含多个 <mdui-ripple> 元素，则这里可以是一个数组；也可以是单个值，同时控制多个 <mdui-ripple> 元素
         */ get rippleTarget() {
            return this;
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            const $rippleTarget = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.rippleTarget);
            // 监听到事件时，是在第几个 <mdui-ripple> 上触发的事件，记录到 this.rippleIndex 中
            const setRippleIndex = (event)=>{
                if ((0, $d0cded150def05db$export$1e2f57719e155213)(this.rippleTarget)) this.rippleIndex = $rippleTarget.index(event.target);
            };
            const rippleTargetArr = (0, $d0cded150def05db$export$1e2f57719e155213)(this.rippleTarget) ? this.rippleTarget : [
                this.rippleTarget
            ];
            rippleTargetArr.forEach((rippleTarget)=>{
                rippleTarget.addEventListener('pointerdown', (event)=>{
                    setRippleIndex(event);
                    this.startPress(event);
                });
                rippleTarget.addEventListener('pointerenter', (event)=>{
                    setRippleIndex(event);
                    this.startHover(event);
                });
                rippleTarget.addEventListener('pointerleave', (event)=>{
                    setRippleIndex(event);
                    this.endHover(event);
                });
                rippleTarget.addEventListener('focus', (event)=>{
                    setRippleIndex(event);
                    this.startFocus();
                });
                rippleTarget.addEventListener('blur', (event)=>{
                    setRippleIndex(event);
                    this.endFocus();
                });
            });
        }
        /**
         * 若存在多个 <mdui-ripple>，但 rippleTarget 为同一个，则 hover 状态无法在多个 <mdui-ripple> 之间切换
         * 所以把 startHover 和 endHover 设置为 protected，供子类调用
         * 子类中，在 getRippleIndex() 的返回值变更前调用 endHover(event)，变更后调用 startHover(event)
         */ startHover(event) {
            if (event.pointerType !== 'mouse' || this.isRippleDisabled()) return;
            this.getRippleTarget().setAttribute('hover', '');
            this.getRippleElement().startHover();
        }
        endHover(event) {
            if (event.pointerType !== 'mouse' || this.isRippleDisabled()) return;
            this.getRippleTarget().removeAttribute('hover');
            this.getRippleElement().endHover();
        }
        /**
         * 当前激活的 <mdui-ripple> 元素是否被禁用
         */ isRippleDisabled() {
            const disabled = this.rippleDisabled;
            if (!Array.isArray(disabled)) return disabled;
            const rippleIndex = this.getRippleIndex();
            if (rippleIndex !== undefined) return disabled[rippleIndex];
            return disabled.length ? disabled[0] : false;
        }
        /**
         * 获取当前激活的 <mdui-ripple> 元素实例
         */ getRippleElement() {
            const ripple = this.rippleElement;
            if (!(0, $d0cded150def05db$export$1e2f57719e155213)(ripple)) return ripple;
            const rippleIndex = this.getRippleIndex();
            if (rippleIndex !== undefined) return ripple[rippleIndex];
            return ripple[0];
        }
        /**
         * 获取当前激活的 <mdui-ripple> 元素相对于哪个元素存在
         */ getRippleTarget() {
            const target = this.rippleTarget;
            if (!(0, $d0cded150def05db$export$1e2f57719e155213)(target)) return target;
            const rippleIndex = this.getRippleIndex();
            if (rippleIndex !== undefined) return target[rippleIndex];
            return target[0];
        }
        startFocus() {
            if (this.isRippleDisabled()) return;
            this.getRippleElement().startFocus();
        }
        endFocus() {
            if (this.isRippleDisabled()) return;
            this.getRippleElement().endFocus();
        }
        startPress(event) {
            // 为鼠标时操作，仅响应鼠标左键点击
            if (this.isRippleDisabled() || event.button) return;
            const target = this.getRippleTarget();
            target.setAttribute('pressed', '');
            // 手指触摸触发涟漪
            if ([
                'touch',
                'pen'
            ].includes(event.pointerType)) {
                let hidden = false;
                // 手指触摸后，延迟一段时间触发涟漪，避免手指滑动时也触发涟漪
                let timer = setTimeout(()=>{
                    timer = 0;
                    this.getRippleElement().startPress(event);
                }, 70);
                const hideRipple = ()=>{
                    // 如果手指没有移动，且涟漪动画还没有开始，则开始涟漪动画
                    if (timer) {
                        clearTimeout(timer);
                        timer = 0;
                        this.getRippleElement().startPress(event);
                    }
                    if (!hidden) {
                        hidden = true;
                        this.endPress();
                    }
                    target.removeEventListener('pointerup', hideRipple);
                    target.removeEventListener('pointercancel', hideRipple);
                };
                // 手指移动后，移除涟漪动画
                const touchMove = ()=>{
                    if (timer) {
                        clearTimeout(timer);
                        timer = 0;
                    }
                    target.removeEventListener('touchmove', touchMove);
                };
                // pointermove 事件过于灵敏，可能在未触发 touchmove 的情况下，触发了 pointermove 事件，导致正常的点击操作没有显示涟漪
                // 因此这里监听 touchmove 事件
                target.addEventListener('touchmove', touchMove);
                target.addEventListener('pointerup', hideRipple);
                target.addEventListener('pointercancel', hideRipple);
            }
            // 鼠标点击触发涟漪，点击后立即触发涟漪（仅鼠标左键能触发涟漪）
            if (event.pointerType === 'mouse' && event.button === 0) {
                const hideRipple = ()=>{
                    this.endPress();
                    target.removeEventListener('pointerup', hideRipple);
                    target.removeEventListener('pointercancel', hideRipple);
                    target.removeEventListener('pointerleave', hideRipple);
                };
                this.getRippleElement().startPress(event);
                target.addEventListener('pointerup', hideRipple);
                target.addEventListener('pointercancel', hideRipple);
                target.addEventListener('pointerleave', hideRipple);
            }
        }
        endPress() {
            if (this.isRippleDisabled()) return;
            this.getRippleTarget().removeAttribute('pressed');
            this.getRippleElement().endPress();
        }
        startDrag() {
            if (this.isRippleDisabled()) return;
            this.getRippleElement().startDrag();
        }
        endDrag() {
            if (this.isRippleDisabled()) return;
            this.getRippleElement().endDrag();
        }
    }
    (0, $ceFTv.__decorate)([
        (0, $acf573f6c2910992$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true,
            converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
            attribute: 'no-ripple'
        })
    ], Mixin.prototype, "noRipple", void 0);
    return Mixin;
};



const $62d60cff497d19e4$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{--shape-corner:var(--mdui-shape-corner-medium);position:relative;display:inline-block;overflow:hidden;border-radius:var(--shape-corner);-webkit-tap-highlight-color:transparent;transition:box-shadow var(--mdui-motion-duration-short4) var(--mdui-motion-easing-linear);--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-surface)}:host([clickable]:not([clickable=false i])){cursor:pointer}:host([variant=elevated]){background-color:rgb(var(--mdui-color-surface-container-low));box-shadow:var(--mdui-elevation-level1)}:host([variant=filled]){background-color:rgb(var(--mdui-color-surface-container-highest))}:host([variant=outlined]){background-color:rgb(var(--mdui-color-surface));border:.0625rem solid rgb(var(--mdui-color-outline))}:host([variant=elevated][hover]){box-shadow:var(--mdui-elevation-level2)}:host([variant=filled][hover]),:host([variant=outlined][hover]){box-shadow:var(--mdui-elevation-level1)}:host([variant=elevated][dragged]),:host([variant=filled][dragged]),:host([variant=outlined][dragged]){box-shadow:var(--mdui-elevation-level3)}:host([disabled]:not([disabled=false i])){opacity:.38;cursor:default;-webkit-user-select:none;user-select:none}:host([variant=elevated][disabled]:not([disabled=false i])){background-color:rgb(var(--mdui-color-surface-variant));box-shadow:var(--mdui-elevation-level0)}:host([variant=filled][disabled]:not([disabled=false i])){background-color:rgb(var(--mdui-color-surface));box-shadow:var(--mdui-elevation-level1)}:host([variant=outlined][disabled]:not([disabled=false i])){box-shadow:var(--mdui-elevation-level0);border-color:rgba(var(--mdui-color-outline),.32)}.link{position:relative;display:inline-block;width:100%;height:100%;color:inherit;font-size:inherit;letter-spacing:inherit;text-decoration:none;touch-action:manipulation;-webkit-user-drag:none}`;


/**
 * @summary 卡片组件
 *
 * ```html
 * <mdui-card>card content</mdui-card>
 * ```
 *
 * @event focus - 获得焦点时触发
 * @event blur - 失去焦点时触发
 *
 * @slot - 卡片的内容
 *
 * @cssprop --shape-corner - 组件的圆角大小。可以指定一个具体的像素值；但更推荐引用[设计令牌](/docs/2/styles/design-tokens#shape-corner)
 */ let $e094832e569ce4a8$export$60332b2344f7fe41 = class Card extends (0, $127a23c52a5adf4f$export$e70f90f657dd64e)((0, $abaf2949eee28760$export$7891358133f12319)((0, $3bb9ba68ccebecb9$export$7b86c168e7d309f7)((0, $53a1aafae9c6752a$export$9bb0a9faa319390c)))) {
    constructor(){
        super(...arguments);
        /**
         * 卡片的形状。可选值包括：
         *
         * * `elevated`：带阴影的卡片，与背景的视觉分离度较高
         * * `filled`：带填充色的卡片，与背景的视觉分离度较低
         * * `outlined`：带边框的卡片，与背景的视觉分离度最高
         */ this.variant = 'elevated';
        /**
         * 是否可点击。为 `true` 时，卡片将具有鼠标悬浮效果和点击涟漪效果
         */ this.clickable = false;
        /**
         * 是否禁用
         */ this.disabled = false;
        this.rippleRef = (0, $f322d22fead4969a$export$7d1e3a5e95ceca43)();
    }
    get rippleElement() {
        return this.rippleRef.value;
    }
    get rippleDisabled() {
        return this.disabled || !this.href && !this.clickable;
    }
    get focusElement() {
        return this.href && !this.disabled ? this.renderRoot.querySelector('._a') : this;
    }
    get focusDisabled() {
        return this.rippleDisabled;
    }
    render() {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-ripple ${(0, $f322d22fead4969a$export$eff4d24c3ff7876e)(this.rippleRef)} .noRipple="${this.noRipple}"></mdui-ripple>${this.href && !this.disabled ? this.renderAnchor({
            className: 'link',
            content: (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>`
        }) : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>`}`;
    }
};
$e094832e569ce4a8$export$60332b2344f7fe41.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $62d60cff497d19e4$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $e094832e569ce4a8$export$60332b2344f7fe41.prototype, "variant", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $e094832e569ce4a8$export$60332b2344f7fe41.prototype, "clickable", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $e094832e569ce4a8$export$60332b2344f7fe41.prototype, "disabled", void 0);
$e094832e569ce4a8$export$60332b2344f7fe41 = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-card')
], $e094832e569ce4a8$export$60332b2344f7fe41);





var $ceFTv = parcelRequire("ceFTv");







/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5859083c0c48887$export$28cf49ad70f82d12 = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)(class extends (0, $7f965b17d718bf91$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $dc08001cbc3c8af5$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $1182a8bbea75578f$export$9c068ae9cc5db4e8) || t === (0, $1182a8bbea75578f$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
        return (0, $dc08001cbc3c8af5$export$ea70d9dd5965b1c8)(i), t;
    }
});





/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1c93789365dd7e63$export$a55877ca9db47377(n, r, t) {
    return n ? r(n) : t?.(n);
}




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Name of the event dispatched to `window` whenever a locale change starts,
 * finishes successfully, or fails. Only relevant to runtime mode.
 *
 * The `detail` of this event is an object with a `status` string that can be:
 * "loading", "ready", or "error", along with the relevant locale code, and
 * error message if applicable.
 *
 * You can listen for this event to know when your application should be
 * re-rendered following a locale change. See also the Localized mixin, which
 * automatically re-renders LitElement classes using this event.
 */ const $297de31ed8b176bc$export$22ecc5ec4a7dfb64 = 'lit-localize-status';


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Tag that allows expressions to be used in localized non-HTML template
 * strings.
 *
 * Example: msg(str`Hello ${this.user}!`);
 *
 * The Lit html tag can also be used for this purpose, but HTML will need to be
 * escaped, and there is a small overhead for HTML parsing.
 *
 * Untagged template strings with expressions aren't supported by lit-localize
 * because they don't allow for values to be captured at runtime.
 */ const $a7d55e67fd220a44$var$_str = (strings, ...values)=>({
        strTag: true,
        strings: strings,
        values: values
    });
const $a7d55e67fd220a44$export$42d51816ce590c93 = $a7d55e67fd220a44$var$_str;
const $a7d55e67fd220a44$export$d837b01947f59adf = (val)=>typeof val !== 'string' && 'strTag' in val;
const $a7d55e67fd220a44$export$54d1368c2e63ae35 = (strings, values, valueOrder)=>{
    let concat = strings[0];
    for(let i = 1; i < strings.length; i++){
        concat += values[valueOrder ? valueOrder[i - 1] : i - 1];
        concat += strings[i];
    }
    return concat;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
const $71e05aa60b685b49$export$627842c9718b61c7 = (template)=>(0, $a7d55e67fd220a44$export$d837b01947f59adf)(template) ? (0, $a7d55e67fd220a44$export$54d1368c2e63ae35)(template.strings, template.values) : template;


let $ad0c7de0be8b3f01$export$d8bbfaecd0f57bdf = (0, $71e05aa60b685b49$export$627842c9718b61c7);
let $ad0c7de0be8b3f01$var$installed = false;
function $ad0c7de0be8b3f01$export$293be9dc57421d1c(impl) {
    if ($ad0c7de0be8b3f01$var$installed) throw new Error('lit-localize can only be configured once');
    $ad0c7de0be8b3f01$export$d8bbfaecd0f57bdf = impl;
    $ad0c7de0be8b3f01$var$installed = true;
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
class $56cc706f52318502$var$LocalizeController {
    constructor(host){
        this.__litLocalizeEventHandler = (event)=>{
            if (event.detail.status === 'ready') this.host.requestUpdate();
        };
        this.host = host;
    }
    hostConnected() {
        window.addEventListener((0, $297de31ed8b176bc$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
    hostDisconnected() {
        window.removeEventListener((0, $297de31ed8b176bc$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
}
/**
 * Re-render the given LitElement whenever a new active locale has loaded.
 *
 * See also {@link localized} for the same functionality as a decorator.
 *
 * When using lit-localize in transform mode, calls to this function are
 * replaced with undefined.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {msg, updateWhenLocaleChanges} from '@lit/localize';
 *
 *   class MyElement extends LitElement {
 *     constructor() {
 *       super();
 *       updateWhenLocaleChanges(this);
 *     }
 *
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */ const $56cc706f52318502$var$_updateWhenLocaleChanges = (host)=>host.addController(new $56cc706f52318502$var$LocalizeController(host));
const $56cc706f52318502$export$19147fd8eb2795e4 = $56cc706f52318502$var$_updateWhenLocaleChanges;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
const $a6db462d5c5bc44b$export$85ef745e96563a4b = ()=>(clazz, _context)=>{
        clazz.addInitializer((0, $56cc706f52318502$export$19147fd8eb2795e4));
        return clazz;
    };


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $23da63b60cc1fde7$export$85f6557964517f1a {
    constructor(){
        this.settled = false;
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    resolve(value) {
        this.settled = true;
        this._resolve(value);
    }
    reject(error) {
        this.settled = true;
        this._reject(error);
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */ // This module is derived from the file:
// https://github.com/tjwebb/fnv-plus/blob/1e2ce68a07cb7dd4c3c85364f3d8d96c95919474/index.js#L309
//
// Changes:
// - Only the _hash64_1a_fast function is included.
// - Removed loop unrolling.
// - Converted to TypeScript ES module.
// - var -> let/const
//
// TODO(aomarks) Upstream improvements to https://github.com/tjwebb/fnv-plus/.
const $ab3af18b4fe5b124$var$hl = [];
for(let i = 0; i < 256; i++)$ab3af18b4fe5b124$var$hl[i] = (i >> 4 & 15).toString(16) + (i & 15).toString(16);
function $ab3af18b4fe5b124$export$318d539d57e27224(str) {
    let t0 = 0, v0 = 0x2325, t1 = 0, v1 = 0x8422, t2 = 0, v2 = 0x9ce4, t3 = 0, v3 = 0xcbf2;
    for(let i = 0; i < str.length; i++){
        v0 ^= str.charCodeAt(i);
        t0 = v0 * 435;
        t1 = v1 * 435;
        t2 = v2 * 435;
        t3 = v3 * 435;
        t2 += v0 << 8;
        t3 += v1 << 8;
        t1 += t0 >>> 16;
        v0 = t0 & 65535;
        t2 += t1 >>> 16;
        v1 = t1 & 65535;
        v3 = t3 + (t2 >>> 16) & 65535;
        v2 = t2 & 65535;
    }
    return $ab3af18b4fe5b124$var$hl[v3 >> 8] + $ab3af18b4fe5b124$var$hl[v3 & 255] + $ab3af18b4fe5b124$var$hl[v2 >> 8] + $ab3af18b4fe5b124$var$hl[v2 & 255] + $ab3af18b4fe5b124$var$hl[v1 >> 8] + $ab3af18b4fe5b124$var$hl[v1 & 255] + $ab3af18b4fe5b124$var$hl[v0 >> 8] + $ab3af18b4fe5b124$var$hl[v0 & 255];
}


const $c63dfe4fb0318253$export$bab7f2b996bc5244 = '\x1e';
/**
 * Id prefix on html-tagged templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $c63dfe4fb0318253$var$HTML_PREFIX = 'h';
/**
 * Id prefix on plain string templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $c63dfe4fb0318253$var$STRING_PREFIX = 's';
function $c63dfe4fb0318253$export$bb8801913caa27b4(strings, isHtmlTagged) {
    return (isHtmlTagged ? $c63dfe4fb0318253$var$HTML_PREFIX : $c63dfe4fb0318253$var$STRING_PREFIX) + (0, $ab3af18b4fe5b124$export$318d539d57e27224)(typeof strings === 'string' ? strings : strings.join($c63dfe4fb0318253$export$bab7f2b996bc5244));
}


const $34dba919b42643e0$var$expressionOrders = new WeakMap();
const $34dba919b42643e0$var$hashCache = new Map();
function $34dba919b42643e0$export$9a3f0ce3906e68f(templates, template, options) {
    if (templates) {
        const id = options?.id ?? $34dba919b42643e0$var$generateId(template);
        const localized = templates[id];
        if (localized) {
            if (typeof localized === 'string') // E.g. "Hello World!"
            return localized;
            else if ('strTag' in localized) // E.g. str`Hello ${name}!`
            //
            // Localized templates have ${number} in place of real template
            // expressions. They can't have real template values, because the
            // variable scope would be wrong. The number tells us the index of the
            // source value to substitute in its place, because expressions can be
            // moved to a different position during translation.
            return (0, $a7d55e67fd220a44$export$54d1368c2e63ae35)(localized.strings, // Cast `template` because its type wasn't automatically narrowed (but
            // we know it must be the same type as `localized`).
            template.values, localized.values);
            else {
                // E.g. html`Hello <b>${name}</b>!`
                //
                // We have to keep our own mapping of expression ordering because we do
                // an in-place update of `values`, and otherwise we'd lose ordering for
                // subsequent renders.
                let order = $34dba919b42643e0$var$expressionOrders.get(localized);
                if (order === undefined) {
                    order = localized.values;
                    $34dba919b42643e0$var$expressionOrders.set(localized, order);
                }
                return {
                    ...localized,
                    values: order.map((i)=>template.values[i])
                };
            }
        }
    }
    return (0, $71e05aa60b685b49$export$627842c9718b61c7)(template);
}
function $34dba919b42643e0$var$generateId(template) {
    const strings = typeof template === 'string' ? template : template.strings;
    let id = $34dba919b42643e0$var$hashCache.get(strings);
    if (id === undefined) {
        id = (0, $c63dfe4fb0318253$export$bb8801913caa27b4)(strings, typeof template !== 'string' && !('strTag' in template));
        $34dba919b42643e0$var$hashCache.set(strings, id);
    }
    return id;
}



/**
 * Dispatch a "lit-localize-status" event to `window` with the given detail.
 */ function $1ecbf2487989fc64$var$dispatchStatusEvent(detail) {
    window.dispatchEvent(new CustomEvent((0, $297de31ed8b176bc$export$22ecc5ec4a7dfb64), {
        detail: detail
    }));
}
let $1ecbf2487989fc64$var$activeLocale = '';
let $1ecbf2487989fc64$var$loadingLocale;
let $1ecbf2487989fc64$var$sourceLocale;
let $1ecbf2487989fc64$var$validLocales;
let $1ecbf2487989fc64$var$loadLocale;
let $1ecbf2487989fc64$var$templates;
let $1ecbf2487989fc64$var$loading = new (0, $23da63b60cc1fde7$export$85f6557964517f1a)();
// The loading promise must be initially resolved, because that's what we should
// return if the user immediately calls setLocale(sourceLocale).
$1ecbf2487989fc64$var$loading.resolve();
let $1ecbf2487989fc64$var$requestId = 0;
const $1ecbf2487989fc64$export$2f3903bcf09d572a = (config)=>{
    (0, $ad0c7de0be8b3f01$export$293be9dc57421d1c)((template, options)=>(0, $34dba919b42643e0$export$9a3f0ce3906e68f)($1ecbf2487989fc64$var$templates, template, options));
    $1ecbf2487989fc64$var$activeLocale = $1ecbf2487989fc64$var$sourceLocale = config.sourceLocale;
    $1ecbf2487989fc64$var$validLocales = new Set(config.targetLocales);
    $1ecbf2487989fc64$var$validLocales.add(config.sourceLocale);
    $1ecbf2487989fc64$var$loadLocale = config.loadLocale;
    return {
        getLocale: $1ecbf2487989fc64$var$getLocale,
        setLocale: $1ecbf2487989fc64$var$setLocale
    };
};
/**
 * Return the active locale code.
 */ const $1ecbf2487989fc64$var$getLocale = ()=>{
    return $1ecbf2487989fc64$var$activeLocale;
};
/**
 * Set the active locale code, and begin loading templates for that locale using
 * the `loadLocale` function that was passed to `configureLocalization`. Returns
 * a promise that resolves when the next locale is ready to be rendered.
 *
 * Note that if a second call to `setLocale` is made while the first requested
 * locale is still loading, then the second call takes precedence, and the
 * promise returned from the first call will resolve when second locale is
 * ready. If you need to know whether a particular locale was loaded, check
 * `getLocale` after the promise resolves.
 *
 * Throws if the given locale is not contained by the configured `sourceLocale`
 * or `targetLocales`.
 */ const $1ecbf2487989fc64$var$setLocale = (newLocale)=>{
    if (newLocale === ($1ecbf2487989fc64$var$loadingLocale ?? $1ecbf2487989fc64$var$activeLocale)) return $1ecbf2487989fc64$var$loading.promise;
    if (!$1ecbf2487989fc64$var$validLocales || !$1ecbf2487989fc64$var$loadLocale) throw new Error('Internal error');
    if (!$1ecbf2487989fc64$var$validLocales.has(newLocale)) throw new Error('Invalid locale code');
    $1ecbf2487989fc64$var$requestId++;
    const thisRequestId = $1ecbf2487989fc64$var$requestId;
    $1ecbf2487989fc64$var$loadingLocale = newLocale;
    if ($1ecbf2487989fc64$var$loading.settled) $1ecbf2487989fc64$var$loading = new (0, $23da63b60cc1fde7$export$85f6557964517f1a)();
    $1ecbf2487989fc64$var$dispatchStatusEvent({
        status: 'loading',
        loadingLocale: newLocale
    });
    const localePromise = newLocale === $1ecbf2487989fc64$var$sourceLocale ? // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({
        templates: undefined
    }) : $1ecbf2487989fc64$var$loadLocale(newLocale);
    localePromise.then((mod)=>{
        if ($1ecbf2487989fc64$var$requestId === thisRequestId) {
            $1ecbf2487989fc64$var$activeLocale = newLocale;
            $1ecbf2487989fc64$var$loadingLocale = undefined;
            $1ecbf2487989fc64$var$templates = mod.templates;
            $1ecbf2487989fc64$var$dispatchStatusEvent({
                status: 'ready',
                readyLocale: newLocale
            });
            $1ecbf2487989fc64$var$loading.resolve();
        }
    // Else another locale was requested in the meantime. Don't resolve or
    // reject, because the newer load call is going to use the same promise.
    // Note the user can call getLocale() after the promise resolves if they
    // need to check if the locale is still the one they expected to load.
    }, (err)=>{
        if ($1ecbf2487989fc64$var$requestId === thisRequestId) {
            $1ecbf2487989fc64$var$dispatchStatusEvent({
                status: 'error',
                errorLocale: newLocale,
                errorMessage: err.toString()
            });
            $1ecbf2487989fc64$var$loading.reject(err);
        }
    });
    return $1ecbf2487989fc64$var$loading.promise;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

const $dc3ad247c954a47e$export$96b14ce1c501d224 = (config)=>{
    (0, $ad0c7de0be8b3f01$export$293be9dc57421d1c)((0, $71e05aa60b685b49$export$627842c9718b61c7));
    const sourceLocale = config.sourceLocale;
    return {
        getLocale: ()=>sourceLocale
    };
};







/**
 * 参考：https://github.com/shoelace-style/shoelace/blob/next/src/internal/form.ts
 */ 


/**
 * 使用该 WeakMap 来存储指定表单中所有的 mdui 表单控件
 * 在每个表单控件的 hostConnected 中添加、hostDisconnected 中移除对应表单的 mdui 表单控件，
 * 然后在 getFormControls 方法中就能获取到表单中所有的 mdui 表单控件
 */ const $376a384cc549d4e2$export$61a522b559454891 = new WeakMap();
const $376a384cc549d4e2$export$2742a3285d55034 = (form)=>{
    const nativeFormControls = [
        ...form.elements
    ];
    const formControls = $376a384cc549d4e2$export$61a522b559454891.get(form) || [];
    const comparePosition = (a, b)=>{
        const position = a.compareDocumentPosition(b);
        return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    };
    // 按 DOM 元素的顺序排序
    return [
        ...nativeFormControls,
        ...formControls
    ].sort(comparePosition);
};




/**
 * 在执行 `<form>` 元素的 reportValidity() 时，不会执行 mdui 组件的 reportValidity() 方法，
 * 因此在 mdui 表单控件的 hostConnected 中把 `<form>` 的 reportValidity 替换为自定义方法，
 * hostDisconnected 中恢复为 原生 reportValidity 方法
 *
 * 该 WeakMap 用于存储指定 `<form>` 的原生 reportValidity 方法
 *
 * 日后使用 ElementInternals 可不再进行该处理，但当前 safari 浏览器不支持。
 */ const $d56b143b5bf6ad89$var$reportValidityOverloads = new WeakMap();
const $d56b143b5bf6ad89$export$64b1c594674e8d1d = new WeakMap();
class $d56b143b5bf6ad89$export$2ecd466f59952f38 {
    constructor(host, options){
        (this.host = host).addController(this);
        this.definedController = new (0, $29b950a65aaa366a$export$da3260c7a0861b80)(host, {
            needDomReady: true
        });
        this.options = {
            form: (control)=>{
                const formId = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(control).attr('form');
                if (formId) {
                    const root = control.getRootNode();
                    return root.getElementById(formId);
                }
                return control.closest('form');
            },
            name: (control)=>control.name,
            value: (control)=>control.value,
            defaultValue: (control)=>control.defaultValue,
            setValue: (control, value)=>control.value = value,
            disabled: (control)=>control.disabled,
            reportValidity: (control)=>(0, $d0cded150def05db$export$f6e2535fb5126e54)(control.reportValidity) ? control.reportValidity() : true,
            ...options
        };
        this.onFormData = this.onFormData.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onFormReset = this.onFormReset.bind(this);
        this.reportFormValidity = this.reportFormValidity.bind(this);
    }
    hostConnected() {
        this.definedController.whenDefined().then(()=>{
            this.form = this.options.form(this.host);
            if (this.form) this.attachForm(this.form);
        });
    }
    hostDisconnected() {
        this.detachForm();
    }
    hostUpdated() {
        this.definedController.whenDefined().then(()=>{
            const form = this.options.form(this.host);
            if (!form) this.detachForm();
            if (form && this.form !== form) {
                this.detachForm();
                this.attachForm(form);
            }
        });
    }
    /**
     * 获取当前表单控件关联的 `<form>` 元素
     */ getForm() {
        return this.form ?? null;
    }
    /**
     * 重置整个表单，所有表单控件恢复成默认值
     */ reset(invoker) {
        this.doAction('reset', invoker);
    }
    /**
     * 提交整个表单
     */ submit(invoker) {
        this.doAction('submit', invoker);
    }
    attachForm(form) {
        if (!form) {
            this.form = undefined;
            return;
        }
        this.form = form;
        if ((0, $376a384cc549d4e2$export$61a522b559454891).has(this.form)) (0, $376a384cc549d4e2$export$61a522b559454891).get(this.form).add(this.host);
        else (0, $376a384cc549d4e2$export$61a522b559454891).set(this.form, new Set([
            this.host
        ]));
        this.form.addEventListener('formdata', this.onFormData);
        this.form.addEventListener('submit', this.onFormSubmit);
        this.form.addEventListener('reset', this.onFormReset);
        if (!$d56b143b5bf6ad89$var$reportValidityOverloads.has(this.form)) {
            $d56b143b5bf6ad89$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
            this.form.reportValidity = ()=>this.reportFormValidity();
        }
    }
    detachForm() {
        if (this.form) {
            (0, $376a384cc549d4e2$export$61a522b559454891).get(this.form).delete(this.host);
            this.form.removeEventListener('formdata', this.onFormData);
            this.form.removeEventListener('submit', this.onFormSubmit);
            this.form.removeEventListener('reset', this.onFormReset);
            if ($d56b143b5bf6ad89$var$reportValidityOverloads.has(this.form) && !(0, $376a384cc549d4e2$export$61a522b559454891).get(this.form).size) {
                this.form.reportValidity = $d56b143b5bf6ad89$var$reportValidityOverloads.get(this.form);
                $d56b143b5bf6ad89$var$reportValidityOverloads.delete(this.form);
            }
        }
    }
    doAction(type, invoker) {
        if (!this.form) return;
        const $button = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(`<button type="${type}">`).css({
            position: 'absolute',
            width: 0,
            height: 0,
            clipPath: 'inset(50%)',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        });
        const button = $button[0];
        if (invoker) {
            button.name = invoker.name;
            button.value = invoker.value;
            [
                'formaction',
                'formenctype',
                'formmethod',
                'formnovalidate',
                'formtarget'
            ].forEach((attr)=>{
                $button.attr(attr, (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(invoker).attr(attr));
            });
        }
        this.form.append(button);
        button.click();
        button.remove();
    }
    onFormData(event) {
        const disabled = this.options.disabled(this.host);
        const name = this.options.name(this.host);
        const value = this.options.value(this.host);
        // 对于按钮，仅在 type="submit" 时，才提交值。已在 doAction() 方法中把 name、value 注入到 <button> 元素上
        const isButton = [
            'mdui-button',
            'mdui-button-icon',
            'mdui-chip',
            'mdui-fab',
            'mdui-segmented-button'
        ].includes(this.host.tagName.toLowerCase());
        if (!disabled && !isButton && (0, $d0cded150def05db$export$844ec244b1367d54)(name) && name && !(0, $d0cded150def05db$export$fce6876652108ab)(value)) {
            if (Array.isArray(value)) value.forEach((val)=>{
                event.formData.append(name, val.toString());
            });
            else event.formData.append(name, value.toString());
        }
    }
    // todo: 当前组件进行验证的顺序，取决于组件的注册顺序，而不会按在 DOM 中的顺序从上到下验证。如何按 DOM 顺序验证？
    onFormSubmit(event) {
        const disabled = this.options.disabled(this.host);
        const reportValidity = this.options.reportValidity;
        if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    onFormReset() {
        if (this.form) {
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            // 取消 invalid 状态。
            // 此外，还需要在各个组件内，监听值的变更，判断 formResets 中是否存在当前表单控件。若存在则 invalid 设为 false；不存在则设置为 checkValidity() 的值
            // @ts-ignore
            this.host.invalid = false;
            if ($d56b143b5bf6ad89$export$64b1c594674e8d1d.has(this.form)) $d56b143b5bf6ad89$export$64b1c594674e8d1d.get(this.form).add(this.host);
            else $d56b143b5bf6ad89$export$64b1c594674e8d1d.set(this.form, new Set([
                this.host
            ]));
        }
    }
    reportFormValidity() {
        if (this.form && !this.form.noValidate) {
            const elements = (0, $376a384cc549d4e2$export$2742a3285d55034)(this.form);
            for (const element of elements){
                if ((0, $d0cded150def05db$export$f6e2535fb5126e54)(element.reportValidity) && !element.reportValidity()) return false;
            }
        }
        return true;
    }
}




class $86ec33836cc10aec$export$34f6a5ffaa663541 {
    constructor(host, ...slotNames){
        this.slotNames = [];
        (this.host = host).addController(this);
        this.slotNames = slotNames;
        this.onSlotChange = this.onSlotChange.bind(this);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener('slotchange', this.onSlotChange);
        if (!(0, $f94b048e0ef94ba5$export$37e2077ccaabdaf6)()) (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(()=>{
            this.host.requestUpdate();
        });
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener('slotchange', this.onSlotChange);
    }
    test(slotName) {
        return slotName === '[default]' ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== '') return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                if (!el.hasAttribute('slot')) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    onSlotChange(event) {
        const slot = event.target;
        if (this.slotNames.includes('[default]') && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
    }
}


/**
 * defaultValue 装饰器。在 attribute 属性变更时，若值和 property 值不一致，则会保存新的 attribute 值
 *
 * 用于在调用表单的 reset() 方法时，还原成初始值
 *
 * @property({ reflect: true }) value = '';
 * @defaultValue() defaultValue = '';
 *
 * @property({ type: Boolean, reflect: true }) checked = false;
 * @defaultValue('checked') defaultChecked = false;
 */ 

function $138a8c22291c3f8a$export$1a01ae0705bafd37(propertyName = 'value') {
    return (proto, key)=>{
        const constructor = proto.constructor;
        const attributeChangedCallback = constructor.prototype.attributeChangedCallback;
        constructor.prototype.attributeChangedCallback = function(name, old, value) {
            const options = constructor.getPropertyOptions(propertyName);
            const attributeName = (0, $d0cded150def05db$export$844ec244b1367d54)(options.attribute) ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $67bf2f689afe545b$export$7312b35fbf521afb);
                const fromAttribute = (0, $d0cded150def05db$export$f6e2535fb5126e54)(converter) ? converter : converter?.fromAttribute ?? (0, $67bf2f689afe545b$export$7312b35fbf521afb).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };
}


/**
 * watch 装饰器。在 @property 或 @state 属性变更时，且在组件更新前触发
 * 若初始值为 undefined，则初始状态不会触发；否则初始状态就会先触发一次
 *
 * 如果要等属性变更后，且组件更新完成再执行，可以在函数中执行 `await this.updateComplete`
 * 如果要等组件首次渲染完后再监听属性，可以传入第二个参数 true。或者在函数中通过 `this.hasUpdated` 进行判断
 *
 * @watch('propName')
 * handlePropChange(oldValue, newValue) {
 *
 * }
 */ /**
 * @param propName 监听的属性名
 * @param waitUntilFirstUpdate 是否等首次渲染完后再监听
 */ function $f12b6253cef59edc$export$3db5d71bdb2d5499(propName, waitUntilFirstUpdate = false) {
    return (proto, functionName)=>{
        // @ts-ignore
        const { update: update } = proto;
        if (propName in proto) // @ts-ignore
        proto.update = function(changedProperties) {
            if (changedProperties.has(propName)) {
                const oldValue = changedProperties.get(propName);
                const newValue = this[propName];
                if (oldValue !== newValue) {
                    if (!waitUntilFirstUpdate || this.hasUpdated) // @ts-ignore
                    this[functionName](oldValue, newValue);
                }
            }
            update.call(this, changedProperties);
        };
    };
}





let $36acaba128fca20f$var$id = 0;
const $36acaba128fca20f$export$8b15d37bc3f197d4 = ()=>{
    return ++$36acaba128fca20f$var$id;
};


let $6deeb9ef1c73e593$var$weakMap;
// ResizeObserver 实例，所有 resizeObserver 函数内部共用一个 ResizeObserver 实例
let $6deeb9ef1c73e593$var$observer;
const $6deeb9ef1c73e593$export$3e59a5e1472e94f1 = (target, callback)=>{
    const $target = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(target);
    const key = (0, $36acaba128fca20f$export$8b15d37bc3f197d4)();
    // 取消监听函数
    const result = {
        unobserve: ()=>{
            $target.each((_, target)=>{
                const options = $6deeb9ef1c73e593$var$weakMap.get(target);
                const index = options.coArr.findIndex((co)=>co.key === key);
                if (index !== -1) options.coArr.splice(index, 1);
                if (!options.coArr.length) {
                    $6deeb9ef1c73e593$var$observer.unobserve(target);
                    $6deeb9ef1c73e593$var$weakMap.delete(target);
                } else $6deeb9ef1c73e593$var$weakMap.set(target, options);
            });
        }
    };
    // 初始化
    if (!$6deeb9ef1c73e593$var$weakMap) {
        $6deeb9ef1c73e593$var$weakMap = new WeakMap();
        $6deeb9ef1c73e593$var$observer = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const options = $6deeb9ef1c73e593$var$weakMap.get(target);
                options.entry = entry;
                options.coArr.forEach((co)=>{
                    co.callback.call(result, entry, result);
                });
            });
        });
    }
    // 添加监听
    $target.each((_, target)=>{
        const options = $6deeb9ef1c73e593$var$weakMap.get(target) ?? {
            coArr: []
        };
        // 同一个元素已添加过监听后，再次添加新的监听时，不会立即执行回调函数，所以这里手动调用一次回调函数
        if (options.coArr.length && options.entry) callback.call(result, options.entry, result);
        options.coArr.push({
            callback: callback,
            key: key
        });
        $6deeb9ef1c73e593$var$weakMap.set(target, options);
        $6deeb9ef1c73e593$var$observer.observe(target);
    });
    return result;
};



const $ba66167bae03ac3c$export$d9a2b46c01bdcf53 = (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`${(0, $1182a8bbea75578f$export$45b790e32b2810ee)}`;



var $ceFTv = parcelRequire("ceFTv");





const $5c3946173dbb3b52$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{display:inline-block;width:1em;height:1em;line-height:1;font-size:1.5rem}`;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9cca465579216710$export$3bebd1f0e3943985 extends (0, $7f965b17d718bf91$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $1182a8bbea75578f$export$45b790e32b2810ee), i.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $1182a8bbea75578f$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $1182a8bbea75578f$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$9cca465579216710$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $9cca465579216710$export$3bebd1f0e3943985.resultType = 1;
const $9cca465579216710$export$b6e69390c23686fb = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)($9cca465579216710$export$3bebd1f0e3943985);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $b4da4e9924f27d5e$var$t extends (0, $9cca465579216710$export$3bebd1f0e3943985) {
}
$b4da4e9924f27d5e$var$t.directiveName = "unsafeSVG", $b4da4e9924f27d5e$var$t.resultType = 2;
const $b4da4e9924f27d5e$export$1cb98903879b8bf5 = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)($b4da4e9924f27d5e$var$t);




const $c4d72673f184a40e$export$e0e99c6b21dfde8d = (svgPaths)=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor">${(0, $b4da4e9924f27d5e$export$1cb98903879b8bf5)(svgPaths)}</svg>`;


let $317ed60748dc278f$export$1cd6d98f0abf92e8 = class IconCancel_Outlined extends (0, $d7ae2122416faf05$export$3f2f9f5909897157) {
    render() {
        return (0, $c4d72673f184a40e$export$e0e99c6b21dfde8d)('<path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"/>');
    }
};
$317ed60748dc278f$export$1cd6d98f0abf92e8.styles = (0, $5c3946173dbb3b52$export$1d567c320f4763bc);
$317ed60748dc278f$export$1cd6d98f0abf92e8 = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-icon-cancel--outlined')
], $317ed60748dc278f$export$1cd6d98f0abf92e8);



var $ceFTv = parcelRequire("ceFTv");




let $5956650bbe032818$export$66493327321323ad = class IconError extends (0, $d7ae2122416faf05$export$3f2f9f5909897157) {
    render() {
        return (0, $c4d72673f184a40e$export$e0e99c6b21dfde8d)('<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>');
    }
};
$5956650bbe032818$export$66493327321323ad.styles = (0, $5c3946173dbb3b52$export$1d567c320f4763bc);
$5956650bbe032818$export$66493327321323ad = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-icon-error')
], $5956650bbe032818$export$66493327321323ad);



var $ceFTv = parcelRequire("ceFTv");




let $0d3529f6d2816e34$export$9ef36bcf05bb63d9 = class IconVisibilityOff extends (0, $d7ae2122416faf05$export$3f2f9f5909897157) {
    render() {
        return (0, $c4d72673f184a40e$export$e0e99c6b21dfde8d)('<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>');
    }
};
$0d3529f6d2816e34$export$9ef36bcf05bb63d9.styles = (0, $5c3946173dbb3b52$export$1d567c320f4763bc);
$0d3529f6d2816e34$export$9ef36bcf05bb63d9 = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-icon-visibility-off')
], $0d3529f6d2816e34$export$9ef36bcf05bb63d9);



var $ceFTv = parcelRequire("ceFTv");




let $023823aba27ba933$export$e8b904c5d6d728c0 = class IconVisibility extends (0, $d7ae2122416faf05$export$3f2f9f5909897157) {
    render() {
        return (0, $c4d72673f184a40e$export$e0e99c6b21dfde8d)('<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>');
    }
};
$023823aba27ba933$export$e8b904c5d6d728c0.styles = (0, $5c3946173dbb3b52$export$1d567c320f4763bc);
$023823aba27ba933$export$e8b904c5d6d728c0 = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-icon-visibility')
], $023823aba27ba933$export$e8b904c5d6d728c0);






// Do not modify this file by hand!
// Re-generate this file by running lit-localize.
/**
 * The locale code that templates in this source code are written in.
 */ const $283b698e093e044b$export$39ee57b29e1d3664 = `en-us`;
const $283b698e093e044b$export$764c106d5e590918 = [
    `ar-eg`,
    `az-az`,
    `be-by`,
    `bg-bg`,
    `bn-bd`,
    `ca-es`,
    `cs-cz`,
    `da-dk`,
    `de-de`,
    `el-gr`,
    `en-gb`,
    `es-es`,
    `et-ee`,
    `fa-ir`,
    `fi-fi`,
    `fr-be`,
    `fr-ca`,
    `fr-fr`,
    `ga-ie`,
    `gl-es`,
    `he-il`,
    `hi-in`,
    `hr-hr`,
    `hu-hu`,
    `hy-am`,
    `id-id`,
    `is-is`,
    `it-it`,
    `ja-jp`,
    `ka-ge`,
    `kk-kz`,
    `km-kh`,
    `kmr-iq`,
    `kn-in`,
    `ko-kr`,
    `lt-lt`,
    `lv-lv`,
    `mk-mk`,
    `ml-in`,
    `mn-mn`,
    `ms-my`,
    `nb-no`,
    `ne-np`,
    `nl-be`,
    `nl-nl`,
    `pl-pl`,
    `pt-br`,
    `pt-pt`,
    `ro-ro`,
    `ru-ru`,
    `sk-sk`,
    `sl-si`,
    `sr-rs`,
    `sv-se`,
    `ta-in`,
    `th-th`,
    `tr-tr`,
    `uk-ua`,
    `ur-pk`,
    `vi-vn`,
    `zh-cn`,
    `zh-hk`,
    `zh-tw`
];
const $283b698e093e044b$export$70e81b5f5f7c5b5e = [
    `ar-eg`,
    `az-az`,
    `be-by`,
    `bg-bg`,
    `bn-bd`,
    `ca-es`,
    `cs-cz`,
    `da-dk`,
    `de-de`,
    `el-gr`,
    `en-gb`,
    `en-us`,
    `es-es`,
    `et-ee`,
    `fa-ir`,
    `fi-fi`,
    `fr-be`,
    `fr-ca`,
    `fr-fr`,
    `ga-ie`,
    `gl-es`,
    `he-il`,
    `hi-in`,
    `hr-hr`,
    `hu-hu`,
    `hy-am`,
    `id-id`,
    `is-is`,
    `it-it`,
    `ja-jp`,
    `ka-ge`,
    `kk-kz`,
    `km-kh`,
    `kmr-iq`,
    `kn-in`,
    `ko-kr`,
    `lt-lt`,
    `lv-lv`,
    `mk-mk`,
    `ml-in`,
    `mn-mn`,
    `ms-my`,
    `nb-no`,
    `ne-np`,
    `nl-be`,
    `nl-nl`,
    `pl-pl`,
    `pt-br`,
    `pt-pt`,
    `ro-ro`,
    `ru-ru`,
    `sk-sk`,
    `sl-si`,
    `sr-rs`,
    `sv-se`,
    `ta-in`,
    `th-th`,
    `tr-tr`,
    `uk-ua`,
    `ur-pk`,
    `vi-vn`,
    `zh-cn`,
    `zh-hk`,
    `zh-tw`
];


const $e9597e517ca085a3$export$25449c41b7f50954 = 'You must call `loadLocale` first to set up the localized template.';
let $e9597e517ca085a3$export$180605366c04f0cd;
let $e9597e517ca085a3$export$c8aadf3621e41efb;
const $e9597e517ca085a3$export$c39d0997d2ad54b6 = (loadFunc)=>{
    const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
    const result = (0, $1ecbf2487989fc64$export$2f3903bcf09d572a)({
        sourceLocale: $283b698e093e044b$export$39ee57b29e1d3664,
        targetLocales: $283b698e093e044b$export$764c106d5e590918,
        loadLocale: loadFunc
    });
    $e9597e517ca085a3$export$180605366c04f0cd = result.getLocale;
    $e9597e517ca085a3$export$c8aadf3621e41efb = result.setLocale;
    window.addEventListener((0, $297de31ed8b176bc$export$22ecc5ec4a7dfb64), (event)=>{
        window.dispatchEvent(new CustomEvent('mdui-localize-status', {
            detail: event.detail
        }));
    });
};
let $e9597e517ca085a3$var$listeningLitLocalizeStatus = false;
const $e9597e517ca085a3$var$localeReadyCallbacksMap = new Map();
const $e9597e517ca085a3$export$995a2c2a1ff886c = (target, callback)=>{
    if (!$e9597e517ca085a3$var$listeningLitLocalizeStatus) {
        $e9597e517ca085a3$var$listeningLitLocalizeStatus = true;
        const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
        window.addEventListener((0, $297de31ed8b176bc$export$22ecc5ec4a7dfb64), (event)=>{
            if (event.detail.status === 'ready') $e9597e517ca085a3$var$localeReadyCallbacksMap.forEach((callbacks)=>{
                callbacks.forEach((cb)=>cb());
            });
        });
    }
    const callbacks = $e9597e517ca085a3$var$localeReadyCallbacksMap.get(target) || [];
    callbacks.push(callback);
    $e9597e517ca085a3$var$localeReadyCallbacksMap.set(target, callbacks);
};
const $e9597e517ca085a3$export$2120695e25bf904e = (target)=>{
    $e9597e517ca085a3$var$localeReadyCallbacksMap.delete(target);
};



var $ceFTv = parcelRequire("ceFTv");








var $ceFTv = parcelRequire("ceFTv");



function $6ff99a31914becfa$export$2e2bcd8739ae039(names) {
    if (typeof names === "string" || typeof names === "number") return "" + names;
    let out = "";
    if (Array.isArray(names)) {
        for(let i = 0, tmp; i < names.length; i++)if ((tmp = $6ff99a31914becfa$export$2e2bcd8739ae039(names[i])) !== "") out += (out && " ") + tmp;
    } else {
        for(let k in names)if (names[k]) out += (out && " ") + k;
    }
    return out;
}










var $ceFTv = parcelRequire("ceFTv");







const $88c4b251730a74bc$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{position:relative;display:inline-block;flex-shrink:0;width:2.5rem;height:2.5rem;stroke:rgb(var(--mdui-color-primary))}.progress{position:relative;display:inline-block;width:100%;height:100%;text-align:left;transition:opacity var(--mdui-motion-duration-medium1) var(--mdui-motion-easing-linear)}.determinate svg{transform:rotate(-90deg);fill:transparent}.determinate .track{stroke:transparent}.determinate .circle{stroke:inherit;transition:stroke-dashoffset var(--mdui-motion-duration-long2) var(--mdui-motion-easing-standard)}.indeterminate{font-size:0;letter-spacing:0;white-space:nowrap;animation:mdui-comp-circular-progress-rotate 1568ms var(--mdui-motion-easing-linear) infinite}.indeterminate .circle,.indeterminate .layer{position:absolute;width:100%;height:100%}.indeterminate .layer{animation:mdui-comp-circular-progress-layer-rotate 5332ms var(--mdui-motion-easing-standard) infinite both}.indeterminate .circle{fill:transparent;stroke:inherit}.indeterminate .gap-patch{position:absolute;top:0;left:47.5%;width:5%;height:100%;overflow:hidden}.indeterminate .gap-patch .circle{left:-900%;width:2000%;transform:rotate(180deg)}.indeterminate .clipper{position:relative;display:inline-block;width:50%;height:100%;overflow:hidden}.indeterminate .clipper .circle{width:200%}.indeterminate .clipper.left .circle{animation:mdui-comp-circular-progress-left-spin 1333ms var(--mdui-motion-easing-standard) infinite both}.indeterminate .clipper.right .circle{left:-100%;animation:mdui-comp-circular-progress-right-spin 1333ms var(--mdui-motion-easing-standard) infinite both}@keyframes mdui-comp-circular-progress-rotate{to{transform:rotate(360deg)}}@keyframes mdui-comp-circular-progress-layer-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}}@keyframes mdui-comp-circular-progress-left-spin{0%{transform:rotate(265deg)}50%{transform:rotate(130deg)}100%{transform:rotate(265deg)}}@keyframes mdui-comp-circular-progress-right-spin{0%{transform:rotate(-265deg)}50%{transform:rotate(-130deg)}100%{transform:rotate(-265deg)}}`;


/**
 * @summary 圆形进度指示器组件
 *
 * ```html
 * <mdui-circular-progress></mdui-circular-progress>
 * ```
 */ let $24b7d1db3ddd7bcf$export$9e72f56a493060bf = class CircularProgress extends (0, $53a1aafae9c6752a$export$9bb0a9faa319390c) {
    constructor(){
        super(...arguments);
        /**
         * 进度指示器的最大值。默认为 `1`
         */ this.max = 1;
    }
    render() {
        const isDeterminate = !(0, $d0cded150def05db$export$fce6876652108ab)(this.value);
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div class="progress ${(0, $c9d15c868ac73f05$export$56cc687933817664)({
            determinate: isDeterminate,
            indeterminate: !isDeterminate
        })}">${isDeterminate ? this.renderDeterminate() : this.renderInDeterminate()}</div>`;
    }
    renderDeterminate() {
        const value = this.value;
        const strokeWidth = 4; // 圆环宽度
        const circleRadius = 18; // 圆环宽度中心点的半径
        const \u03C0 = 3.1415926;
        const center = circleRadius + strokeWidth / 2;
        const circumference = 2 * \u03C0 * circleRadius;
        const determinateStrokeDashOffset = (1 - value / Math.max(this.max ?? value, value)) * circumference;
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<svg viewBox="0 0 ${center * 2} ${center * 2}"><circle class="track" cx="${center}" cy="${center}" r="${circleRadius}" stroke-width="${strokeWidth}"></circle><circle class="circle" cx="${center}" cy="${center}" r="${circleRadius}" stroke-dasharray="${2 * \u03C0 * circleRadius}" stroke-dashoffset="${determinateStrokeDashOffset}" stroke-width="${strokeWidth}"></circle></svg>`;
    }
    renderInDeterminate() {
        const strokeWidth = 4; // 圆环宽度
        const circleRadius = 18; // 圆环宽度中心点的半径
        const \u03C0 = 3.1415926;
        const center = circleRadius + strokeWidth / 2;
        const circumference = 2 * \u03C0 * circleRadius;
        const halfCircumference = 0.5 * circumference;
        const circle = (thisStrokeWidth)=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<svg class="circle" viewBox="0 0 ${center * 2} ${center * 2}"><circle cx="${center}" cy="${center}" r="${circleRadius}" stroke-dasharray="${circumference}" stroke-dashoffset="${halfCircumference}" stroke-width="${thisStrokeWidth}"></circle></svg>`;
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div class="layer"><div class="clipper left">${circle(strokeWidth)}</div><div class="gap-patch">${circle(strokeWidth * 0.8)}</div><div class="clipper right">${circle(strokeWidth)}</div></div>`;
    }
};
$24b7d1db3ddd7bcf$export$9e72f56a493060bf.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $88c4b251730a74bc$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $24b7d1db3ddd7bcf$export$9e72f56a493060bf.prototype, "max", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number
    })
], $24b7d1db3ddd7bcf$export$9e72f56a493060bf.prototype, "value", void 0);
$24b7d1db3ddd7bcf$export$9e72f56a493060bf = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-circular-progress')
], $24b7d1db3ddd7bcf$export$9e72f56a493060bf);






const $eeff11f728ecfc08$export$fde5e54d6ffcadff = (0, $0268acc93e67b930$export$dbf350e5966cf602)`.button{position:relative;display:inline-flex;align-items:center;justify-content:center;height:100%;padding:0;overflow:hidden;color:inherit;font-size:inherit;font-family:inherit;font-weight:inherit;letter-spacing:inherit;white-space:nowrap;text-align:center;text-decoration:none;vertical-align:middle;background:0 0;border:none;outline:0;cursor:inherit;-webkit-user-select:none;user-select:none;touch-action:manipulation;zoom:1;-webkit-user-drag:none}`;


class $d2ad4ee595242e3a$export$b0bb876e969289cd extends (0, $127a23c52a5adf4f$export$e70f90f657dd64e)((0, $abaf2949eee28760$export$7891358133f12319)((0, $3bb9ba68ccebecb9$export$7b86c168e7d309f7)((0, $53a1aafae9c6752a$export$9bb0a9faa319390c)))) {
    constructor(){
        super(...arguments);
        /**
         * 是否禁用
         */ this.disabled = false;
        /**
         * 是否处于加载中状态
         */ this.loading = false;
        /**
         * 按钮的名称，将与表单数据一起提交。
         *
         * **Note**：仅在未设置 `href` 属性时，此属性才有效。
         */ this.name = '';
        /**
         * 按钮的初始值，将与表单数据一起提交。
         *
         * **Note**：仅在未设置 `href` 属性时，此属性才有效。
         */ this.value = '';
        /**
         * 按钮的类型。默认类型为 `button`。可选类型包括：
         *
         * * `submit`：点击按钮会提交表单数据到服务器
         * * `reset`：点击按钮会将表单中的所有字段重置为初始值
         * * `button`：此类型的按钮没有默认行为
         *
         * **Note**：仅在未指定 `href` 属性时，此属性才有效。
         */ this.type = 'button';
        /**
         * 如果设置了此属性，表单提交时将不执行表单验证。
         *
         * 如果设置了此属性，将覆盖 `<form>` 元素的 `novalidate` 属性。
         *
         * **Note**：仅在未设置 `href` 属性且 `type="submit"` 时，此属性才有效。
         */ this.formNoValidate = false;
        this.formController = new (0, $d56b143b5bf6ad89$export$2ecd466f59952f38)(this);
    }
    /**
     * 表单验证状态对象，具体参见 [`ValidityState`](https://developer.mozilla.org/zh-CN/docs/Web/API/ValidityState)
     */ get validity() {
        if (this.isButton()) return this.focusElement.validity;
    }
    /**
     * 如果表单验证未通过，此属性将包含提示信息。如果验证通过，此属性将为空字符串
     */ get validationMessage() {
        if (this.isButton()) return this.focusElement.validationMessage;
    }
    get rippleDisabled() {
        return this.disabled || this.loading;
    }
    get focusElement() {
        return this.isButton() ? this.renderRoot?.querySelector('._button') : !this.focusDisabled ? this.renderRoot?.querySelector('._a') : this;
    }
    get focusDisabled() {
        return this.disabled || this.loading;
    }
    /**
     * 检查表单字段是否通过验证。如果未通过，返回 `false` 并触发 `invalid` 事件；如果通过，返回 `true`
     */ checkValidity() {
        if (this.isButton()) {
            const valid = this.focusElement.checkValidity();
            if (!valid) // @ts-ignore
            this.emit('invalid', {
                bubbles: false,
                cancelable: true,
                composed: false
            });
            return valid;
        }
        return true;
    }
    /**
     * 检查表单字段是否通过验证。如果未通过，返回 `false` 并触发 `invalid` 事件；如果通过，返回 `true`。
     *
     * 如果验证未通过，还会在组件上显示验证失败的提示。
     */ reportValidity() {
        if (this.isButton()) {
            const invalid = !this.focusElement.reportValidity();
            if (invalid) // @ts-ignore
            this.emit('invalid', {
                bubbles: false,
                cancelable: true,
                composed: false
            });
            return !invalid;
        }
        return true;
    }
    /**
     * 设置自定义的错误提示文本。只要这个文本不为空，就表示字段未通过验证
     *
     * @param message 自定义的错误提示文本
     */ setCustomValidity(message) {
        if (this.isButton()) this.focusElement.setCustomValidity(message);
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.addEventListener('click', ()=>{
            if (this.type === 'submit') this.formController.submit(this);
            if (this.type === 'reset') this.formController.reset(this);
        });
    }
    renderLoading() {
        return this.loading ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-circular-progress part="loading"></mdui-circular-progress>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53);
    }
    renderButton({ id: id, className: className, part: part, content: content = (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>` }) {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<button id="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(id)}" class="${(0, $6ff99a31914becfa$export$2e2bcd8739ae039)([
            '_button',
            className
        ])}" part="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(part)}" ?disabled="${this.rippleDisabled || this.focusDisabled}">${content}</button>`;
    }
    isButton() {
        return !this.href;
    }
}
$d2ad4ee595242e3a$export$b0bb876e969289cd.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $eeff11f728ecfc08$export$fde5e54d6ffcadff)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "disabled", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "loading", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "name", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "value", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "type", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "form", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'formaction'
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "formAction", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'formenctype'
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "formEnctype", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'formmethod'
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "formMethod", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'formnovalidate'
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "formNoValidate", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'formtarget'
    })
], $d2ad4ee595242e3a$export$b0bb876e969289cd.prototype, "formTarget", void 0);



var $ceFTv = parcelRequire("ceFTv");




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $30616b9c1b48e973$var$n = "important", $30616b9c1b48e973$var$i = " !" + $30616b9c1b48e973$var$n, $30616b9c1b48e973$export$1e5b4ce2fa884e6a = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)(class extends (0, $7f965b17d718bf91$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $7f965b17d718bf91$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($30616b9c1b48e973$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $30616b9c1b48e973$var$n : "") : s[t] = e;
            }
        }
        return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
    }
});








/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b27e2e9450fc6a62$export$74673a32c6041f3e = async (t, s)=>{
    for await (const i of t)if (!1 === await s(i)) return;
};
class $b27e2e9450fc6a62$export$71341b9b69479007 {
    constructor(t){
        this.Y = t;
    }
    disconnect() {
        this.Y = void 0;
    }
    reconnect(t) {
        this.Y = t;
    }
    deref() {
        return this.Y;
    }
}
class $b27e2e9450fc6a62$export$193ea5a420bb5c41 {
    constructor(){
        this.Z = void 0, this.q = void 0;
    }
    get() {
        return this.Z;
    }
    pause() {
        this.Z ??= new Promise((t)=>this.q = t);
    }
    resume() {
        this.q?.(), this.Z = this.q = void 0;
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d8983edf6b6eda44$var$n = (t)=>!(0, $dc08001cbc3c8af5$export$c3825b437cbdea5c)(t) && "function" == typeof t.then, $d8983edf6b6eda44$var$h = 1073741823;
class $d8983edf6b6eda44$export$51c6edf8ee19b71a extends (0, $044d98491ba33eb0$export$7d025501802325e) {
    constructor(){
        super(...arguments), this._$Cwt = $d8983edf6b6eda44$var$h, this._$Cbt = [], this._$CK = new (0, $b27e2e9450fc6a62$export$71341b9b69479007)(this), this._$CX = new (0, $b27e2e9450fc6a62$export$193ea5a420bb5c41);
    }
    render(...s) {
        return s.find((t)=>!$d8983edf6b6eda44$var$n(t)) ?? (0, $1182a8bbea75578f$export$9c068ae9cc5db4e8);
    }
    update(s, i) {
        const e = this._$Cbt;
        let r = e.length;
        this._$Cbt = i;
        const o = this._$CK, c = this._$CX;
        this.isConnected || this.disconnected();
        for(let t = 0; t < i.length && !(t > this._$Cwt); t++){
            const s = i[t];
            if (!$d8983edf6b6eda44$var$n(s)) return this._$Cwt = t, s;
            t < r && s === e[t] || (this._$Cwt = $d8983edf6b6eda44$var$h, r = 0, Promise.resolve(s).then(async (t)=>{
                for(; c.get();)await c.get();
                const i = o.deref();
                if (void 0 !== i) {
                    const e = i._$Cbt.indexOf(s);
                    e > -1 && e < i._$Cwt && (i._$Cwt = e, i.setValue(t));
                }
            }));
        }
        return 0, $1182a8bbea75578f$export$9c068ae9cc5db4e8;
    }
    disconnected() {
        this._$CK.disconnect(), this._$CX.pause();
    }
    reconnected() {
        this._$CK.reconnect(this), this._$CX.resume();
    }
}
const $d8983edf6b6eda44$export$a40009bd2c363351 = (0, $7f965b17d718bf91$export$99b43ad1ed32e735)($d8983edf6b6eda44$export$51c6edf8ee19b71a);









(0, $b95421a1db56b097$export$3d8c2f653ac9d0b9).fn.trigger = function(name, // eslint-disable-next-line @typescript-eslint/no-explicit-any
detail = null, options) {
    const { type: type, namespace: namespace } = (0, $c9243290d90ea08c$export$98e6a39c04603d36)(name);
    const event = new (0, $c9243290d90ea08c$export$df19c5abb73be735)(type, {
        detail: detail,
        data: null,
        namespace: namespace,
        bubbles: true,
        cancelable: false,
        composed: true,
        ...options
    });
    return this.each((_, element)=>{
        element.dispatchEvent(event);
    });
};





const $1e3e766d9280c80a$export$6b2c617adea21f3c = 'ajaxStart';
const $1e3e766d9280c80a$export$edf1da70bd7fb56d = 'ajaxSuccess';
const $1e3e766d9280c80a$export$1d84e373e41d1900 = 'ajaxError';
const $1e3e766d9280c80a$export$daf97b5ec893c045 = 'ajaxComplete';
const $1e3e766d9280c80a$export$106e2f2d32348bb = {};
const $1e3e766d9280c80a$export$a497d4fec1af79d7 = (method)=>{
    return [
        'GET',
        'HEAD'
    ].includes(method);
};
const $1e3e766d9280c80a$export$8fa1eaeb4700701e = (url, query)=>{
    return `${url}&${query}`.replace(/[&?]{1,2}/, '?');
};
const $1e3e766d9280c80a$export$c3a3240a17b6712 = (url)=>{
    const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
    return /^([\w-]+:)?\/\/([^/]+)/.test(url) && RegExp.$2 !== window.location.host;
};
const $1e3e766d9280c80a$export$ce01fa4b1b0d6c2c = (status)=>{
    return status >= 200 && status < 300 || [
        0,
        304
    ].includes(status);
};
const $1e3e766d9280c80a$export$235b7fc70b9fc359 = (options)=>{
    // 默认参数
    const defaults = {
        url: '',
        method: 'GET',
        data: '',
        processData: true,
        async: true,
        cache: true,
        username: '',
        password: '',
        headers: {},
        xhrFields: {},
        statusCode: {},
        dataType: '',
        contentType: 'application/x-www-form-urlencoded',
        timeout: 0,
        global: true
    };
    // globalOptions 中的回调函数不合并
    (0, $d0cded150def05db$export$1b8ac1d3a07c9372)($1e3e766d9280c80a$export$106e2f2d32348bb, (key, value)=>{
        const callbacks = [
            'beforeSend',
            'success',
            'error',
            'complete',
            'statusCode'
        ];
        if (!callbacks.includes(key) && !(0, $d0cded150def05db$export$fce6876652108ab)(value)) defaults[key] = value;
    });
    return (0, $229897d88c30053c$export$8b58be045bf06082)({}, defaults, options);
};




const $e54f7c33f3bbdba8$export$6f7d1d9d04558207 = (obj)=>{
    if (!(0, $d0cded150def05db$export$c10d0b04eaa80a43)(obj) && !Array.isArray(obj)) return '';
    const args = [];
    const destructure = (key, value)=>{
        let keyTmp;
        if ((0, $d0cded150def05db$export$c10d0b04eaa80a43)(value)) (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(value, (i, v)=>{
            keyTmp = Array.isArray(value) && !(0, $d0cded150def05db$export$c10d0b04eaa80a43)(v) ? '' : i;
            destructure(`${key}[${keyTmp}]`, v);
        });
        else {
            keyTmp = value == null || value === '' ? '=' : `=${encodeURIComponent(value)}`;
            args.push(encodeURIComponent(key) + keyTmp);
        }
    };
    if (Array.isArray(obj)) (0, $d0cded150def05db$export$211b8db791997e25)(obj, ({ name: name, value: value })=>{
        return destructure(name, value);
    });
    else (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(obj, destructure);
    return args.join('&');
};


const $08db1f021c5655eb$export$e68fce4c5f453854 = (options)=>{
    const document = (0, $c87de1375632dba4$export$f65ca476c09acec0)();
    const window = (0, $c87de1375632dba4$export$38b2d434cce3ea22)();
    // 是否已取消请求
    let isCanceled = false;
    // ajaxStart、ajaxError、ajaxComplete 事件参数
    // @ts-ignore
    const eventParams = {};
    // ajaxSuccess 事件参数
    // @ts-ignore
    const successEventParams = {};
    // 参数合并
    const mergedOptions = (0, $1e3e766d9280c80a$export$235b7fc70b9fc359)(options);
    const method = mergedOptions.method.toUpperCase();
    let { data: data, url: url } = mergedOptions;
    url = url || window.location.toString();
    const { processData: processData, async: async, cache: cache, username: username, password: password, headers: headers, xhrFields: xhrFields, statusCode: statusCode, dataType: dataType, contentType: contentType, timeout: timeout, global: global } = mergedOptions;
    // 需要发送的数据
    // GET/HEAD 请求和 processData 为 true 时，转换为查询字符串格式，特殊格式不转换
    const isMethodQueryString = (0, $1e3e766d9280c80a$export$a497d4fec1af79d7)(method);
    if (data && (isMethodQueryString || processData) && !(0, $d0cded150def05db$export$844ec244b1367d54)(data) && !(data instanceof ArrayBuffer) && !(data instanceof Blob) && !(data instanceof Document) && !(data instanceof FormData)) data = (0, $e54f7c33f3bbdba8$export$6f7d1d9d04558207)(data);
    // 对于 GET、HEAD 类型的请求，把 data 数据添加到 URL 中
    if (data && isMethodQueryString) {
        // 查询字符串拼接到 URL 中
        url = (0, $1e3e766d9280c80a$export$8fa1eaeb4700701e)(url, data);
        data = null;
    }
    /**
     * 触发事件和回调函数
     * @param event
     * @param callback
     * @param args
     */ const trigger = (event, callback, ...args)=>{
        // 触发全局事件
        if (global) (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(document).trigger(event, callback === 'success' ? successEventParams : eventParams);
        // 触发 ajax 回调和事件
        let resultGlobal;
        let resultCustom;
        // 全局回调
        if (callback in (0, $1e3e766d9280c80a$export$106e2f2d32348bb)) // @ts-ignore
        resultGlobal = (0, $1e3e766d9280c80a$export$106e2f2d32348bb)[callback](...args);
        // 自定义回调
        if (mergedOptions[callback]) // @ts-ignore
        resultCustom = mergedOptions[callback](...args);
        // beforeSend 回调返回 false 时取消 ajax 请求
        if (callback === 'beforeSend' && [
            resultGlobal,
            resultCustom
        ].includes(false)) isCanceled = true;
    };
    // XMLHttpRequest 请求
    const XHR = ()=>{
        let textStatus;
        return new Promise((resolve, reject)=>{
            const doReject = (reason)=>{
                return reject(new Error(reason));
            };
            // GET/HEAD 请求的缓存处理
            if (isMethodQueryString && !cache) url = (0, $1e3e766d9280c80a$export$8fa1eaeb4700701e)(url, `_=${Date.now()}`);
            // 创建 XHR
            const xhr = new XMLHttpRequest();
            xhr.open(method, url, async, username, password);
            if (contentType || data && !isMethodQueryString && contentType !== false) xhr.setRequestHeader('Content-Type', contentType);
            // 设置 Accept
            if (dataType === 'json') xhr.setRequestHeader('Accept', 'application/json, text/javascript');
            // 添加 headers
            (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(headers, (key, value)=>{
                // undefined 值不发送，string 和 null 需要发送
                if (!(0, $d0cded150def05db$export$fce6876652108ab)(value)) xhr.setRequestHeader(key, value + ''); // 把 null 转换成字符串
            });
            // 检查是否是跨域请求，跨域请求时不添加 X-Requested-With
            if (!(0, $1e3e766d9280c80a$export$c3a3240a17b6712)(url)) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            // 设置 xhr 选项
            (0, $d0cded150def05db$export$1b8ac1d3a07c9372)(xhrFields, (key, value)=>{
                xhr[key] = value;
            });
            eventParams.xhr = successEventParams.xhr = xhr;
            eventParams.options = successEventParams.options = mergedOptions;
            let xhrTimeout;
            xhr.onload = ()=>{
                if (xhrTimeout) clearTimeout(xhrTimeout);
                // AJAX 返回的 HTTP 响应码是否表示成功
                const isSuccess = (0, $1e3e766d9280c80a$export$ce01fa4b1b0d6c2c)(xhr.status);
                // @ts-ignore
                let responseData = undefined;
                if (isSuccess) {
                    textStatus = xhr.status === 204 || method === 'HEAD' ? 'nocontent' : xhr.status === 304 ? 'notmodified' : 'success';
                    if (dataType === 'json' || !dataType && (xhr.getResponseHeader('content-type') || '').includes('json')) {
                        try {
                            responseData = method === 'HEAD' ? undefined : JSON.parse(xhr.responseText);
                            successEventParams.response = responseData;
                        } catch (err) {
                            textStatus = 'parsererror';
                            trigger((0, $1e3e766d9280c80a$export$1d84e373e41d1900), 'error', xhr, textStatus);
                            doReject(textStatus);
                        }
                        if (textStatus !== 'parsererror') {
                            trigger((0, $1e3e766d9280c80a$export$edf1da70bd7fb56d), 'success', responseData, textStatus, xhr);
                            resolve(responseData);
                        }
                    } else {
                        responseData = method === 'HEAD' ? undefined : xhr.responseType === 'text' || xhr.responseType === '' ? xhr.responseText : xhr.response;
                        successEventParams.response = responseData;
                        trigger((0, $1e3e766d9280c80a$export$edf1da70bd7fb56d), 'success', responseData, textStatus, xhr);
                        resolve(responseData);
                    }
                } else {
                    textStatus = 'error';
                    trigger((0, $1e3e766d9280c80a$export$1d84e373e41d1900), 'error', xhr, textStatus);
                    doReject(textStatus);
                }
                // statusCode
                (0, $d0cded150def05db$export$211b8db791997e25)([
                    (0, $1e3e766d9280c80a$export$106e2f2d32348bb).statusCode ?? {},
                    statusCode
                ], (func)=>{
                    if (func[xhr.status]) {
                        if (isSuccess) func[xhr.status](responseData, textStatus, xhr);
                        else func[xhr.status](xhr, textStatus);
                    }
                });
                trigger((0, $1e3e766d9280c80a$export$daf97b5ec893c045), 'complete', xhr, textStatus);
            };
            xhr.onerror = ()=>{
                if (xhrTimeout) clearTimeout(xhrTimeout);
                trigger((0, $1e3e766d9280c80a$export$1d84e373e41d1900), 'error', xhr, xhr.statusText);
                trigger((0, $1e3e766d9280c80a$export$daf97b5ec893c045), 'complete', xhr, 'error');
                doReject(xhr.statusText);
            };
            xhr.onabort = ()=>{
                let statusText = 'abort';
                if (xhrTimeout) {
                    statusText = 'timeout';
                    clearTimeout(xhrTimeout);
                }
                trigger((0, $1e3e766d9280c80a$export$1d84e373e41d1900), 'error', xhr, statusText);
                trigger((0, $1e3e766d9280c80a$export$daf97b5ec893c045), 'complete', xhr, statusText);
                doReject(statusText);
            };
            // ajax start 回调
            trigger((0, $1e3e766d9280c80a$export$6b2c617adea21f3c), 'beforeSend', xhr, mergedOptions);
            if (isCanceled) return doReject('cancel');
            // Timeout
            if (timeout > 0) xhrTimeout = window.setTimeout(()=>xhr.abort(), timeout);
            // 发送 XHR
            xhr.send(data);
        });
    };
    return XHR();
};






const $42da3c15efb64b42$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{display:inline-block;width:1em;height:1em;font-weight:400;font-family:'Material Icons';font-display:block;font-style:normal;line-height:1;direction:ltr;letter-spacing:normal;white-space:nowrap;text-transform:none;word-wrap:normal;-webkit-font-smoothing:antialiased;text-rendering:optimizelegibility;-moz-osx-font-smoothing:grayscale;font-size:1.5rem}::slotted(svg),svg{width:100%;height:100%;fill:currentcolor}`;


/**
 * @summary 图标组件
 *
 * ```html
 * <mdui-icon name="search"></mdui-icon>
 * ```
 *
 * @slot - `svg` 图标的内容
 */ let $ace75c505bb200c7$export$f04a61298a47a40f = class Icon extends (0, $53a1aafae9c6752a$export$9bb0a9faa319390c) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $86ec33836cc10aec$export$34f6a5ffaa663541)(this, '[default]');
    }
    render() {
        const renderDefault = ()=>{
            if (this.name) {
                const [name, variant] = this.name.split('--');
                const familyMap = new Map([
                    [
                        'outlined',
                        'Material Icons Outlined'
                    ],
                    [
                        'filled',
                        'Material Icons'
                    ],
                    [
                        'rounded',
                        'Material Icons Round'
                    ],
                    [
                        'sharp',
                        'Material Icons Sharp'
                    ],
                    [
                        'two-tone',
                        'Material Icons Two Tone'
                    ]
                ]);
                return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<span style="${(0, $30616b9c1b48e973$export$1e5b4ce2fa884e6a)({
                    fontFamily: familyMap.get(variant)
                })}">${name}</span>`;
            }
            if (this.src) return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`${(0, $d8983edf6b6eda44$export$a40009bd2c363351)((0, $08db1f021c5655eb$export$e68fce4c5f453854)({
                url: this.src
            }).then((0, $b4da4e9924f27d5e$export$1cb98903879b8bf5)))}`;
            return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)``;
        };
        return this.hasSlotController.test('[default]') ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>` : renderDefault();
    }
};
$ace75c505bb200c7$export$f04a61298a47a40f.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $42da3c15efb64b42$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $ace75c505bb200c7$export$f04a61298a47a40f.prototype, "name", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $ace75c505bb200c7$export$f04a61298a47a40f.prototype, "src", void 0);
$ace75c505bb200c7$export$f04a61298a47a40f = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-icon')
], $ace75c505bb200c7$export$f04a61298a47a40f);





const $a0812466456bb63e$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{--shape-corner:var(--mdui-shape-corner-full);position:relative;display:inline-block;flex-shrink:0;overflow:hidden;text-align:center;border-radius:var(--shape-corner);cursor:pointer;-webkit-tap-highlight-color:transparent;font-size:1.5rem;width:2.5rem;height:2.5rem}:host([variant=standard]){color:rgb(var(--mdui-color-on-surface-variant));--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-surface-variant)}:host([variant=filled]){color:rgb(var(--mdui-color-primary));background-color:rgb(var(--mdui-color-surface-container-highest));--mdui-comp-ripple-state-layer-color:var(--mdui-color-primary)}:host([variant=tonal]){color:rgb(var(--mdui-color-on-surface-variant));background-color:rgb(var(--mdui-color-surface-container-highest));--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-surface-variant)}:host([variant=outlined]){border:.0625rem solid rgb(var(--mdui-color-outline));color:rgb(var(--mdui-color-on-surface-variant));--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-surface-variant)}:host([variant=outlined][pressed]){color:rgb(var(--mdui-color-on-surface));--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-surface)}:host([variant=standard][selected]:not([selected=false i])){color:rgb(var(--mdui-color-primary));--mdui-comp-ripple-state-layer-color:var(--mdui-color-primary)}:host([variant=filled]:not([selectable])),:host([variant=filled][selectable=false i]),:host([variant=filled][selected]:not([selected=false i])){color:rgb(var(--mdui-color-on-primary));background-color:rgb(var(--mdui-color-primary));--mdui-comp-ripple-state-layer-color:var(--mdui-color-on-primary)}:host([variant=tonal]:not([selectable])),:host([variant=tonal][selectable=false i]),:host([variant=tonal][selected]:not([selected=false i])){color:rgb(var(--mdui-color-on-secondary-container));background-color:rgb(var(--mdui-color-secondary-container));--mdui-comp-ripple-state-layer-color:var(
      --mdui-color-on-secondary-container
    )}:host([variant=outlined][selected]:not([selected=false i])){border:none;color:rgb(var(--mdui-color-inverse-on-surface));background-color:rgb(var(--mdui-color-inverse-surface));--mdui-comp-ripple-state-layer-color:var(--mdui-color-inverse-on-surface)}:host([variant=filled][disabled]:not([disabled=false i])),:host([variant=outlined][disabled]:not([disabled=false i])),:host([variant=tonal][disabled]:not([disabled=false i])){background-color:rgba(var(--mdui-color-on-surface),.12);border-color:rgba(var(--mdui-color-on-surface),.12)}:host([disabled]:not([disabled=false i])),:host([loading]:not([loading=false i])){cursor:default;pointer-events:none}:host([disabled]:not([disabled=false i])){color:rgba(var(--mdui-color-on-surface),.38)!important}:host([loading]:not([loading=false i])) .button,:host([loading]:not([loading=false i])) mdui-ripple{opacity:0}.button{float:left;width:100%}.icon,.selected-icon mdui-icon,::slotted(*){font-size:inherit}mdui-circular-progress{display:flex;position:absolute;top:calc(50% - 1.5rem / 2);left:calc(50% - 1.5rem / 2);width:1.5rem;height:1.5rem}:host([variant=filled]:not([disabled])) mdui-circular-progress,:host([variant=filled][disabled=false i]) mdui-circular-progress{stroke:rgb(var(--mdui-color-on-primary))}:host([disabled]:not([disabled=false i])) mdui-circular-progress{stroke:rgba(var(--mdui-color-on-surface),38%)}`;


/**
 * @summary 图标按钮组件
 *
 * ```html
 * <mdui-button-icon icon="search"></mdui-button-icon>
 * ```
 *
 * @event focus - 获得焦点时触发
 * @event blur - 失去焦点时触发
 * @event change - 选中状态变更时触发
 * @event invalid - 表单字段验证未通过时触发
 *
 * @slot - 图标组件
 * @slot selected-icon 选中状态显示的图标元素
 *
 * @csspart button - 内部的 `<button>` 或 `<a>` 元素
 * @csspart icon - 未选中状态的图标
 * @csspart selected-icon 选中状态的图标
 * @csspart loading - 加载中状态的 `<mdui-circular-progress>` 元素
 *
 * @cssprop --shape-corner - 组件的圆角大小。可以指定一个具体的像素值；但更推荐引用[设计令牌](/docs/2/styles/design-tokens#shape-corner)
 */ let $c27d5c28049f0305$export$e1c22a2ee2645e36 = class ButtonIcon extends (0, $d2ad4ee595242e3a$export$b0bb876e969289cd) {
    constructor(){
        super(...arguments);
        /**
         * 图标按钮的形状。可选值包括：
         *
         * * `standard`：适用于最低优先级的操作
         * * `filled`：视觉效果强烈，适用于高优先级的操作
         * * `tonal`：视觉效果介于 `filled` 和 `outlined` 之间，适用于中高优先级的操作
         * * `outlined`：适用于中等优先级的操作
         */ this.variant = 'standard';
        /**
         * 是否可选中
         */ this.selectable = false;
        /**
         * 是否已被选中
         */ this.selected = false;
        this.rippleRef = (0, $f322d22fead4969a$export$7d1e3a5e95ceca43)();
        this.hasSlotController = new (0, $86ec33836cc10aec$export$34f6a5ffaa663541)(this, '[default]', 'selected-icon');
    }
    get rippleElement() {
        return this.rippleRef.value;
    }
    onSelectedChange() {
        this.emit('change');
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.addEventListener('click', ()=>{
            if (!this.selectable || this.disabled) return;
            this.selected = !this.selected;
        });
    }
    render() {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-ripple ${(0, $f322d22fead4969a$export$eff4d24c3ff7876e)(this.rippleRef)} .noRipple="${this.noRipple}"></mdui-ripple>${this.isButton() ? this.renderButton({
            className: 'button',
            part: 'button',
            content: this.renderIcon()
        }) : this.disabled || this.loading ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<span part="button" class="button _a">${this.renderIcon()}</span>` : this.renderAnchor({
            className: 'button',
            part: 'button',
            content: this.renderIcon()
        })} ${this.renderLoading()}`;
    }
    renderIcon() {
        const icon = ()=>this.hasSlotController.test('[default]') ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot></slot>` : this.icon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon part="icon" class="icon" name="${this.icon}"></mdui-icon>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53);
        const selectedIcon = ()=>this.hasSlotController.test('selected-icon') || this.selectedIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="selected-icon" part="selected-icon" class="selected-icon"><mdui-icon name="${this.selectedIcon}"></mdui-icon></slot>` : icon();
        return this.selected ? selectedIcon() : icon();
    }
};
$c27d5c28049f0305$export$e1c22a2ee2645e36.styles = [
    (0, $d2ad4ee595242e3a$export$b0bb876e969289cd).styles,
    (0, $a0812466456bb63e$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "variant", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "icon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'selected-icon'
    })
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "selectedIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "selectable", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "selected", void 0);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('selected', true)
], $c27d5c28049f0305$export$e1c22a2ee2645e36.prototype, "onSelectedChange", null);
$c27d5c28049f0305$export$e1c22a2ee2645e36 = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-button-icon')
], $c27d5c28049f0305$export$e1c22a2ee2645e36);






const $18c7421cab84640e$export$1d567c320f4763bc = (0, $0268acc93e67b930$export$dbf350e5966cf602)`:host{display:inline-block;width:100%}:host([disabled]:not([disabled=false i])){pointer-events:none}:host([type=hidden]){display:none}.container{position:relative;display:flex;align-items:center;height:100%;padding:.125rem .125rem .125rem 1rem;transition:box-shadow var(--mdui-motion-duration-short4) var(--mdui-motion-easing-standard)}.container.has-icon{padding-left:.75rem}.container.has-action,.container.has-right-icon,.container.has-suffix{padding-right:.75rem}:host([variant=filled]) .container{box-shadow:inset 0 -.0625rem 0 0 rgb(var(--mdui-color-on-surface-variant));background-color:rgb(var(--mdui-color-surface-container-highest));border-radius:var(--mdui-shape-corner-extra-small) var(--mdui-shape-corner-extra-small) 0 0}:host([variant=filled]) .container.invalid,:host([variant=filled]) .container.invalid-style{box-shadow:inset 0 -.0625rem 0 0 rgb(var(--mdui-color-error))}:host([variant=filled]:hover) .container{box-shadow:inset 0 -.0625rem 0 0 rgb(var(--mdui-color-on-surface))}:host([variant=filled]:hover) .container.invalid,:host([variant=filled]:hover) .container.invalid-style{box-shadow:inset 0 -.0625rem 0 0 rgb(var(--mdui-color-on-error-container))}:host([variant=filled][focused-style]) .container,:host([variant=filled][focused]) .container{box-shadow:inset 0 -.125rem 0 0 rgb(var(--mdui-color-primary))}:host([variant=filled][focused-style]) .container.invalid,:host([variant=filled][focused-style]) .container.invalid-style,:host([variant=filled][focused]) .container.invalid,:host([variant=filled][focused]) .container.invalid-style{box-shadow:inset 0 -.125rem 0 0 rgb(var(--mdui-color-error))}:host([variant=filled][disabled]:not([disabled=false i])) .container{box-shadow:inset 0 -.0625rem 0 0 rgba(var(--mdui-color-on-surface),38%);background-color:rgba(var(--mdui-color-on-surface),4%)}:host([variant=outlined]) .container{box-shadow:inset 0 0 0 .0625rem rgb(var(--mdui-color-outline));border-radius:var(--mdui-shape-corner-extra-small)}:host([variant=outlined]) .container.invalid,:host([variant=outlined]) .container.invalid-style{box-shadow:inset 0 0 0 .0625rem rgb(var(--mdui-color-error))}:host([variant=outlined]:hover) .container{box-shadow:inset 0 0 0 .0625rem rgb(var(--mdui-color-on-surface))}:host([variant=outlined]:hover) .container.invalid,:host([variant=outlined]:hover) .container.invalid-style{box-shadow:inset 0 0 0 .0625rem rgb(var(--mdui-color-on-error-container))}:host([variant=outlined][focused-style]) .container,:host([variant=outlined][focused]) .container{box-shadow:inset 0 0 0 .125rem rgb(var(--mdui-color-primary))}:host([variant=outlined][focused-style]) .container.invalid,:host([variant=outlined][focused-style]) .container.invalid-style,:host([variant=outlined][focused]) .container.invalid,:host([variant=outlined][focused]) .container.invalid-style{box-shadow:inset 0 0 0 .125rem rgb(var(--mdui-color-error))}:host([variant=outlined][disabled]:not([disabled=false i])) .container{box-shadow:inset 0 0 0 .125rem rgba(var(--mdui-color-on-surface),12%)}.action,.icon,.prefix,.right-icon,.suffix{display:flex;-webkit-user-select:none;user-select:none;color:rgb(var(--mdui-color-on-surface-variant))}:host([disabled]:not([disabled=false i])) .action,:host([disabled]:not([disabled=false i])) .icon,:host([disabled]:not([disabled=false i])) .prefix,:host([disabled]:not([disabled=false i])) .right-icon,:host([disabled]:not([disabled=false i])) .suffix{color:rgba(var(--mdui-color-on-surface),38%)}.invalid .right-icon,.invalid-style .right-icon{color:rgb(var(--mdui-color-error))}:host(:hover) .invalid .right-icon,:host(:hover) .invalid-style .right-icon{color:rgb(var(--mdui-color-on-error-container))}:host([focused-style]) .invalid .right-icon,:host([focused-style]) .invalid-style .right-icon,:host([focused]) .invalid .right-icon,:host([focused]) .invalid-style .right-icon{color:rgb(var(--mdui-color-error))}.action,.icon,.right-icon{font-size:1.5rem}.action mdui-button-icon,.icon mdui-button-icon,.right-icon mdui-button-icon,::slotted(mdui-button-icon[slot]){margin-left:-.5rem;margin-right:-.5rem}.action .i,.icon .i,.right-icon .i,::slotted([slot$=icon]){font-size:inherit}.has-icon .icon{margin-right:1rem}.has-prefix .prefix{padding-right:.125rem}.has-action .action{margin-left:.75rem}.has-suffix .suffix{padding-right:.25rem;padding-left:.125rem}.has-right-icon .right-icon{margin-left:.75rem}.prefix,.suffix{display:none;font-size:var(--mdui-typescale-body-large-size);font-weight:var(--mdui-typescale-body-large-weight);letter-spacing:var(--mdui-typescale-body-large-tracking);line-height:var(--mdui-typescale-body-large-line-height)}:host([variant=filled][label]) .prefix,:host([variant=filled][label]) .suffix{padding-top:1rem}.has-value .prefix,.has-value .suffix,:host([focused-style]) .prefix,:host([focused-style]) .suffix,:host([focused]) .prefix,:host([focused]) .suffix{display:flex}.input-container{display:flex;width:100%;height:100%}.label{position:absolute;pointer-events:none;max-width:calc(100% - 1rem);display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:1;transition:all var(--mdui-motion-duration-short4) var(--mdui-motion-easing-standard);top:1rem;color:rgb(var(--mdui-color-on-surface-variant));font-size:var(--mdui-typescale-body-large-size);font-weight:var(--mdui-typescale-body-large-weight);letter-spacing:var(--mdui-typescale-body-large-tracking);line-height:var(--mdui-typescale-body-large-line-height)}.invalid .label,.invalid-style .label{color:rgb(var(--mdui-color-error))}:host([variant=outlined]) .label{padding:0 .25rem;margin:0 -.25rem}:host([variant=outlined]:hover) .label{color:rgb(var(--mdui-color-on-surface))}:host([variant=filled]:hover) .invalid .label,:host([variant=filled]:hover) .invalid-style .label,:host([variant=outlined]:hover) .invalid .label,:host([variant=outlined]:hover) .invalid-style .label{color:rgb(var(--mdui-color-on-error-container))}:host([variant=filled][focused-style]) .label,:host([variant=filled][focused]) .label,:host([variant=outlined][focused-style]) .label,:host([variant=outlined][focused]) .label{color:rgb(var(--mdui-color-primary))}:host([variant=filled]) .has-value .label,:host([variant=filled][focused-style]) .label,:host([variant=filled][focused]) .label,:host([variant=filled][type=date]) .label,:host([variant=filled][type=datetime-local]) .label,:host([variant=filled][type=month]) .label,:host([variant=filled][type=time]) .label,:host([variant=filled][type=week]) .label{font-size:var(--mdui-typescale-body-small-size);font-weight:var(--mdui-typescale-body-small-weight);letter-spacing:var(--mdui-typescale-body-small-tracking);line-height:var(--mdui-typescale-body-small-line-height);top:.25rem}:host([variant=outlined]) .has-value .label,:host([variant=outlined][focused-style]) .label,:host([variant=outlined][focused]) .label,:host([variant=outlined][type=date]) .label,:host([variant=outlined][type=datetime-local]) .label,:host([variant=outlined][type=month]) .label,:host([variant=outlined][type=time]) .label,:host([variant=outlined][type=week]) .label{font-size:var(--mdui-typescale-body-small-size);font-weight:var(--mdui-typescale-body-small-weight);letter-spacing:var(--mdui-typescale-body-small-tracking);line-height:var(--mdui-typescale-body-small-line-height);top:-.5rem;left:.75rem;background-color:rgb(var(--mdui-color-background))}:host([variant=filled][focused-style]) .invalid .label,:host([variant=filled][focused-style]) .invalid-style .label,:host([variant=filled][focused]) .invalid .label,:host([variant=filled][focused]) .invalid-style .label,:host([variant=outlined][focused-style]) .invalid .label,:host([variant=outlined][focused-style]) .invalid-style .label,:host([variant=outlined][focused]) .invalid .label,:host([variant=outlined][focused]) .invalid-style .label{color:rgb(var(--mdui-color-error))}:host([variant=filled][disabled]:not([disabled=false i])) .label,:host([variant=outlined][disabled]:not([disabled=false i])) .label{color:rgba(var(--mdui-color-on-surface),38%)}.input{display:block;width:100%;border:none;outline:0;background:0 0;appearance:none;resize:none;cursor:inherit;font-family:inherit;padding:.875rem .875rem .875rem 0;font-size:var(--mdui-typescale-body-large-size);font-weight:var(--mdui-typescale-body-large-weight);letter-spacing:var(--mdui-typescale-body-large-tracking);line-height:var(--mdui-typescale-body-large-line-height);color:rgb(var(--mdui-color-on-surface));caret-color:rgb(var(--mdui-color-primary))}.has-action .input,.has-right-icon .input{padding-right:.25rem}.has-suffix .input{padding-right:0}.input.hide-input{opacity:0;height:0;min-height:0;width:0;padding:0!important;overflow:hidden}.input::placeholder{color:rgb(var(--mdui-color-on-surface-variant))}.invalid .input,.invalid-style .input{caret-color:rgb(var(--mdui-color-error))}:host([disabled]:not([disabled=false i])) .input{color:rgba(var(--mdui-color-on-surface),38%)}:host([end-aligned]:not([end-aligned=false i])) .input{text-align:right}textarea.input{padding-top:0;margin-top:.875rem}:host([variant=filled]) .label+.input{padding-top:1.375rem;padding-bottom:.375rem}:host([variant=filled]) .label+textarea.input{padding-top:0;margin-top:1.375rem}.supporting{display:flex;justify-content:space-between;padding:.25rem 1rem;color:rgb(var(--mdui-color-on-surface-variant))}.supporting.invalid,.supporting.invalid-style{color:rgb(var(--mdui-color-error))}.helper{display:block;opacity:1;transition:opacity var(--mdui-motion-duration-short4) var(--mdui-motion-easing-linear);font-size:var(--mdui-typescale-body-small-size);font-weight:var(--mdui-typescale-body-small-weight);letter-spacing:var(--mdui-typescale-body-small-tracking);line-height:var(--mdui-typescale-body-small-line-height)}:host([disabled]:not([disabled=false i])) .helper{color:rgba(var(--mdui-color-on-surface),38%)}:host([helper-on-focus]:not([helper-on-focus=false i])) .helper{opacity:0}:host([helper-on-focus][focused-style]:not([helper-on-focus=false i])) .helper,:host([helper-on-focus][focused]:not([helper-on-focus=false i])) .helper{opacity:1}.error{font-size:var(--mdui-typescale-body-small-size);font-weight:var(--mdui-typescale-body-small-weight);letter-spacing:var(--mdui-typescale-body-small-tracking);line-height:var(--mdui-typescale-body-small-line-height)}.counter{flex-wrap:nowrap;padding-left:1rem;font-size:var(--mdui-typescale-body-small-size);font-weight:var(--mdui-typescale-body-small-weight);letter-spacing:var(--mdui-typescale-body-small-tracking);line-height:var(--mdui-typescale-body-small-line-height)}::-ms-reveal{display:none}.input[type=number]::-webkit-inner-spin-button,.input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;display:none}.input[type=number]{-moz-appearance:textfield}.input[type=search]::-webkit-search-cancel-button{-webkit-appearance:none}`;


/**
 * @summary 文本框组件
 *
 * ```html
 * <mdui-text-field label="Text Field"></mdui-text-field>
 * ```
 *
 * @event focus - 获得焦点时触发
 * @event blur - 失去焦点时触发
 * @event change - 在文本框的值变更，且失去焦点时触发
 * @event input - 在文本框的值变更时触发
 * @event invalid - 表单字段验证不通过时触发
 * @event clear - 在点击由 `clearable` 属性生成的清空按钮时触发。可以通过调用 `event.preventDefault()` 阻止清空文本框
 *
 * @slot icon - 左侧图标
 * @slot end-icon - 右侧图标
 * @slot error-icon - 验证失败状态的右侧图标
 * @slot prefix - 左侧文本
 * @slot suffix - 右侧文本
 * @slot clear-button - 清空按钮
 * @slot clear-icon - 清空按钮中的图标
 * @slot toggle-password-button - 密码显示状态切换按钮
 * @slot show-password-icon - 显示密码状态下，密码显示状态切换按钮中的图标
 * @slot hide-password-icon - 隐藏密码状态下，密码显示状态切换按钮中的图标
 * @slot helper - 底部的帮助文本
 *
 * @csspart container - 文本框容器
 * @csspart icon - 左侧图标
 * @csspart end-icon - 右侧图标
 * @csspart error-icon - 验证失败状态的右侧图标
 * @csspart prefix - 左侧文本
 * @csspart suffix - 右侧文本
 * @csspart label - 上方的标签文本
 * @csspart input - 内部的 `<input>` 或 `<textarea>` 元素
 * @csspart clear-button - 清空按钮
 * @csspart clear-icon - 清空按钮中的图标
 * @csspart toggle-password-button - 密码显示状态切换按钮
 * @csspart show-password-icon - 显示密码状态下，密码显示状态切换按钮中的图标
 * @csspart hide-password-icon - 隐藏密码状态下，密码显示状态切换按钮中的图标
 * @csspart supporting - 底部辅助信息容器，包括 helper、error、counter
 * @csspart helper - 底部的帮助文本
 * @csspart error - 底部的错误描述文本
 * @csspart counter - 底部右侧的字数统计
 */ let $7f500ac2a36a388b$export$2c73285ae9390cec = class TextField extends (0, $3bb9ba68ccebecb9$export$7b86c168e7d309f7)((0, $53a1aafae9c6752a$export$9bb0a9faa319390c)) {
    constructor(){
        super(...arguments);
        /**
         * 文本框的形状。默认为 `filled`。可选值包括：
         *
         * * `filled`：带背景色的文本框，视觉效果较强
         * * `outlined`：带边框的文本框，视觉效果较弱
         */ this.variant = 'filled';
        /**
         * 文本框输入类型。默认为 `text`。可选值包括：
         *
         * * `text`：默认值。文本字段
         * * `number`：只能输入数字。拥有动态键盘的设备上会显示数字键盘
         * * `password`：用于输入密码，其值会被遮盖
         * * `url`：用于输入 URL，会验证 URL 格式。在支持动态键盘的设备上有相应的键盘
         * * `email`：用于输入邮箱地址，会验证邮箱格式。在支持动态键盘的设备上有相应的键盘
         * * `search`：用于搜索框。拥有动态键盘的设备上的回车图标会变成搜索图标
         * * `tel`：用于输入电话号码。拥有动态键盘的设备上会显示电话数字键盘
         * * `hidden`：隐藏该控件，但其值仍会提交到服务器
         * * `date`：输入日期的控件（年、月、日，不包括时间）。在支持的浏览器激活时打开日期选择器或年月日的数字滚轮
         * * `datetime-local`：输入日期和时间的控件，不包括时区。在支持的浏览器激活时打开日期选择器或年月日的数字滚轮
         * * `month`：输入年和月的控件，没有时区
         * * `time`：用于输入时间的控件，不包括时区
         * * `week`：用于输入以年和周数组成的日期，不带时区
         */ this.type = 'text';
        /**
         * 文本框名称，将与表单数据一起提交
         */ this.name = '';
        /**
         * 文本框的值，将与表单数据一起提交
         */ this.value = '';
        /**
         * 默认值。在重置表单时，将重置为该默认值。该属性只能通过 JavaScript 属性设置
         */ this.defaultValue = '';
        /**
         * 是否仅在获得焦点时，显示底部的帮助文本
         */ this.helperOnFocus = false;
        /**
         * 是否可清空文本框内容
         */ this.clearable = false;
        /**
         * 是否将文本右对齐
         */ this.endAligned = false;
        /**
         * 是否为只读模式
         */ this.readonly = false;
        /**
         * 是否禁用输入框
         */ this.disabled = false;
        /**
         * 提交表单时，是否必须填写该字段
         */ this.required = false;
        /**
         * 是否根据输入内容自动调整文本框高度
         */ this.autosize = false;
        /**
         * 是否显示字数统计，只在 `maxlength` 被指定时有效
         */ this.counter = false;
        /**
         * `type` 为 `password` 时，设置此属性会添加一个切换按钮，用于在明文和密文之间切换
         */ this.togglePassword = false;
        /**
         * 是否启用拼写检查
         */ this.spellcheck = false;
        /**
         * 是否验证未通过
         *
         * 该验证为浏览器原生验证 API，基于 `type`、`required`、`minlength`、`maxlength` 及 `pattern` 等属性的验证结果
         */ this.invalid = false;
        /**
         * 该属性设置为 true 时，则在样式上为 text-field 赋予 invalid 的状态。实际是否验证通过仍需根据 invalid 属性判断
         * 该属性仅供 mdui 内部使用，当前 select 组件使用了该属性
         */ this.invalidStyle = false;
        /**
         * 该属性设置为 true 时，则在样式上为 text-field 赋予聚焦状态。实际是否聚焦仍然由 focusableMixin 控制
         * 该属性仅供 mdui 内部使用，当前 select 组件使用了该属性
         */ this.focusedStyle = false;
        this.isPasswordVisible = false;
        this.hasValue = false;
        /**
         * 通过该属性传入了错误文案时，会优先显示该文案。需要配合 invalid=true 或 invalidStyle=true 使用
         * 当前仅供 select 组件使用
         */ this.error = '';
        this.inputRef = (0, $f322d22fead4969a$export$7d1e3a5e95ceca43)();
        this.formController = new (0, $d56b143b5bf6ad89$export$2ecd466f59952f38)(this);
        this.hasSlotController = new (0, $86ec33836cc10aec$export$34f6a5ffaa663541)(this, 'icon', 'end-icon', 'helper', 'input');
        /**
         * 该属性设为 true 时，即使设置了 readonly，仍可以显示 clearable
         * 当前仅供 select 组件使用
         */ this.readonlyButClearable = false;
    }
    /**
     * 表单验证状态对象，具体参见 [`ValidityState`](https://developer.mozilla.org/zh-CN/docs/Web/API/ValidityState)
     */ get validity() {
        return this.inputRef.value.validity;
    }
    /**
     * 如果表单验证未通过，此属性将包含提示信息。如果验证通过，此属性将为空字符串
     */ get validationMessage() {
        return this.inputRef.value.validationMessage;
    }
    /**
     * 获取当前值，并转换为 `number` 类型；或设置一个 `number` 类型的值。
     * 如果值无法被转换为 `number` 类型，则会返回 `NaN`。
     */ get valueAsNumber() {
        return this.inputRef.value?.valueAsNumber ?? parseFloat(this.value);
    }
    set valueAsNumber(newValue) {
        const input = document.createElement('input');
        input.type = 'number';
        input.valueAsNumber = newValue;
        this.value = input.value;
    }
    get focusElement() {
        return this.inputRef.value;
    }
    get focusDisabled() {
        return this.disabled;
    }
    /**
     * 是否显示聚焦状态样式
     */ get isFocusedStyle() {
        // @ts-ignore
        return this.focused || this.focusedStyle;
    }
    /**
     * 是否渲染为 textarea。为 false 时渲染为 input
     */ get isTextarea() {
        return this.rows && this.rows > 1 || this.autosize;
    }
    onDisabledChange() {
        // 禁用状态始终为验证通过，所以 disabled 变更时需要重新校验
        this.inputRef.value.disabled = this.disabled;
        this.invalid = !this.inputRef.value.checkValidity();
    }
    async onValueChange() {
        this.hasValue = ![
            '',
            null
        ].includes(this.value);
        if (this.hasUpdated) {
            await this.updateComplete;
            this.setTextareaHeight();
            // reset 引起的值变更，不执行验证；直接修改值引起的变更，需要进行验证
            const form = this.formController.getForm();
            if (form && (0, $d56b143b5bf6ad89$export$64b1c594674e8d1d).get(form)?.has(this)) {
                this.invalid = false;
                (0, $d56b143b5bf6ad89$export$64b1c594674e8d1d).get(form).delete(this);
            } else this.invalid = !this.inputRef.value.checkValidity();
        }
    }
    onRowsChange() {
        this.setTextareaHeight();
    }
    async onMaxRowsChange() {
        if (!this.autosize) return;
        if (!this.hasUpdated) await this.updateComplete;
        // 设置最大高度，为 line-height * maxRows + padding-top + padding-bottom
        const $input = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.inputRef.value);
        $input.css('max-height', parseFloat($input.css('line-height')) * (this.maxRows ?? 1) + parseFloat($input.css('padding-top')) + parseFloat($input.css('padding-bottom')));
    }
    async onMinRowsChange() {
        if (!this.autosize) return;
        if (!this.hasUpdated) await this.updateComplete;
        // 设置最小高度，为 line-height * minRows + padding-top + padding-bottom
        const $input = (0, $b95421a1db56b097$export$3d8c2f653ac9d0b9)(this.inputRef.value);
        $input.css('min-height', parseFloat($input.css('line-height')) * (this.minRows ?? 1) + parseFloat($input.css('padding-top')) + parseFloat($input.css('padding-bottom')));
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete.then(()=>{
            this.setTextareaHeight();
            this.observeResize = (0, $6deeb9ef1c73e593$export$3e59a5e1472e94f1)(this.inputRef.value, ()=>this.setTextareaHeight());
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observeResize?.unobserve();
        (0, $e9597e517ca085a3$export$2120695e25bf904e)(this);
    }
    /**
     * 选中文本框中的文本
     */ select() {
        this.inputRef.value.select();
    }
    /**
     * 选中文本框中特定范围的内容
     *
     * @param start 被选中的第一个字符的位置索引，从 `0` 开始。如果这个值比元素的 `value` 长度还大，则会被看作 `value` 最后一个位置的索引
     * @param end 被选中的最后一个字符的*下一个*位置索引。如果这个值比元素的 `value` 长度还大，则会被看作 `value` 最后一个位置的索引
     * @param direction 一个表示选择方向的字符串，可能的值有：`forward`、`backward`、`none`
     */ setSelectionRange(start, end, direction = 'none') {
        this.inputRef.value.setSelectionRange(start, end, direction);
    }
    /**
     * 将文本框中特定范围的文本替换为新的文本
     * @param replacement 要插入的字符串
     * @param start 要替换的字符的起止位置的索引。默认为当前用户选中的字符的起始位置的索引
     * @param end 要替换的字符的结束位置的索引。默认为当前用户选中的字符的结束位置的索引
     * @param selectMode 文本被替换后，选取的状态。可选值为：
     * * `select`：选择新插入的文本
     * * `start`：将光标移动到新插入的文本的起始位置
     * * `end`：将光标移动到新插入的文本的结束位置
     * * `preserve`：默认值。尝试保留选取
     */ setRangeText(replacement, start, end, selectMode = 'preserve') {
        this.inputRef.value.setRangeText(replacement, start, end, selectMode);
        if (this.value !== this.inputRef.value.value) {
            this.value = this.inputRef.value.value;
            this.setTextareaHeight();
            this.emit('input');
            this.emit('change');
        }
    }
    /**
     * 检查表单字段是否通过验证。如果未通过，返回 `false` 并触发 `invalid` 事件；如果通过，返回 `true`
     */ checkValidity() {
        const valid = this.inputRef.value.checkValidity();
        if (!valid) this.emit('invalid', {
            bubbles: false,
            cancelable: true,
            composed: false
        });
        return valid;
    }
    /**
     * 检查表单字段是否通过验证。如果未通过，返回 `false` 并触发 `invalid` 事件；如果通过，返回 `true`。
     *
     * 如果验证未通过，还会在组件上显示验证失败的提示。
     */ reportValidity() {
        this.invalid = !this.inputRef.value.reportValidity();
        if (this.invalid) {
            this.emit('invalid', {
                bubbles: false,
                cancelable: true,
                composed: false
            });
            this.focus();
        }
        return !this.invalid;
    }
    /**
     * 设置自定义的错误提示文本。只要这个文本不为空，就表示字段未通过验证
     *
     * @param message 自定义的错误提示文本
     */ setCustomValidity(message) {
        this.setCustomValidityInternal(message);
        // 外部调用 setCustomValidity 时，不再使用内置的验证规则，所以需要移除监听语言变更事件
        (0, $e9597e517ca085a3$export$2120695e25bf904e)(this);
    }
    render() {
        const hasIcon = !!this.icon || this.hasSlotController.test('icon');
        const hasEndIcon = !!this.endIcon || this.hasSlotController.test('end-icon');
        const hasErrorIcon = this.invalid || this.invalidStyle;
        const hasTogglePasswordButton = this.type === 'password' && this.togglePassword && !this.disabled;
        const hasClearButton = this.clearable && !this.disabled && (!this.readonly || this.readonlyButClearable) && (typeof this.value === 'number' || this.value.length > 0);
        const hasPrefix = !!this.prefix || this.hasSlotController.test('prefix');
        const hasSuffix = !!this.suffix || this.hasSlotController.test('suffix');
        const hasHelper = !!this.helper || this.hasSlotController.test('helper');
        const hasError = hasErrorIcon && !!(this.error || this.inputRef.value.validationMessage);
        const hasCounter = this.counter && !!this.maxlength;
        // 存在 input slot 时，隐藏组件内部的 .input 元素，使用 slot 代替
        const hasInputSlot = this.hasSlotController.test('input');
        const invalidClassNameObj = {
            invalid: this.invalid,
            'invalid-style': this.invalidStyle
        };
        const className = (0, $c9d15c868ac73f05$export$56cc687933817664)({
            container: true,
            'has-value': this.hasValue,
            'has-icon': hasIcon,
            'has-right-icon': hasEndIcon || hasErrorIcon,
            'has-action': hasClearButton || hasTogglePasswordButton,
            'has-prefix': hasPrefix,
            'has-suffix': hasSuffix,
            'is-firefox': navigator.userAgent.includes('Firefox'),
            ...invalidClassNameObj
        });
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div part="container" class="${className}">${this.renderPrefix()}<div class="input-container">${this.renderLabel()} ${this.isTextarea ? this.renderTextArea(hasInputSlot) : this.renderInput(hasInputSlot)} ${(0, $1c93789365dd7e63$export$a55877ca9db47377)(hasInputSlot, ()=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="input" class="input"></slot>`)}</div>${this.renderSuffix()}${this.renderClearButton(hasClearButton)} ${this.renderTogglePasswordButton(hasTogglePasswordButton)} ${this.renderRightIcon(hasErrorIcon)}</div>${(0, $1c93789365dd7e63$export$a55877ca9db47377)(hasError || hasHelper || hasCounter, ()=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div part="supporting" class="${(0, $c9d15c868ac73f05$export$56cc687933817664)({
                supporting: true,
                ...invalidClassNameObj
            })}">${this.renderHelper(hasError, hasHelper)} ${this.renderCounter(hasCounter)}</div>`)}`;
    }
    setCustomValidityInternal(message) {
        this.inputRef.value.setCustomValidity(message);
        this.invalid = !this.inputRef.value.checkValidity();
        this.requestUpdate();
    }
    onChange() {
        this.value = this.inputRef.value.value;
        if (this.isTextarea) this.setTextareaHeight();
        this.emit('change');
    }
    onClear(event) {
        this.value = '';
        this.emit('clear');
        this.emit('input');
        this.emit('change');
        this.focus();
        event.stopPropagation();
    }
    onInput(event) {
        event.stopPropagation();
        this.value = this.inputRef.value.value;
        if (this.isTextarea) this.setTextareaHeight();
        this.emit('input');
    }
    onInvalid(event) {
        event.preventDefault();
    }
    onKeyDown(event) {
        const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        // 聚焦状态按下回车时，提交表单。可以在 keydown 事件中使用 event.preventDefault() 来取消提交表单
        if (event.key === 'Enter' && !hasModifier) setTimeout(()=>{
            if (!event.defaultPrevented) this.formController.submit();
        });
    }
    /**
     * textarea 不支持 pattern 属性，所以在 keyup 时执行验证
     */ onTextAreaKeyUp() {
        if (this.pattern) {
            const patternRegex = new RegExp(this.pattern);
            const hasError = this.value && !this.value.match(patternRegex);
            if (hasError) {
                this.setCustomValidityInternal(this.getPatternErrorMsg());
                (0, $e9597e517ca085a3$export$995a2c2a1ff886c)(this, ()=>{
                    this.setCustomValidityInternal(this.getPatternErrorMsg());
                });
            } else {
                this.setCustomValidityInternal('');
                (0, $e9597e517ca085a3$export$2120695e25bf904e)(this);
            }
        }
    }
    onTogglePassword() {
        this.isPasswordVisible = !this.isPasswordVisible;
    }
    getPatternErrorMsg() {
        return (0, $ad0c7de0be8b3f01$export$d8bbfaecd0f57bdf)('Please match the requested format.', {
            id: 'components.textField.patternError'
        });
    }
    setTextareaHeight() {
        if (this.autosize) {
            this.inputRef.value.style.height = 'auto';
            this.inputRef.value.style.height = `${this.inputRef.value.scrollHeight}px`;
        } else this.inputRef.value.style.height = undefined;
    }
    renderLabel() {
        return this.label ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<label part="label" class="label">${this.label}</label>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53);
    }
    renderPrefix() {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="icon" part="icon" class="icon">${this.icon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.icon}" class="i"></mdui-icon>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53)}</slot><slot name="prefix" part="prefix" class="prefix">${this.prefix}</slot>`;
    }
    renderSuffix() {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="suffix" part="suffix" class="suffix">${this.suffix}</slot>`;
    }
    renderRightIcon(hasErrorIcon) {
        return hasErrorIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="error-icon" part="error-icon" class="right-icon">${this.errorIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.errorIcon}" class="i"></mdui-icon>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon-error class="i"></mdui-icon-error>`}</slot>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="end-icon" part="end-icon" class="end-icon right-icon">${this.endIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.endIcon}" class="i"></mdui-icon>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53)}</slot>`;
    }
    renderClearButton(hasClearButton) {
        return (0, $1c93789365dd7e63$export$a55877ca9db47377)(hasClearButton, ()=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="clear-button" part="clear-button" class="action" @click="${this.onClear}"><mdui-button-icon tabindex="-1"><slot name="clear-icon" part="clear-icon">${this.clearIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.clearIcon}" class="i"></mdui-icon>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon-cancel--outlined class="i"></mdui-icon-cancel--outlined>`}</slot></mdui-button-icon></slot>`);
    }
    renderTogglePasswordButton(hasTogglePasswordButton) {
        return (0, $1c93789365dd7e63$export$a55877ca9db47377)(hasTogglePasswordButton, ()=>(0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="toggle-password-button" part="toggle-password-button" class="action" @click="${this.onTogglePassword}"><mdui-button-icon tabindex="-1">${this.isPasswordVisible ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="show-password-icon" part="show-password-icon">${this.showPasswordIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.showPasswordIcon}" class="i"></mdui-icon>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon-visibility-off class="i"></mdui-icon-visibility-off>`}</slot>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="hide-password-icon" part="hide-password-icon">${this.hidePasswordIcon ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon name="${this.hidePasswordIcon}" class="i"></mdui-icon>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<mdui-icon-visibility class="i"></mdui-icon-visibility>`}</slot>`}</mdui-button-icon></slot>`);
    }
    renderInput(hasInputSlot) {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<input ${(0, $f322d22fead4969a$export$eff4d24c3ff7876e)(this.inputRef)} part="input" class="input ${(0, $c9d15c868ac73f05$export$56cc687933817664)({
            'hide-input': hasInputSlot
        })}" type="${this.type === 'password' && this.isPasswordVisible ? 'text' : this.type}" name="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.name)}" .value="${(0, $e5859083c0c48887$export$28cf49ad70f82d12)(this.value)}" placeholder="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(// @ts-ignore
        !this.label || this.isFocusedStyle || this.hasValue ? this.placeholder : undefined)}" ?readonly="${this.readonly}" ?disabled="${this.disabled}" ?required="${this.required}" minlength="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.minlength)}" maxlength="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.maxlength)}" min="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.min)}" max="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.max)}" step="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.step)}" autocapitalize="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.type === 'password' ? 'off' : this.autocapitalize)}" autocomplete="${this.autocomplete}" autocorrect="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.type === 'password' ? 'off' : this.autocorrect)}" spellcheck="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.spellcheck)}" pattern="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.pattern)}" enterkeyhint="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.enterkeyhint)}" inputmode="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.inputmode)}" @change="${this.onChange}" @input="${this.onInput}" @invalid="${this.onInvalid}" @keydown="${this.onKeyDown}">`;
    }
    renderTextArea(hasInputSlot) {
        return (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<textarea ${(0, $f322d22fead4969a$export$eff4d24c3ff7876e)(this.inputRef)} part="input" class="input ${(0, $c9d15c868ac73f05$export$56cc687933817664)({
            'hide-input': hasInputSlot
        })}" name="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.name)}" .value="${(0, $e5859083c0c48887$export$28cf49ad70f82d12)(this.value)}" placeholder="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(// @ts-ignore
        !this.label || this.isFocusedStyle || this.hasValue ? this.placeholder : undefined)}" ?readonly="${this.readonly}" ?disabled="${this.disabled}" ?required="${this.required}" minlength="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.minlength)}" maxlength="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.maxlength)}" rows="${this.rows ?? 1}" autocapitalize="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.autocapitalize)}" autocorrect="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.autocorrect)}" spellcheck="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.spellcheck)}" enterkeyhint="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.enterkeyhint)}" inputmode="${(0, $dd2a3999053fa8a1$export$f68dd208b5df064d)(this.inputmode)}" @change="${this.onChange}" @input="${this.onInput}" @invalid="${this.onInvalid}" @keydown="${this.onKeyDown}" @keyup="${this.onTextAreaKeyUp}"></textarea>`;
    }
    /**
     * @param hasError 是否包含错误提示
     * @param hasHelper 是否含 helper 属性或 helper slot
     */ renderHelper(hasError, hasHelper) {
        return hasError ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div part="error" class="error">${this.error || this.inputRef.value.validationMessage}</div>` : hasHelper ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<slot name="helper" part="helper" class="helper">${this.helper}</slot>` : (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<span></span>`;
    }
    renderCounter(hasCounter) {
        return hasCounter ? (0, $1182a8bbea75578f$export$c0bb0b647f701bb5)`<div part="counter" class="counter">${this.value.length}/${this.maxlength}</div>` : (0, $ba66167bae03ac3c$export$d9a2b46c01bdcf53);
    }
};
$7f500ac2a36a388b$export$2c73285ae9390cec.styles = [
    (0, $a1095454894349c1$export$7ef977f86985f711),
    (0, $18c7421cab84640e$export$1d567c320f4763bc)
];
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "variant", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "type", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "name", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "value", void 0);
(0, $ceFTv.__decorate)([
    (0, $138a8c22291c3f8a$export$1a01ae0705bafd37)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "defaultValue", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "label", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "placeholder", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "helper", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'helper-on-focus'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "helperOnFocus", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "clearable", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'clear-icon'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "clearIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'end-aligned'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "endAligned", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "prefix", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "suffix", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "icon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'end-icon'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "endIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'error-icon'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "errorIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "form", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "readonly", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "disabled", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "required", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "rows", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "autosize", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true,
        attribute: 'min-rows'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "minRows", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true,
        attribute: 'max-rows'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "maxRows", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "minlength", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "maxlength", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "counter", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "min", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "max", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "step", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "pattern", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'toggle-password'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "togglePassword", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'show-password-icon'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "showPasswordIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true,
        attribute: 'hide-password-icon'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "hidePasswordIcon", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "autocapitalize", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "autocorrect", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "autocomplete", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "enterkeyhint", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b)
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "spellcheck", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        reflect: true
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "inputmode", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "invalid", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "invalidStyle", void 0);
(0, $ceFTv.__decorate)([
    (0, $acf573f6c2910992$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        converter: (0, $9f4de283a23bd2a5$export$2aee1c8d7bab360b),
        attribute: 'focused-style'
    })
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "focusedStyle", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "isPasswordVisible", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "hasValue", void 0);
(0, $ceFTv.__decorate)([
    (0, $81aad1feed252031$export$ca000e230c0caa3e)()
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "error", void 0);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('disabled', true)
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "onDisabledChange", null);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('value')
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "onValueChange", null);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('rows', true)
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "onRowsChange", null);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('maxRows')
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "onMaxRowsChange", null);
(0, $ceFTv.__decorate)([
    (0, $f12b6253cef59edc$export$3db5d71bdb2d5499)('minRows')
], $7f500ac2a36a388b$export$2c73285ae9390cec.prototype, "onMinRowsChange", null);
$7f500ac2a36a388b$export$2c73285ae9390cec = (0, $ceFTv.__decorate)([
    (0, $6eca265e3a72f146$export$da64fc29f17f9d0e)('mdui-text-field')
], $7f500ac2a36a388b$export$2c73285ae9390cec);





var $a2E6i = parcelRequire("a2E6i");

var $a2E6i = parcelRequire("a2E6i");

var $ar3s2 = parcelRequire("ar3s2");
var $9f9ad051847c8abe$exports = {};

$parcel$export($9f9ad051847c8abe$exports, "promisifyRequest", () => $9f9ad051847c8abe$export$b327150396135fe7);
$parcel$export($9f9ad051847c8abe$exports, "createStore", () => $9f9ad051847c8abe$export$f51a9068ac82ea43);
$parcel$export($9f9ad051847c8abe$exports, "get", () => $9f9ad051847c8abe$export$3988ae62b71be9a3);
$parcel$export($9f9ad051847c8abe$exports, "set", () => $9f9ad051847c8abe$export$adaa4cf7ef1b65be);
$parcel$export($9f9ad051847c8abe$exports, "setMany", () => $9f9ad051847c8abe$export$daa0a5170277c7a8);
$parcel$export($9f9ad051847c8abe$exports, "getMany", () => $9f9ad051847c8abe$export$5df405cccea42673);
$parcel$export($9f9ad051847c8abe$exports, "update", () => $9f9ad051847c8abe$export$722fbec263ad908a);
$parcel$export($9f9ad051847c8abe$exports, "del", () => $9f9ad051847c8abe$export$1d2f21e549771e67);
$parcel$export($9f9ad051847c8abe$exports, "delMany", () => $9f9ad051847c8abe$export$c8aa84257229cac8);
$parcel$export($9f9ad051847c8abe$exports, "clear", () => $9f9ad051847c8abe$export$42ffd38884aecdac);
$parcel$export($9f9ad051847c8abe$exports, "keys", () => $9f9ad051847c8abe$export$ed97f33186d4b816);
$parcel$export($9f9ad051847c8abe$exports, "values", () => $9f9ad051847c8abe$export$68c286be0e7e55b7);
$parcel$export($9f9ad051847c8abe$exports, "entries", () => $9f9ad051847c8abe$export$3e9f948b41964866);
function $9f9ad051847c8abe$var$_slicedToArray(arr, i) {
    return $9f9ad051847c8abe$var$_arrayWithHoles(arr) || $9f9ad051847c8abe$var$_iterableToArrayLimit(arr, i) || $9f9ad051847c8abe$var$_unsupportedIterableToArray(arr, i) || $9f9ad051847c8abe$var$_nonIterableRest();
}
function $9f9ad051847c8abe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9f9ad051847c8abe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9f9ad051847c8abe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9f9ad051847c8abe$var$_arrayLikeToArray(o, minLen);
}
function $9f9ad051847c8abe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9f9ad051847c8abe$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9f9ad051847c8abe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9f9ad051847c8abe$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $9f9ad051847c8abe$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $9f9ad051847c8abe$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $9f9ad051847c8abe$var$defaultGetStoreFunc;
function $9f9ad051847c8abe$var$defaultGetStore() {
    if (!$9f9ad051847c8abe$var$defaultGetStoreFunc) $9f9ad051847c8abe$var$defaultGetStoreFunc = $9f9ad051847c8abe$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $9f9ad051847c8abe$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $9f9ad051847c8abe$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $9f9ad051847c8abe$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($9f9ad051847c8abe$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
    });
}
function $9f9ad051847c8abe$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $9f9ad051847c8abe$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $9f9ad051847c8abe$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $9f9ad051847c8abe$export$b327150396135fe7(store.getAll());
        var items = [];
        return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $9f9ad051847c8abe$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9f9ad051847c8abe$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $9f9ad051847c8abe$export$b327150396135fe7(store.getAllKeys()),
            $9f9ad051847c8abe$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $9f9ad051847c8abe$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $9f9ad051847c8abe$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


function $ca550f0d6b72e82f$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $ca550f0d6b72e82f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ca550f0d6b72e82f$var$$082ef78710a13331$exports = {};
var $ca550f0d6b72e82f$var$$80184bab4212ab17$exports = {};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$exports = {};
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $ca550f0d6b72e82f$export$e03c1c3201ee8bb7;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $ca550f0d6b72e82f$export$6287f85d0f6a9342;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $ca550f0d6b72e82f$export$d1e7755b007c0847;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "persist", function() {
    return $ca550f0d6b72e82f$export$9a6132153fba2e0;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "restore", function() {
    return $ca550f0d6b72e82f$export$db239ef39aadc7fe;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $ca550f0d6b72e82f$export$b1fb4cac938035f7;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $ca550f0d6b72e82f$export$8001d3a0cfa5d8fd;
});
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ca550f0d6b72e82f$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === 'number' ? --value : false);
                }
            });
        };
}
function $ca550f0d6b72e82f$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') return new Notification(typeof message === 'function' ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
class $ca550f0d6b72e82f$export$d1e7755b007c0847 {
    constructor(meta){
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    save(storeKey, value) {
        return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (value != null) this.value = (0, $a2E6i.toJS)((_b = yield (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)) !== null && _b !== void 0 ? _b : value);
            const { set: set } = yield $9f9ad051847c8abe$exports, data = {
                value: this.value,
                expireAt: this.expireIn + Date.now()
            };
            return set(`${storeKey}-${this.key}`, data);
        });
    }
    load(storeKey) {
        return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const { get: get, del: del } = yield $9f9ad051847c8abe$exports;
            storeKey += `-${this.key}`;
            const { value: value, expireAt: expireAt } = (_a = yield get(storeKey)) !== null && _a !== void 0 ? _a : {};
            if (expireAt && expireAt < Date.now()) {
                delete this.value;
                return del(storeKey);
            }
            this.value = value;
            return (_c = value != null ? yield (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value) : value) !== null && _c !== void 0 ? _c : value;
        });
    }
    destroy(storeKey) {
        return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            (_a = this.disposer) === null || _a === void 0 || _a.call(this);
            const { del: del } = yield $9f9ad051847c8abe$exports;
            return del(`${storeKey}-${this.key}`);
        });
    }
}
const $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $ca550f0d6b72e82f$export$9a6132153fba2e0(_a = {}) {
    var { expireIn: expireIn = Infinity } = _a, meta = $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $ca550f0d6b72e82f$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $ca550f0d6b72e82f$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
        for (const item of list){
            const { key: key } = item, value = yield item.load(storeKey);
            if (value != null) {
                Reflect.set(classInstance, key, value);
                restoredData[key] = value;
            }
            item.disposer = (0, $a2E6i.reaction)(()=>classInstance[key], (value)=>item.save(storeKey, value));
        }
        if ((0, $ar3s2.isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $ca550f0d6b72e82f$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
        for (const node of list)yield node.destroy(storeKey);
    });
}
function $ca550f0d6b72e82f$export$8001d3a0cfa5d8fd({ storeKey: storeKey, expireIn: expireIn = Infinity } = {}) {
    return (Super, {})=>(()=>{
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            let _classSuper = Super;
            let _pageIndex_decorators;
            let _pageIndex_initializers = [];
            let _pageIndex_extraInitializers = [];
            let _pageSize_decorators;
            let _pageSize_initializers = [];
            let _pageSize_extraInitializers = [];
            let _filter_decorators;
            let _filter_initializers = [];
            let _filter_extraInitializers = [];
            let _totalCount_decorators;
            let _totalCount_initializers = [];
            let _totalCount_extraInitializers = [];
            let _pageList_decorators;
            let _pageList_initializers = [];
            let _pageList_extraInitializers = [];
            return _a = class PersistListModel extends _classSuper {
                constructor(){
                    super(...arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(this, $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_extraInitializers), $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_extraInitializers), $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_extraInitializers), $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_extraInitializers), $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_initializers, [])));
                    Object.defineProperty(this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_extraInitializers), globalThis.indexedDB && $ca550f0d6b72e82f$export$db239ef39aadc7fe(this, typeof storeKey === 'function' ? storeKey(this) : storeKey))
                    });
                }
                get pageIndex() {
                    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                }
                set pageIndex(value) {
                    $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                }
                get pageSize() {
                    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                }
                set pageSize(value) {
                    $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                }
                get filter() {
                    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                }
                set filter(value) {
                    $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                }
                get totalCount() {
                    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                }
                set totalCount(value) {
                    $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                }
                get pageList() {
                    return $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                }
                set pageList(value) {
                    $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                }
            }, _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), (()=>{
                var _b;
                const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $ca550f0d6b72e82f$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $a2E6i.observable)
                ];
                _pageSize_decorators = [
                    $ca550f0d6b72e82f$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $a2E6i.observable)
                ];
                _filter_decorators = [
                    $ca550f0d6b72e82f$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $a2E6i.observable)
                ];
                _totalCount_decorators = [
                    $ca550f0d6b72e82f$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $a2E6i.observable)
                ];
                _pageList_decorators = [
                    $ca550f0d6b72e82f$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $a2E6i.observable)
                ];
                $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageIndex" in obj,
                        get: (obj)=>obj.pageIndex,
                        set: (obj, value)=>{
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageSize" in obj,
                        get: (obj)=>obj.pageSize,
                        set: (obj, value)=>{
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"filter" in obj,
                        get: (obj)=>obj.filter,
                        set: (obj, value)=>{
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"totalCount" in obj,
                        get: (obj)=>obj.totalCount,
                        set: (obj, value)=>{
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $ca550f0d6b72e82f$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageList" in obj,
                        get: (obj)=>obj.pageList,
                        set: (obj, value)=>{
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            })(), _a;
        })();
}
$ca550f0d6b72e82f$var$$parcel$exportWildcard($ca550f0d6b72e82f$var$$082ef78710a13331$exports, $ca550f0d6b72e82f$var$$80184bab4212ab17$exports);
$ca550f0d6b72e82f$var$$parcel$exportWildcard($ca550f0d6b72e82f$var$$082ef78710a13331$exports, $ca550f0d6b72e82f$var$$400caf514fe4dd82$exports);
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$exports = {};
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $ca550f0d6b72e82f$export$d12e20a4eec10acf;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $ca550f0d6b72e82f$export$673dbc4a8d0cb20a;
});
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ca550f0d6b72e82f$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $a2E6i.observable)
        ];
        _uploading_decorators = [
            (0, $a2E6i.observable)
        ];
        _clear_decorators = [
            (0, $a2E6i.action)
        ];
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $ca550f0d6b72e82f$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $ca550f0d6b72e82f$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $a2E6i.observable)
        ];
        _clearCurrent_decorators = [
            (0, $a2E6i.action)
        ];
        _updateOne_decorators = [
            $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('uploading')
        ];
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$exports = {};
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $ca550f0d6b72e82f$export$36e5777a1ba4b7c3;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $ca550f0d6b72e82f$export$a143d493d941bafc;
});
$ca550f0d6b72e82f$var$$parcel$export($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $ca550f0d6b72e82f$export$6a4eb2e7fc9e8903;
});
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ca550f0d6b72e82f$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage;
    let _classSuper = $ca550f0d6b72e82f$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        get pageIndex() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $a2E6i.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $ar3s2.splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $ar3s2.splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAll() {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageSize = this.pageSize) {
                while(!this.noMore)yield this.getList(filter, undefined, pageSize);
                return this.allItems;
            });
        }
        countAll(keys_1) {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $ar3s2.countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers);
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _pageIndex_decorators = [
            (0, $a2E6i.observable)
        ];
        _pageSize_decorators = [
            (0, $a2E6i.observable)
        ];
        _filter_decorators = [
            (0, $a2E6i.observable)
        ];
        _totalCount_decorators = [
            (0, $a2E6i.observable)
        ];
        _pageList_decorators = [
            (0, $a2E6i.observable)
        ];
        _get_currentPage_decorators = [
            (0, $a2E6i.computed)
        ];
        _get_pageCount_decorators = [
            (0, $a2E6i.computed)
        ];
        _get_allItems_decorators = [
            (0, $a2E6i.computed)
        ];
        _get_noMore_decorators = [
            (0, $a2E6i.computed)
        ];
        _statistic_decorators = [
            (0, $a2E6i.observable)
        ];
        _clearList_decorators = [
            (0, $a2E6i.action)
        ];
        _restoreList_decorators = [
            (0, $a2E6i.action)
        ];
        _turnTo_decorators = [
            (0, $a2E6i.action)
        ];
        _getList_decorators = [
            $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('uploading')
        ];
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $ca550f0d6b72e82f$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $a2E6i.action),
                $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('downloading')
            ];
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $ca550f0d6b72e82f$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $ar3s2.splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $ca550f0d6b72e82f$export$e03c1c3201ee8bb7('downloading')
            ];
            $ca550f0d6b72e82f$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}


var $e5d2a3ae662f5d2e$export$185802fd694ee1f5;
var $e5d2a3ae662f5d2e$export$f87f6982d1fd4f81;
var $e5d2a3ae662f5d2e$export$723e4939e5a27c8;
// only svg for now.
var $e5d2a3ae662f5d2e$export$f84e8e69fd4488a5;
var $38aec60e008fa351$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$38aec60e008fa351$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $96cdee29c4ef344c$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $3c0c059760123098$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $3c0c059760123098$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $3c0c059760123098$export$ed1d66da50968976;
var $3c0c059760123098$export$6733b14783f975c2;
var $3c0c059760123098$export$ce5b1274f8597fa0;
var $3c0c059760123098$export$43dd553ecded716d;
let $3c0c059760123098$var$toSJISFunction;
const $3c0c059760123098$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$3c0c059760123098$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$3c0c059760123098$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $3c0c059760123098$var$CODEWORDS_COUNT[version];
};
$3c0c059760123098$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$3c0c059760123098$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $3c0c059760123098$var$toSJISFunction = f;
};
$3c0c059760123098$export$ce5b1274f8597fa0 = function() {
    return typeof $3c0c059760123098$var$toSJISFunction !== 'undefined';
};
$3c0c059760123098$export$43dd553ecded716d = function toSJIS(kanji) {
    return $3c0c059760123098$var$toSJISFunction(kanji);
};


var $0d86d6c290a07c1c$export$61196ced6d74a310;
var $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
var $0d86d6c290a07c1c$export$3722cfe417b6ed86;
var $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd;
var $0d86d6c290a07c1c$export$1ea939691cdc45b8;
var $0d86d6c290a07c1c$export$6788812c4e6611e6;
$0d86d6c290a07c1c$export$61196ced6d74a310 = {
    bit: 1
};
$0d86d6c290a07c1c$export$3a1a48c8f6ef640e = {
    bit: 0
};
$0d86d6c290a07c1c$export$3722cfe417b6ed86 = {
    bit: 3
};
$0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $0d86d6c290a07c1c$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $0d86d6c290a07c1c$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $0d86d6c290a07c1c$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$0d86d6c290a07c1c$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$0d86d6c290a07c1c$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0d86d6c290a07c1c$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0d86d6c290a07c1c$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $c33b7439ba8b2a6c$exports = {};
function $c33b7439ba8b2a6c$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$c33b7439ba8b2a6c$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$c33b7439ba8b2a6c$exports = $c33b7439ba8b2a6c$var$BitBuffer;


var $5158baa00c8f4fa8$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $5158baa00c8f4fa8$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $5158baa00c8f4fa8$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$5158baa00c8f4fa8$exports = $5158baa00c8f4fa8$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $ac0face0132a0e67$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $ac0face0132a0e67$export$c39457c570f2b189;

var $ac0face0132a0e67$require$getSymbolSize = $3c0c059760123098$export$8d4a06d3facd414b;
$ac0face0132a0e67$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $ac0face0132a0e67$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$ac0face0132a0e67$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $ac0face0132a0e67$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $0e214d44dead0105$export$c39457c570f2b189;

var $0e214d44dead0105$require$getSymbolSize = $3c0c059760123098$export$8d4a06d3facd414b;
const $0e214d44dead0105$var$FINDER_PATTERN_SIZE = 7;
$0e214d44dead0105$export$c39457c570f2b189 = function getPositions(version) {
    const size = $0e214d44dead0105$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $0e214d44dead0105$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $0e214d44dead0105$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $ab013ad757fb013d$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $ab013ad757fb013d$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $ab013ad757fb013d$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $ab013ad757fb013d$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $ab013ad757fb013d$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $ab013ad757fb013d$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $ab013ad757fb013d$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $ab013ad757fb013d$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $ab013ad757fb013d$export$fe9625aaceb0e563;
$ab013ad757fb013d$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $ab013ad757fb013d$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$ab013ad757fb013d$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$ab013ad757fb013d$export$6788812c4e6611e6 = function from(value) {
    return $ab013ad757fb013d$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$ab013ad757fb013d$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $ab013ad757fb013d$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$ab013ad757fb013d$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $ab013ad757fb013d$var$PenaltyScores.N2;
};
$ab013ad757fb013d$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $ab013ad757fb013d$var$PenaltyScores.N3;
};
$ab013ad757fb013d$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $ab013ad757fb013d$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $ab013ad757fb013d$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $ab013ad757fb013d$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$ab013ad757fb013d$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $ab013ad757fb013d$var$getMaskAt(pattern, row, col));
    }
};
$ab013ad757fb013d$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($ab013ad757fb013d$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $ab013ad757fb013d$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $ab013ad757fb013d$export$a5fd3a02c14d0b3e(data) + $ab013ad757fb013d$export$9a9385107a518e46(data) + $ab013ad757fb013d$export$ade754353f0dc75e(data) + $ab013ad757fb013d$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $ab013ad757fb013d$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $c525c70215eeca0c$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $c525c70215eeca0c$export$683d1b3e8a1a8438;

const $c525c70215eeca0c$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $c525c70215eeca0c$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$c525c70215eeca0c$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0d86d6c290a07c1c$export$61196ced6d74a310:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $0d86d6c290a07c1c$export$3a1a48c8f6ef640e:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $0d86d6c290a07c1c$export$3722cfe417b6ed86:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd:
            return $c525c70215eeca0c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$c525c70215eeca0c$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $0d86d6c290a07c1c$export$61196ced6d74a310:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $0d86d6c290a07c1c$export$3a1a48c8f6ef640e:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $0d86d6c290a07c1c$export$3722cfe417b6ed86:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $0d86d6c290a07c1c$export$7f8ddf7c7c20b3cd:
            return $c525c70215eeca0c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $93334cf51ca9c9c3$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $a1eabc4d156beeb3$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $a1eabc4d156beeb3$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $a1eabc4d156beeb3$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $8bbcff3e9321f949$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $8bbcff3e9321f949$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $8bbcff3e9321f949$export$6e3a27864ab166fe;
const $8bbcff3e9321f949$var$EXP_TABLE = new Uint8Array(512);
const $8bbcff3e9321f949$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $8bbcff3e9321f949$var$EXP_TABLE[i] = x;
        $8bbcff3e9321f949$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$8bbcff3e9321f949$var$EXP_TABLE[i] = $8bbcff3e9321f949$var$EXP_TABLE[i - 255];
})();
$8bbcff3e9321f949$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $8bbcff3e9321f949$var$LOG_TABLE[n];
};
$8bbcff3e9321f949$export$b310ec824aaee37f = function exp(n) {
    return $8bbcff3e9321f949$var$EXP_TABLE[n];
};
$8bbcff3e9321f949$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $8bbcff3e9321f949$var$EXP_TABLE[$8bbcff3e9321f949$var$LOG_TABLE[x] + $8bbcff3e9321f949$var$LOG_TABLE[y]];
};


$a1eabc4d156beeb3$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $8bbcff3e9321f949$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$a1eabc4d156beeb3$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $8bbcff3e9321f949$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$a1eabc4d156beeb3$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $a1eabc4d156beeb3$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $8bbcff3e9321f949$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $93334cf51ca9c9c3$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $93334cf51ca9c9c3$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $a1eabc4d156beeb3$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $93334cf51ca9c9c3$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $a1eabc4d156beeb3$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$93334cf51ca9c9c3$exports = $93334cf51ca9c9c3$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $ae92eaec358ee6d6$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $ae92eaec358ee6d6$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $ae92eaec358ee6d6$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $ae92eaec358ee6d6$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $57b99d0a6afdc424$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $57b99d0a6afdc424$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $57b99d0a6afdc424$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $57b99d0a6afdc424$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $57b99d0a6afdc424$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $57b99d0a6afdc424$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $dd482bca37708faa$export$1ea939691cdc45b8;
$dd482bca37708faa$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $1ed07c57a1550335$export$a4d452c2363c8e12;
var $1ed07c57a1550335$export$9df7c29d562bab83;
var $1ed07c57a1550335$export$8f4bf8f7eb581284;
var $1ed07c57a1550335$export$4d318981b5a83836;
var $1ed07c57a1550335$export$376a9ed239d6c1c8;
var $1ed07c57a1550335$export$175f16aef75a4569;
var $1ed07c57a1550335$export$50b7f9bf92c74274;
var $1ed07c57a1550335$export$4ba5f52893b4ac97;
const $1ed07c57a1550335$var$numeric = '[0-9]+';
const $1ed07c57a1550335$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $1ed07c57a1550335$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$1ed07c57a1550335$var$kanji = $1ed07c57a1550335$var$kanji.replace(/u/g, '\\u');
const $1ed07c57a1550335$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $1ed07c57a1550335$var$kanji + ')(?:.|[\r\n]))+';
$1ed07c57a1550335$export$a4d452c2363c8e12 = new RegExp($1ed07c57a1550335$var$kanji, 'g');
$1ed07c57a1550335$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$1ed07c57a1550335$export$8f4bf8f7eb581284 = new RegExp($1ed07c57a1550335$var$byte, 'g');
$1ed07c57a1550335$export$4d318981b5a83836 = new RegExp($1ed07c57a1550335$var$numeric, 'g');
$1ed07c57a1550335$export$376a9ed239d6c1c8 = new RegExp($1ed07c57a1550335$var$alphanumeric, 'g');
const $1ed07c57a1550335$var$TEST_KANJI = new RegExp('^' + $1ed07c57a1550335$var$kanji + '$');
const $1ed07c57a1550335$var$TEST_NUMERIC = new RegExp('^' + $1ed07c57a1550335$var$numeric + '$');
const $1ed07c57a1550335$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$1ed07c57a1550335$export$175f16aef75a4569 = function testKanji(str) {
    return $1ed07c57a1550335$var$TEST_KANJI.test(str);
};
$1ed07c57a1550335$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $1ed07c57a1550335$var$TEST_NUMERIC.test(str);
};
$1ed07c57a1550335$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $1ed07c57a1550335$var$TEST_ALPHANUMERIC.test(str);
};


$57b99d0a6afdc424$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$57b99d0a6afdc424$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$57b99d0a6afdc424$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$57b99d0a6afdc424$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$57b99d0a6afdc424$export$bb410559a65d3418 = {
    bit: -1
};
$57b99d0a6afdc424$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$57b99d0a6afdc424$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($1ed07c57a1550335$export$50b7f9bf92c74274(dataStr)) return $57b99d0a6afdc424$export$4d318981b5a83836;
    else if ($1ed07c57a1550335$export$4ba5f52893b4ac97(dataStr)) return $57b99d0a6afdc424$export$376a9ed239d6c1c8;
    else if ($1ed07c57a1550335$export$175f16aef75a4569(dataStr)) return $57b99d0a6afdc424$export$a4d452c2363c8e12;
    else return $57b99d0a6afdc424$export$8f4bf8f7eb581284;
};
$57b99d0a6afdc424$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$57b99d0a6afdc424$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $57b99d0a6afdc424$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $57b99d0a6afdc424$export$4d318981b5a83836;
        case 'alphanumeric':
            return $57b99d0a6afdc424$export$376a9ed239d6c1c8;
        case 'kanji':
            return $57b99d0a6afdc424$export$a4d452c2363c8e12;
        case 'byte':
            return $57b99d0a6afdc424$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$57b99d0a6afdc424$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($57b99d0a6afdc424$export$1ea939691cdc45b8(value)) return value;
    try {
        return $57b99d0a6afdc424$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $ae92eaec358ee6d6$var$G18 = 7973;
const $ae92eaec358ee6d6$var$G18_BCH = $3c0c059760123098$export$ed1d66da50968976($ae92eaec358ee6d6$var$G18);
function $ae92eaec358ee6d6$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $ae92eaec358ee6d6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $ae92eaec358ee6d6$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $57b99d0a6afdc424$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $ae92eaec358ee6d6$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $ae92eaec358ee6d6$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $ae92eaec358ee6d6$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $ae92eaec358ee6d6$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $ae92eaec358ee6d6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $57b99d0a6afdc424$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$ae92eaec358ee6d6$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($dd482bca37708faa$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$ae92eaec358ee6d6$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $57b99d0a6afdc424$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $ae92eaec358ee6d6$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$ae92eaec358ee6d6$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $0d86d6c290a07c1c$export$6788812c4e6611e6(errorCorrectionLevel, $0d86d6c290a07c1c$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $ae92eaec358ee6d6$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $ae92eaec358ee6d6$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$ae92eaec358ee6d6$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$dd482bca37708faa$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($3c0c059760123098$export$ed1d66da50968976(d) - $ae92eaec358ee6d6$var$G18_BCH >= 0)d ^= $ae92eaec358ee6d6$var$G18 << $3c0c059760123098$export$ed1d66da50968976(d) - $ae92eaec358ee6d6$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $f2fabc9649342799$export$eee5438974ef6f0e;

const $f2fabc9649342799$var$G15 = 1335;
const $f2fabc9649342799$var$G15_MASK = 21522;
const $f2fabc9649342799$var$G15_BCH = $3c0c059760123098$export$ed1d66da50968976($f2fabc9649342799$var$G15);
$f2fabc9649342799$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($3c0c059760123098$export$ed1d66da50968976(d) - $f2fabc9649342799$var$G15_BCH >= 0)d ^= $f2fabc9649342799$var$G15 << $3c0c059760123098$export$ed1d66da50968976(d) - $f2fabc9649342799$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $f2fabc9649342799$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $e76504f6730aa999$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $e76504f6730aa999$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $e76504f6730aa999$export$89ab1afb9839589b;

var $9431ccf630768e9c$exports = {};

function $9431ccf630768e9c$var$NumericData(data) {
    this.mode = $57b99d0a6afdc424$export$4d318981b5a83836;
    this.data = data.toString();
}
$9431ccf630768e9c$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$9431ccf630768e9c$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9431ccf630768e9c$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $9431ccf630768e9c$var$NumericData.getBitsLength(this.data.length);
};
$9431ccf630768e9c$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$9431ccf630768e9c$exports = $9431ccf630768e9c$var$NumericData;


var $e1996a7391d2fae7$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $e1996a7391d2fae7$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $e1996a7391d2fae7$var$AlphanumericData(data) {
    this.mode = $57b99d0a6afdc424$export$376a9ed239d6c1c8;
    this.data = data;
}
$e1996a7391d2fae7$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $e1996a7391d2fae7$var$AlphanumericData.getBitsLength(this.data.length);
};
$e1996a7391d2fae7$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($e1996a7391d2fae7$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$e1996a7391d2fae7$exports = $e1996a7391d2fae7$var$AlphanumericData;


var $b086cdb22c772d6f$exports = {};

function $b086cdb22c772d6f$var$ByteData(data) {
    this.mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$b086cdb22c772d6f$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$b086cdb22c772d6f$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b086cdb22c772d6f$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $b086cdb22c772d6f$var$ByteData.getBitsLength(this.data.length);
};
$b086cdb22c772d6f$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$b086cdb22c772d6f$exports = $b086cdb22c772d6f$var$ByteData;


var $9ce94abdf224fcfd$exports = {};


function $9ce94abdf224fcfd$var$KanjiData(data) {
    this.mode = $57b99d0a6afdc424$export$a4d452c2363c8e12;
    this.data = data;
}
$9ce94abdf224fcfd$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$9ce94abdf224fcfd$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9ce94abdf224fcfd$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $9ce94abdf224fcfd$var$KanjiData.getBitsLength(this.data.length);
};
$9ce94abdf224fcfd$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $3c0c059760123098$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$9ce94abdf224fcfd$exports = $9ce94abdf224fcfd$var$KanjiData;




var $66317a2f62ebddf7$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $66317a2f62ebddf7$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $66317a2f62ebddf7$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $66317a2f62ebddf7$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $66317a2f62ebddf7$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $66317a2f62ebddf7$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$66317a2f62ebddf7$exports = $66317a2f62ebddf7$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $e76504f6730aa999$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $e76504f6730aa999$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $e76504f6730aa999$var$getSegmentsFromString(dataStr) {
    const numSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$4d318981b5a83836, $57b99d0a6afdc424$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$376a9ed239d6c1c8, $57b99d0a6afdc424$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($3c0c059760123098$export$ce5b1274f8597fa0()) {
        byteSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$8f4bf8f7eb581284, $57b99d0a6afdc424$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$a4d452c2363c8e12, $57b99d0a6afdc424$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $e76504f6730aa999$var$getSegments($1ed07c57a1550335$export$9df7c29d562bab83, $57b99d0a6afdc424$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $e76504f6730aa999$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return $9431ccf630768e9c$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return $e1996a7391d2fae7$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return $9ce94abdf224fcfd$exports.getBitsLength(length);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
            return $b086cdb22c772d6f$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $e76504f6730aa999$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $e76504f6730aa999$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $57b99d0a6afdc424$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: $e76504f6730aa999$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $57b99d0a6afdc424$export$8f4bf8f7eb581284,
                        length: $e76504f6730aa999$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $e76504f6730aa999$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $e76504f6730aa999$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $e76504f6730aa999$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $e76504f6730aa999$var$getSegmentBitsLength(node.length, node.mode) + 4 + $57b99d0a6afdc424$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $e76504f6730aa999$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $57b99d0a6afdc424$export$1bd4c93ffb42e55e(data);
    mode = $57b99d0a6afdc424$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $57b99d0a6afdc424$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $57b99d0a6afdc424$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $57b99d0a6afdc424$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $57b99d0a6afdc424$export$a4d452c2363c8e12 && !$3c0c059760123098$export$ce5b1274f8597fa0()) mode = $57b99d0a6afdc424$export$8f4bf8f7eb581284;
    switch(mode){
        case $57b99d0a6afdc424$export$4d318981b5a83836:
            return new $9431ccf630768e9c$exports(data);
        case $57b99d0a6afdc424$export$376a9ed239d6c1c8:
            return new $e1996a7391d2fae7$exports(data);
        case $57b99d0a6afdc424$export$a4d452c2363c8e12:
            return new $9ce94abdf224fcfd$exports(data);
        case $57b99d0a6afdc424$export$8f4bf8f7eb581284:
            return new $b086cdb22c772d6f$exports(data);
    }
}
$e76504f6730aa999$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($e76504f6730aa999$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($e76504f6730aa999$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$e76504f6730aa999$export$3004f64547af360e = function fromString(data, version) {
    const segs = $e76504f6730aa999$var$getSegmentsFromString(data, $3c0c059760123098$export$ce5b1274f8597fa0());
    const nodes = $e76504f6730aa999$var$buildNodes(segs);
    const graph = $e76504f6730aa999$var$buildGraph(nodes, version);
    const path = $66317a2f62ebddf7$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $e76504f6730aa999$export$571d59b505e6bb4e($e76504f6730aa999$var$mergeSegments(optimizedSegs));
};
$e76504f6730aa999$export$89ab1afb9839589b = function rawSplit(data) {
    return $e76504f6730aa999$export$571d59b505e6bb4e($e76504f6730aa999$var$getSegmentsFromString(data, $3c0c059760123098$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $0e214d44dead0105$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $96cdee29c4ef344c$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupAlignmentPattern(matrix, version) {
    const pos = $ac0face0132a0e67$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $96cdee29c4ef344c$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $ae92eaec358ee6d6$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $96cdee29c4ef344c$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $f2fabc9649342799$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $96cdee29c4ef344c$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $96cdee29c4ef344c$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $c33b7439ba8b2a6c$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $57b99d0a6afdc424$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $96cdee29c4ef344c$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $96cdee29c4ef344c$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $3c0c059760123098$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $c525c70215eeca0c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $c525c70215eeca0c$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $93334cf51ca9c9c3$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $96cdee29c4ef344c$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $e76504f6730aa999$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $e76504f6730aa999$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $ae92eaec358ee6d6$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $e76504f6730aa999$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $ae92eaec358ee6d6$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $96cdee29c4ef344c$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $3c0c059760123098$export$8d4a06d3facd414b(version);
    const modules = new $5158baa00c8f4fa8$exports(moduleCount);
    // Add function modules
    $96cdee29c4ef344c$var$setupFinderPattern(modules, version);
    $96cdee29c4ef344c$var$setupTimingPattern(modules);
    $96cdee29c4ef344c$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $96cdee29c4ef344c$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $96cdee29c4ef344c$var$setupVersionInfo(modules, version);
    // Add data codewords
    $96cdee29c4ef344c$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $ab013ad757fb013d$export$fe9625aaceb0e563(modules, $96cdee29c4ef344c$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $ab013ad757fb013d$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $96cdee29c4ef344c$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$96cdee29c4ef344c$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $0d86d6c290a07c1c$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $0d86d6c290a07c1c$export$6788812c4e6611e6(options.errorCorrectionLevel, $0d86d6c290a07c1c$export$3a1a48c8f6ef640e);
        version = $ae92eaec358ee6d6$export$6788812c4e6611e6(options.version);
        mask = $ab013ad757fb013d$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $3c0c059760123098$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $96cdee29c4ef344c$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $80d9e22a657d988d$export$b3890eb0ae9dca99;
var $80d9e22a657d988d$export$c3e5526bbaf70a25;
var $861b45120a86cc31$export$d2312e68e1f5ad00;
var $861b45120a86cc31$export$5cdac61cf538712e;
var $861b45120a86cc31$export$c3a1a1f268a8142b;
var $861b45120a86cc31$export$83136f57c739c5f3;
function $861b45120a86cc31$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$861b45120a86cc31$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $861b45120a86cc31$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $861b45120a86cc31$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$861b45120a86cc31$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$861b45120a86cc31$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $861b45120a86cc31$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$861b45120a86cc31$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $861b45120a86cc31$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $80d9e22a657d988d$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $80d9e22a657d988d$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$80d9e22a657d988d$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $80d9e22a657d988d$var$getCanvasElement();
    opts = $861b45120a86cc31$export$d2312e68e1f5ad00(opts);
    const size = $861b45120a86cc31$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $861b45120a86cc31$export$83136f57c739c5f3(image.data, qrData, opts);
    $80d9e22a657d988d$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$80d9e22a657d988d$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $80d9e22a657d988d$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $50025a8fe93b5848$export$b3890eb0ae9dca99;

function $50025a8fe93b5848$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $50025a8fe93b5848$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $50025a8fe93b5848$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $50025a8fe93b5848$var$svgCmd('M', col + margin, 0.5 + row + margin) : $50025a8fe93b5848$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $50025a8fe93b5848$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$50025a8fe93b5848$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $861b45120a86cc31$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $50025a8fe93b5848$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $50025a8fe93b5848$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $50025a8fe93b5848$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $e5d2a3ae662f5d2e$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$38aec60e008fa351$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $96cdee29c4ef344c$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $96cdee29c4ef344c$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$e5d2a3ae662f5d2e$export$185802fd694ee1f5 = $96cdee29c4ef344c$export$185802fd694ee1f5;
$e5d2a3ae662f5d2e$export$f87f6982d1fd4f81 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, $80d9e22a657d988d$export$b3890eb0ae9dca99);
$e5d2a3ae662f5d2e$export$723e4939e5a27c8 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, $80d9e22a657d988d$export$c3e5526bbaf70a25);
$e5d2a3ae662f5d2e$export$f84e8e69fd4488a5 = $e5d2a3ae662f5d2e$var$renderCanvas.bind(null, function(data, _, opts) {
    return $50025a8fe93b5848$export$b3890eb0ae9dca99(data, opts);
});




var $a2E6i = parcelRequire("a2E6i");

var $ar3s2 = parcelRequire("ar3s2");

function $4cd7c25c55fc19e4$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $4cd7c25c55fc19e4$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $4cd7c25c55fc19e4$export$2e9a7bb10257a509;
});
var $4cd7c25c55fc19e4$var$$552a56cc5ff3f479$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $4cd7c25c55fc19e4$export$c7e91f8aec23ae14;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $4cd7c25c55fc19e4$export$b06b4c21253e26e2;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $4cd7c25c55fc19e4$export$4077c0dfbe9c3861;
});
class $4cd7c25c55fc19e4$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $4cd7c25c55fc19e4$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $4cd7c25c55fc19e4$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $ar3s2.delegate)(targetSelector, (event)=>{
            root.removeEventListener('animationend', ended);
            root.removeEventListener('animationcancel', ended);
            resolve(event);
        });
        root.addEventListener('animationend', ended);
        root.addEventListener('animationcancel', ended);
    });
var $4cd7c25c55fc19e4$var$$317b1f21909c74b8$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$317b1f21909c74b8$exports, "component", function() {
    return $4cd7c25c55fc19e4$export$d8556a2a8f973135;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$317b1f21909c74b8$exports, "on", function() {
    return $4cd7c25c55fc19e4$export$af631764ddc44097;
});
const $4cd7c25c55fc19e4$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $4cd7c25c55fc19e4$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return this.shadowRoot || this.internals.shadowRoot || this;
            }
            constructor(){
                var _a;
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.tagName.includes('-') ? this.attachInternals() : undefined
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $2867b35b7a77a433$exports.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !((_a = this.internals) === null || _a === void 0 ? void 0 : _a.shadowRoot)) this.attachShadow(meta);
            }
            async connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $4cd7c25c55fc19e4$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super['connectedCallback']) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                await this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            updateDOM(content) {
                var _a, _b;
                const result = this.renderer.render(content, this.root, meta.renderMode);
                return result instanceof Promise ? result.then((_a = this.updatedCallback) === null || _a === void 0 ? void 0 : _a.bind(this)) : (_b = this.updatedCallback) === null || _b === void 0 ? void 0 : _b.call(this);
            }
            async update() {
                var _a;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $ar3s2.isEmpty)(vNode) ? meta.mode ? (0, $44580a92b304de9d$exports.jsx)("slot", {}) : null : vNode;
                if (!(content != null)) return;
                if (!meta.transitible || typeof document.startViewTransition !== 'function') return this.updateDOM(content);
                const { updateCallbackDone: updateCallbackDone, finished: finished } = document.startViewTransition(()=>this.updateDOM(content));
                try {
                    await finished;
                } catch (_b) {
                    return updateCallbackDone;
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $4cd7c25c55fc19e4$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $4cd7c25c55fc19e4$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $4cd7c25c55fc19e4$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $ar3s2.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $4cd7c25c55fc19e4$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
}
var $4cd7c25c55fc19e4$var$$0c03e47eb1097734$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$0c03e47eb1097734$exports, "observer", function() {
    return $4cd7c25c55fc19e4$export$b6ae1bc530f4c149;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$0c03e47eb1097734$exports, "attribute", function() {
    return $4cd7c25c55fc19e4$export$af4b9a83f4b00434;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$0c03e47eb1097734$exports, "reaction", function() {
    return $4cd7c25c55fc19e4$export$7203b476385689ae;
});
var $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
function $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$wrapFunction(func) {
    const renderer = new (0, $2867b35b7a77a433$exports.DOMRenderer)();
    return (props)=>{
        let tree = func(props), root;
        if (!(0, $2867b35b7a77a433$exports.VNode).isFragment(tree)) {
            const disposer = (0, $a2E6i.autorun)(()=>{
                tree = func(props);
                if (tree && root) renderer.patch((0, $2867b35b7a77a433$exports.VNode).fromDOM(root), tree);
            });
            const { ref: ref } = tree;
            tree.ref = (node)=>{
                if (node) root = node;
                else disposer();
                ref === null || ref === void 0 || ref(node);
            };
        }
        return tree;
    };
}
const $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$reactionMap = new WeakMap();
function $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return $4cd7c25c55fc19e4$export$b06b4c21253e26e2(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { update: update } = Object.getPrototypeOf(this);
                    return new Promise((resolve)=>this.disposers.push((0, $a2E6i.autorun)(()=>update.call(this).then(resolve))));
                }
            });
            Promise.resolve().then(()=>$4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor['observedAttributes'];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $ar3s2.toCamelCase)(name)] = (0, $ar3s2.parseJSON)(value);
            (_a = super['attributeChangedCallback']) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            let value = this[(0, $ar3s2.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === 'object') {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === 'object' ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor['observedAttributes'] || [], reactions = $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $a2E6i.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $a2E6i.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $4cd7c25c55fc19e4$export$b6ae1bc530f4c149(func, _) {
    return (0, $ar3s2.isHTMLElementClass)(func) ? $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$wrapClass(func) : $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$wrapFunction(func);
}
function $4cd7c25c55fc19e4$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor['observedAttributes'], attribute = (0, $ar3s2.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
function $4cd7c25c55fc19e4$export$7203b476385689ae(expression) {
    return (effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $4cd7c25c55fc19e4$var$$0c03e47eb1097734$var$reactionMap.set(this, reactions);
        });
}
var $4cd7c25c55fc19e4$var$$819b340f625a29f4$exports = {};
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $4cd7c25c55fc19e4$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        $4cd7c25c55fc19e4$export$d8556a2a8f973135({
            tagName: 'animation-css'
        }),
        $4cd7c25c55fc19e4$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _playing_extraInitializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(this, _instanceExtraInitializers), $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(this, _type_extraInitializers), $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_initializers, false)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_extraInitializers)
            });
        }
        get type() {
            return $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $ar3s2.importCSS)('https://unpkg.com/animate.css@4/animate.min.css');
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await $4cd7c25c55fc19e4$export$4077c0dfbe9c3861(this, '.animate__animated');
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $44580a92b304de9d$exports.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes('Out') ? (0, $44580a92b304de9d$exports.jsx)((0, $44580a92b304de9d$exports.Fragment), {}) : (0, $44580a92b304de9d$exports.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
            (0, $a2E6i.observable)
        ];
        _playing_decorators = [
            $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
            (0, $a2E6i.observable)
        ];
        _typeChanged_decorators = [
            $4cd7c25c55fc19e4$export$7203b476385689ae(({ type: type })=>type)
        ];
        $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4cd7c25c55fc19e4$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();
$4cd7c25c55fc19e4$var$$parcel$exportWildcard($4cd7c25c55fc19e4$var$$d4436c849e74ae70$exports, $4cd7c25c55fc19e4$var$$819b340f625a29f4$exports);
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$exports, "AsyncCell", function() {
    return $4cd7c25c55fc19e4$export$854a54a999c89982;
});
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $4cd7c25c55fc19e4$export$488013bae63b21da;
});
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $4cd7c25c55fc19e4$export$854a54a999c89982 = (()=>{
    var _AsyncCell_component_accessor_storage, _AsyncCell_delegatedProps_accessor_storage;
    let _classDecorators = [
        $4cd7c25c55fc19e4$export$d8556a2a8f973135({
            tagName: 'async-cell'
        }),
        $4cd7c25c55fc19e4$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _component_decorators;
    let _component_initializers = [];
    let _component_extraInitializers = [];
    let _delegatedProps_decorators;
    let _delegatedProps_initializers = [];
    let _delegatedProps_extraInitializers = [];
    var AsyncCell = _classThis = class extends _classSuper {
        get component() {
            return $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_component_accessor_storage, "f");
        }
        set component(value) {
            $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_component_accessor_storage, value, "f");
        }
        get delegatedProps() {
            return $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_delegatedProps_accessor_storage, "f");
        }
        set delegatedProps(value) {
            $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_delegatedProps_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.load();
        }
        async load() {
            this.component = undefined;
            const Tag = await this.loader();
            this.component = (_a)=>{
                var { children: children } = _a, props = $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__rest(_a, [
                    "children"
                ]);
                return (0, $44580a92b304de9d$exports.jsx)(Tag, Object.assign({}, props, {
                    children: children
                }));
            };
            this.emit('load', this.component);
        }
        render() {
            const { component: Tag, props: props, delegatedProps: delegatedProps } = this;
            const _a = Object.assign(Object.assign({}, props), delegatedProps), { children: children } = _a, data = $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__rest(_a, [
                "children"
            ]);
            return Tag && (0, $44580a92b304de9d$exports.jsx)(Tag, Object.assign({}, data, {
                children: children
            }));
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "loader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AsyncCell_component_accessor_storage.set(this, $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_initializers, void 0));
            _AsyncCell_delegatedProps_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_extraInitializers), $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_initializers, void 0)));
            $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_extraInitializers);
        }
    };
    _AsyncCell_component_accessor_storage = new WeakMap();
    _AsyncCell_delegatedProps_accessor_storage = new WeakMap();
    $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "AsyncCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $a2E6i.observable)
        ];
        _delegatedProps_decorators = [
            (0, $a2E6i.observable)
        ];
        $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _delegatedProps_decorators, {
            kind: "accessor",
            name: "delegatedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"delegatedProps" in obj,
                get: (obj)=>obj.delegatedProps,
                set: (obj, value)=>{
                    obj.delegatedProps = value;
                }
            },
            metadata: _metadata
        }, _delegatedProps_initializers, _delegatedProps_extraInitializers);
        $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AsyncCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4cd7c25c55fc19e4$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AsyncCell = _classThis;
})();
function $4cd7c25c55fc19e4$export$488013bae63b21da(loader) {
    return (props)=>(0, $44580a92b304de9d$exports.jsx)($4cd7c25c55fc19e4$export$854a54a999c89982, {
            delegatedProps: props,
            loader: async ()=>(await loader()).default
        });
}
var $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$exports = {};
$4cd7c25c55fc19e4$var$$parcel$export($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $4cd7c25c55fc19e4$export$2a668e8d088a0667;
});
var $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $4cd7c25c55fc19e4$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _name_extraInitializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _value_extraInitializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _required_extraInitializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _disabled_extraInitializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        let _autofocus_extraInitializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute('value', raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute('value');
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _instanceExtraInitializers), $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_extraInitializers), $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_extraInitializers), $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_extraInitializers), $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set(this, ($4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_extraInitializers), $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_initializers, void 0)));
                $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_extraInitializers);
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $4cd7c25c55fc19e4$export$7203b476385689ae(({ value: value })=>value)
            ];
            _name_decorators = [
                $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _value_decorators = [
                (0, $a2E6i.observable)
            ];
            _required_decorators = [
                $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _disabled_decorators = [
                $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _autofocus_decorators = [
                $4cd7c25c55fc19e4$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $4cd7c25c55fc19e4$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}


var $b64130aeb23d8739$exports = {};
/**
 * vCard
 * @constructor
 * @return {vCard}
 */ function $b64130aeb23d8739$var$vCard() {
    if (!(this instanceof $b64130aeb23d8739$var$vCard)) return new $b64130aeb23d8739$var$vCard();
    /** @type {String} Version number */ this.version = $b64130aeb23d8739$var$vCard.versions[$b64130aeb23d8739$var$vCard.versions.length - 1];
    /** @type {Object} Card data */ this.data = {};
}
/**
 * vCard MIME type
 * @type {String}
 */ $b64130aeb23d8739$var$vCard.mimeType = 'text/vcard';
/**
 * vCard file extension
 * @type {String}
 */ $b64130aeb23d8739$var$vCard.extension = '.vcf';
/**
 * vCard versions
 * @type {Array}
 */ $b64130aeb23d8739$var$vCard.versions = [
    '2.1',
    '3.0',
    '4.0'
];
/**
 * VCF EOL character sequence
 * @type {String}
 */ $b64130aeb23d8739$var$vCard.EOL = '\r\n';

/**
 * Folds a long line according to the RFC 5322.
 * @see http://tools.ietf.org/html/rfc5322#section-2.1.1
 * @param  {String}  input
 * @param  {Number}  maxLength
 * @param  {Boolean} hardWrap
 * @return {String}
 */ $b64130aeb23d8739$var$vCard.foldLine = (parcelRequire("iEIKV"));
/**
 * Normalizes input (cast to string, line folding, whitespace)
 * @param  {String} input
 * @return {String}
 */ $b64130aeb23d8739$var$vCard.normalize = function(input) {
    return (input + '')// Trim whitespace
    .replace(/^[\s\r\n]+|[\s\r\n]+$/g, '')// Trim blank lines
    .replace(/(\r\n)[\x09\x20]?(\r\n)|$/g, '$1')// Unfold folded lines
    .replace(/\r\n[\x20\x09]/g, "");
};
/**
 * Check whether a given version is supported
 * @param  {String} version
 * @return {Boolean}
 */ $b64130aeb23d8739$var$vCard.isSupported = function(version) {
    return /^\d\.\d$/.test(version) && $b64130aeb23d8739$var$vCard.versions.indexOf(version) !== -1;
};
/**
 * Parses a string or buffer into a vCard object
 * @param  {String|Buffer} value
 * @return {Array<vCard>}
 */ $b64130aeb23d8739$var$vCard.parse = function(value) {
    var objects = (value + '').split(/(?=BEGIN\:VCARD)/gi);
    var cards = [];
    for(var i = 0; i < objects.length; i++)cards.push(new $b64130aeb23d8739$var$vCard().parse(objects[i]));
    return cards;
};

/**
 * Parse an array of vcf formatted lines
 * @internal used by `vCard#parse()`
 * @type {Function}
 */ $b64130aeb23d8739$var$vCard.parseLines = (parcelRequire("2KRUh"));
/**
 * Constructs a vCard from jCard data
 * @param  {Array} jcard
 * @return {vCard}
 */ $b64130aeb23d8739$var$vCard.fromJSON = function(jcard) {
    jcard = typeof jcard === 'string' ? JSON.parse(jcard) : jcard;
    if (jcard == null || !Array.isArray(jcard)) return new $b64130aeb23d8739$var$vCard();
    if (!/vcard/i.test(jcard[0])) throw new Error('Object not in jCard format');
    var card = new $b64130aeb23d8739$var$vCard();
    jcard[1].forEach(function(prop) {
        card.addProperty($b64130aeb23d8739$var$vCard.Property.fromJSON(prop));
    });
    return card;
};
/**
 * Format a card object according to the given version
 * @param  {vCard}  card
 * @param  {String} version
 * @return {String}
 */ $b64130aeb23d8739$var$vCard.format = function(card, version) {
    version = version || card.version || $b64130aeb23d8739$var$vCard.versions[$b64130aeb23d8739$var$vCard.versions.length - 1];
    if (!$b64130aeb23d8739$var$vCard.isSupported(version)) throw new Error('Unsupported vCard version "' + version + '"');
    var vcf = [];
    vcf.push('BEGIN:VCARD');
    vcf.push('VERSION:' + version);
    var props = Object.keys(card.data);
    var prop = '';
    for(var i = 0; i < props.length; i++){
        if (props[i] === 'version') continue;
        prop = card.data[props[i]];
        if (Array.isArray(prop)) for(var k = 0; k < prop.length; k++){
            if (prop[k].isEmpty()) continue;
            vcf.push($b64130aeb23d8739$var$vCard.foldLine(prop[k].toString(version), 75));
        }
        else if (!prop.isEmpty()) vcf.push($b64130aeb23d8739$var$vCard.foldLine(prop.toString(version), 75));
    }
    vcf.push('END:VCARD');
    return vcf.join($b64130aeb23d8739$var$vCard.EOL);
};

// vCard Property constructor
$b64130aeb23d8739$var$vCard.Property = (parcelRequire("lXGBn"));
/**
 * vCard prototype
 * @type {Object}
 */ $b64130aeb23d8739$var$vCard.prototype = {
    constructor: $b64130aeb23d8739$var$vCard,
    /**
   * Get a vCard property
   * @param  {String} key
   * @return {Object|Array}
   */ get: function(key) {
        if (this.data[key] == null) return this.data[key];
        if (Array.isArray(this.data[key])) return this.data[key].map(function(prop) {
            return prop.clone();
        });
        else return this.data[key].clone();
    },
    /**
   * Set a vCard property
   * @param {String} key
   * @param {String} value
   * @param {Object} params
   */ set: function(key, value, params) {
        return this.setProperty(new $b64130aeb23d8739$var$vCard.Property(key, value, params));
    },
    /**
   * Add a vCard property
   * @param {String} key
   * @param {String} value
   * @param {Object} params
   */ add: function(key, value, params) {
        var prop = new $b64130aeb23d8739$var$vCard.Property(key, value, params);
        this.addProperty(prop);
        return this;
    },
    /**
   * Set a vCard property from an already
   * constructed vCard.Property
   * @param {vCard.Property} prop
   */ setProperty: function(prop) {
        this.data[prop._field] = prop;
        return this;
    },
    /**
   * Add a vCard property from an already
   * constructed vCard.Property
   * @param {vCard.Property} prop
   */ addProperty: function(prop) {
        var key = prop._field;
        if (Array.isArray(this.data[key])) this.data[key].push(prop);
        else if (this.data[key] != null) this.data[key] = [
            this.data[key],
            prop
        ];
        else this.data[key] = prop;
        return this;
    },
    /**
   * Parse a vcf formatted vCard
   * @param  {String} value
   * @return {vCard}
   */ parse: function(value) {
        // Normalize & split
        var lines = $b64130aeb23d8739$var$vCard.normalize(value).split(/\r\n/g);
        // Keep begin and end markers
        // for eventual error messages
        var begin = lines[0];
        var version = lines[1];
        var end = lines[lines.length - 1];
        // Multiple used RegExp's
        const regexp_version = /VERSION:\d\.\d/i;
        if (!/BEGIN:VCARD/i.test(begin)) throw new SyntaxError('Invalid vCard: Expected "BEGIN:VCARD" but found "' + begin + '"');
        if (!/END:VCARD/i.test(end)) throw new SyntaxError('Invalid vCard: Expected "END:VCARD" but found "' + end + '"');
        if (!regexp_version.test(version)) {
            // VERSION mostly follows BEGIN, but it has only mandatory follow BEGIN, for version 4.0
            // Let's do the more expensive lookup for the lesser used version variant
            if (!(version = lines.find((line)=>regexp_version.test(line)))) throw new SyntaxError('Invalid vCard: Expected "VERSION:\\d.\\d" but none found');
        // TODO: Do we need to throw an error if version = 4.0 or != 3.0|2.1? (because not followed BEGIN)?
        }
        this.version = version.substring(8, 11);
        if (!$b64130aeb23d8739$var$vCard.isSupported(this.version)) throw new Error('Unsupported version "' + this.version + '"');
        this.data = $b64130aeb23d8739$var$vCard.parseLines(lines);
        return this;
    },
    /**
   * Format the vCard as vcf with given version
   * @param  {String} version
   * @param  {String} charset
   * @return {String}
   */ toString: function(version, charset) {
        version = version || this.version;
        return $b64130aeb23d8739$var$vCard.format(this, version);
    },
    /**
   * Format the card as jCard
   * @param {String} version='4.0'
   * @return {Array} jCard
   */ toJCard: function(version) {
        version = version || '4.0';
        var keys = Object.keys(this.data);
        var data = [
            [
                'version',
                {},
                'text',
                version
            ]
        ];
        var prop = null;
        for(var i = 0; i < keys.length; i++){
            if (keys[i] === 'version') continue;
            prop = this.data[keys[i]];
            if (Array.isArray(prop)) for(var k = 0; k < prop.length; k++)data.push(prop[k].toJSON());
            else data.push(prop.toJSON());
        }
        return [
            'vcard',
            data
        ];
    },
    /**
   * Format the card as jCard
   * @return {Array} jCard
   */ toJSON: function() {
        return this.toJCard(this.version);
    }
};
// Exports
$b64130aeb23d8739$exports = $b64130aeb23d8739$var$vCard;


function $5c3171cb4df06a17$export$f0e861b00351cd63(data) {
    const card = new (0, (/*@__PURE__*/$parcel$interopDefault($b64130aeb23d8739$exports)))();
    for (let [name, value] of Object.entries(data)){
        value = value.trim();
        switch(name){
            case 'fn':
                card.set('n', value.replace(/\s+/g, ';'));
                break;
            case 'photo':
            case 'logo':
                if (value) {
                    const type = value.split('.').at(-1);
                    value = `TYPE=${type === 'jpg' ? 'JPEG' : type === null || type === void 0 ? void 0 : type.toUpperCase()};VALUE=URI:${value}`;
                }
        }
        card.set(name, value);
    }
    card.set('rev', new Date().toJSON());
    return card;
}


var $06e3f71f763fe50b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $06e3f71f763fe50b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $06e3f71f763fe50b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $06e3f71f763fe50b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $06e3f71f763fe50b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $06e3f71f763fe50b$export$4fa704fc80ebb5e2 = (()=>{
    var _VCardGenerator_rawData_accessor_storage;
    let _classDecorators = [
        (0, $4cd7c25c55fc19e4$export$d8556a2a8f973135)({
            tagName: 'vcard-generator'
        }),
        (0, $4cd7c25c55fc19e4$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _rawData_decorators;
    let _rawData_initializers = [];
    let _rawData_extraInitializers = [];
    let _get_vCardData_decorators;
    let _renderCanvas_decorators;
    var VCardGenerator = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _VCardGenerator_rawData_accessor_storage.set(this, ($06e3f71f763fe50b$var$__runInitializers(this, _instanceExtraInitializers), $06e3f71f763fe50b$var$__runInitializers(this, _rawData_initializers, {})));
            this.restored = ($06e3f71f763fe50b$var$__runInitializers(this, _rawData_extraInitializers), (0, $ca550f0d6b72e82f$export$db239ef39aadc7fe)(this, 'vCard'));
            this.handleChange = (event)=>{
                event.stopPropagation();
                var { name: name, value: value } = event.target;
                this.rawData = Object.assign(Object.assign({}, this.rawData), {
                    [name]: value.trim()
                });
            };
            this.renderForm = ({ fn: fn, email: email, tel: tel, url: url, photo: photo, title: title, org: org })=>(0, $44580a92b304de9d$exports.jsxs)("form", {
                    className: "d-flex flex-column gap-3 flex-fill",
                    onChange: this.handleChange,
                    children: [
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            name: "fn",
                            label: "Full name",
                            required: true,
                            value: fn
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            type: "email",
                            name: "email",
                            label: "E-mail",
                            required: true,
                            value: email
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            type: "tel",
                            name: "tel",
                            label: "Telephone",
                            value: tel
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            type: "url",
                            name: "url",
                            label: "Web-site",
                            value: url
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            type: "url",
                            name: "photo",
                            label: "Photo",
                            value: photo
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            name: "title",
                            label: "Title",
                            required: true,
                            value: title
                        }),
                        (0, $44580a92b304de9d$exports.jsx)("mdui-text-field", {
                            name: "org",
                            label: "Organization",
                            value: org
                        })
                    ]
                });
        }
        get rawData() {
            return $06e3f71f763fe50b$var$__classPrivateFieldGet(this, _VCardGenerator_rawData_accessor_storage, "f");
        }
        set rawData(value) {
            $06e3f71f763fe50b$var$__classPrivateFieldSet(this, _VCardGenerator_rawData_accessor_storage, value, "f");
        }
        get vCardData() {
            return (0, $5c3171cb4df06a17$export$f0e861b00351cd63)(this.rawData).toString('3.0');
        }
        renderCanvas(vCardData) {
            const canvas = this.querySelector('canvas');
            if (canvas) (0, $e5d2a3ae662f5d2e$export$f87f6982d1fd4f81)(canvas, vCardData);
        }
        render() {
            const { rawData: rawData } = this;
            return (0, $44580a92b304de9d$exports.jsxs)("mdui-card", {
                className: "d-flex flex-wrap flex-sm-nowrap",
                children: [
                    this.renderForm(rawData),
                    (0, $44580a92b304de9d$exports.jsx)("canvas", {})
                ]
            });
        }
    };
    _VCardGenerator_rawData_accessor_storage = new WeakMap();
    $06e3f71f763fe50b$var$__setFunctionName(_classThis, "VCardGenerator");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _rawData_decorators = [
            (0, $ca550f0d6b72e82f$export$9a6132153fba2e0)(),
            (0, $a2E6i.observable)
        ];
        _get_vCardData_decorators = [
            (0, $a2E6i.computed)
        ];
        _renderCanvas_decorators = [
            (0, $4cd7c25c55fc19e4$export$7203b476385689ae)((that)=>that.vCardData)
        ];
        $06e3f71f763fe50b$var$__esDecorate(_classThis, null, _rawData_decorators, {
            kind: "accessor",
            name: "rawData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"rawData" in obj,
                get: (obj)=>obj.rawData,
                set: (obj, value)=>{
                    obj.rawData = value;
                }
            },
            metadata: _metadata
        }, _rawData_initializers, _rawData_extraInitializers);
        $06e3f71f763fe50b$var$__esDecorate(_classThis, null, _get_vCardData_decorators, {
            kind: "getter",
            name: "vCardData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"vCardData" in obj,
                get: (obj)=>obj.vCardData
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $06e3f71f763fe50b$var$__esDecorate(_classThis, null, _renderCanvas_decorators, {
            kind: "method",
            name: "renderCanvas",
            static: false,
            private: false,
            access: {
                has: (obj)=>"renderCanvas" in obj,
                get: (obj)=>obj.renderCanvas
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $06e3f71f763fe50b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        VCardGenerator = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $06e3f71f763fe50b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return VCardGenerator = _classThis;
})();


(0, $a2E6i.configure)({
    enforceActions: 'never'
});
new (0, $2867b35b7a77a433$exports.DOMRenderer)().render(new (0, $2867b35b7a77a433$exports.VNode)({
    tagName: 'vcard-generator'
}));


//# sourceMappingURL=index.90ebefc7.js.map
